import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    postV2AdminAgentChat: build.mutation<
      PostV2AdminAgentChatApiResponse,
      PostV2AdminAgentChatApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/agent/chat`,
        method: "POST",
        body: queryArg.agentChatRequest,
      }),
    }),
    postV2AdminAgentExportPdf: build.mutation<
      PostV2AdminAgentExportPdfApiResponse,
      PostV2AdminAgentExportPdfApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/agent/export/pdf`,
        method: "POST",
        body: queryArg.exportPdfRequest,
      }),
    }),
    getV2AdminAgentSessions: build.query<
      GetV2AdminAgentSessionsApiResponse,
      GetV2AdminAgentSessionsApiArg
    >({
      query: () => ({ url: `/v2/admin/agent/sessions` }),
    }),
    getV2AdminAgentSkills: build.query<
      GetV2AdminAgentSkillsApiResponse,
      GetV2AdminAgentSkillsApiArg
    >({
      query: () => ({ url: `/v2/admin/agent/skills` }),
    }),
    postV2AdminAnalyzeExternalProvider: build.mutation<
      PostV2AdminAnalyzeExternalProviderApiResponse,
      PostV2AdminAnalyzeExternalProviderApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/analyze-external-provider`,
        method: "POST",
        body: queryArg.externalProviderAnalyzeRequest,
      }),
    }),
    postV2AdminAnalyzeProvider: build.mutation<
      PostV2AdminAnalyzeProviderApiResponse,
      PostV2AdminAnalyzeProviderApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/analyze-provider`,
        method: "POST",
        body: queryArg.customerInsightsAnalyzeRequest,
      }),
    }),
    getV2AdminApplicationConfigFeatures: build.query<
      GetV2AdminApplicationConfigFeaturesApiResponse,
      GetV2AdminApplicationConfigFeaturesApiArg
    >({
      query: () => ({ url: `/v2/admin/application-config/features` }),
    }),
    getV2AdminApplicationConfigFeaturesByFeatureNameByOrganization: build.query<
      GetV2AdminApplicationConfigFeaturesByFeatureNameByOrganizationApiResponse,
      GetV2AdminApplicationConfigFeaturesByFeatureNameByOrganizationApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/application-config/features/${queryArg.featureName}/by-organization`,
      }),
    }),
    getV2AdminApplicationConfigFeaturesByFeatureNameStats: build.query<
      GetV2AdminApplicationConfigFeaturesByFeatureNameStatsApiResponse,
      GetV2AdminApplicationConfigFeaturesByFeatureNameStatsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/application-config/features/${queryArg.featureName}/stats`,
      }),
    }),
    getV2AdminApplicationConfigStatsigGates: build.query<
      GetV2AdminApplicationConfigStatsigGatesApiResponse,
      GetV2AdminApplicationConfigStatsigGatesApiArg
    >({
      query: () => ({ url: `/v2/admin/application-config/statsig/gates` }),
    }),
    getV2AdminApplicationConfigStatsigGatesByGateIdOverrides: build.query<
      GetV2AdminApplicationConfigStatsigGatesByGateIdOverridesApiResponse,
      GetV2AdminApplicationConfigStatsigGatesByGateIdOverridesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/application-config/statsig/gates/${queryArg.gateId}/overrides`,
      }),
    }),
    patchV2AdminApplicationConfigStatsigGatesByGateIdOverrides: build.mutation<
      PatchV2AdminApplicationConfigStatsigGatesByGateIdOverridesApiResponse,
      PatchV2AdminApplicationConfigStatsigGatesByGateIdOverridesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/application-config/statsig/gates/${queryArg.gateId}/overrides`,
        method: "PATCH",
        body: queryArg.addGateOverridesRequest,
      }),
    }),
    putV2AdminApplicationConfigStatsigGatesByGateIdOverrides: build.mutation<
      PutV2AdminApplicationConfigStatsigGatesByGateIdOverridesApiResponse,
      PutV2AdminApplicationConfigStatsigGatesByGateIdOverridesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/application-config/statsig/gates/${queryArg.gateId}/overrides`,
        method: "PUT",
        body: queryArg.updateGateOverridesRequest,
      }),
    }),
    postV2AdminApplicationConfigStatsigGatesByGateIdOverridesRemove:
      build.mutation<
        PostV2AdminApplicationConfigStatsigGatesByGateIdOverridesRemoveApiResponse,
        PostV2AdminApplicationConfigStatsigGatesByGateIdOverridesRemoveApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/application-config/statsig/gates/${queryArg.gateId}/overrides/remove`,
          method: "POST",
          body: queryArg.removeGateOverridesRequest,
        }),
      }),
    getV2AdminApplicationConfigStatsigUsersByUserIdGates: build.query<
      GetV2AdminApplicationConfigStatsigUsersByUserIdGatesApiResponse,
      GetV2AdminApplicationConfigStatsigUsersByUserIdGatesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/application-config/statsig/users/${queryArg.userId}/gates`,
      }),
    }),
    postV2AdminAppointmentsMaterialize: build.mutation<
      PostV2AdminAppointmentsMaterializeApiResponse,
      PostV2AdminAppointmentsMaterializeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/appointments/materialize`,
        method: "POST",
        body: queryArg.materializationRequest,
      }),
    }),
    getV2AdminAppointmentsMaterializeByTaskId: build.query<
      GetV2AdminAppointmentsMaterializeByTaskIdApiResponse,
      GetV2AdminAppointmentsMaterializeByTaskIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/appointments/materialize/${queryArg.taskId}`,
      }),
    }),
    getV2AdminAppointmentsByAppointmentId: build.query<
      GetV2AdminAppointmentsByAppointmentIdApiResponse,
      GetV2AdminAppointmentsByAppointmentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/appointments/${queryArg.appointmentId}`,
      }),
    }),
    getV2AdminBillingDashboardOrganizations: build.query<
      GetV2AdminBillingDashboardOrganizationsApiResponse,
      GetV2AdminBillingDashboardOrganizationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/billing/dashboard/organizations`,
        params: {
          search: queryArg.search,
          sort_by: queryArg.sortBy,
          sort_dir: queryArg.sortDir,
          page: queryArg.page,
          per_page: queryArg.perPage,
        },
      }),
    }),
    getV2AdminBillingDashboardOrganizationsByOrganizationId: build.query<
      GetV2AdminBillingDashboardOrganizationsByOrganizationIdApiResponse,
      GetV2AdminBillingDashboardOrganizationsByOrganizationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/billing/dashboard/organizations/${queryArg.organizationId}`,
      }),
    }),
    postV2AdminBulkAnalyzeProviders: build.mutation<
      PostV2AdminBulkAnalyzeProvidersApiResponse,
      PostV2AdminBulkAnalyzeProvidersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/bulk-analyze-providers`,
        method: "POST",
        body: queryArg.customerInsightsBulkAnalyzeRequest,
      }),
    }),
    getV2AdminBundleAssignments: build.query<
      GetV2AdminBundleAssignmentsApiResponse,
      GetV2AdminBundleAssignmentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/bundle-assignments`,
        params: {
          organization_id: queryArg.organizationId,
          user_id: queryArg.userId,
          status: queryArg.status,
        },
      }),
    }),
    postV2AdminBundleAssignments: build.mutation<
      PostV2AdminBundleAssignmentsApiResponse,
      PostV2AdminBundleAssignmentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/bundle-assignments`,
        method: "POST",
        body: queryArg.createAssignmentRequest,
      }),
    }),
    postV2AdminBundleAssignmentsOrganizationsByOrganizationIdSyncBundles:
      build.mutation<
        PostV2AdminBundleAssignmentsOrganizationsByOrganizationIdSyncBundlesApiResponse,
        PostV2AdminBundleAssignmentsOrganizationsByOrganizationIdSyncBundlesApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/bundle-assignments/organizations/${queryArg.organizationId}/sync-bundles`,
          method: "POST",
        }),
      }),
    getV2AdminBundleAssignmentsByAssignmentId: build.query<
      GetV2AdminBundleAssignmentsByAssignmentIdApiResponse,
      GetV2AdminBundleAssignmentsByAssignmentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/bundle-assignments/${queryArg.assignmentId}`,
      }),
    }),
    postV2AdminBundleAssignmentsByAssignmentIdReplace: build.mutation<
      PostV2AdminBundleAssignmentsByAssignmentIdReplaceApiResponse,
      PostV2AdminBundleAssignmentsByAssignmentIdReplaceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/bundle-assignments/${queryArg.assignmentId}/replace`,
        method: "POST",
        body: queryArg.replaceBundleRequest,
      }),
    }),
    putV2AdminBundleAssignmentsByAssignmentIdStatus: build.mutation<
      PutV2AdminBundleAssignmentsByAssignmentIdStatusApiResponse,
      PutV2AdminBundleAssignmentsByAssignmentIdStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/bundle-assignments/${queryArg.assignmentId}/status`,
        method: "PUT",
        body: queryArg.updateAssignmentStatusRequest,
      }),
    }),
    getV2AdminBundles: build.query<
      GetV2AdminBundlesApiResponse,
      GetV2AdminBundlesApiArg
    >({
      query: () => ({ url: `/v2/admin/bundles` }),
    }),
    getV2AdminBundlesByBundleId: build.query<
      GetV2AdminBundlesByBundleIdApiResponse,
      GetV2AdminBundlesByBundleIdApiArg
    >({
      query: (queryArg) => ({ url: `/v2/admin/bundles/${queryArg.bundleId}` }),
    }),
    getV2AdminBundlesByBundleIdAssignments: build.query<
      GetV2AdminBundlesByBundleIdAssignmentsApiResponse,
      GetV2AdminBundlesByBundleIdAssignmentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/bundles/${queryArg.bundleId}/assignments`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          status: queryArg.status,
        },
      }),
    }),
    postV2AdminCanonicalServiceTypesSeed: build.mutation<
      PostV2AdminCanonicalServiceTypesSeedApiResponse,
      PostV2AdminCanonicalServiceTypesSeedApiArg
    >({
      query: () => ({
        url: `/v2/admin/canonical-service-types/seed`,
        method: "POST",
      }),
    }),
    deleteV2AdminCanonicalServiceTypesBySlug: build.mutation<
      DeleteV2AdminCanonicalServiceTypesBySlugApiResponse,
      DeleteV2AdminCanonicalServiceTypesBySlugApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/canonical-service-types/${queryArg.slug}`,
        method: "DELETE",
      }),
    }),
    getV2AdminCapabilities: build.query<
      GetV2AdminCapabilitiesApiResponse,
      GetV2AdminCapabilitiesApiArg
    >({
      query: () => ({ url: `/v2/admin/capabilities` }),
    }),
    getV2AdminCapabilitiesByCapabilityId: build.query<
      GetV2AdminCapabilitiesByCapabilityIdApiResponse,
      GetV2AdminCapabilitiesByCapabilityIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/capabilities/${queryArg.capabilityId}`,
      }),
    }),
    postV2AdminChatbotConversationsInitiate: build.mutation<
      PostV2AdminChatbotConversationsInitiateApiResponse,
      PostV2AdminChatbotConversationsInitiateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/chatbot-conversations/initiate`,
        method: "POST",
        body: queryArg.initiateConversationRequest,
      }),
    }),
    postV2AdminClaimRulesSeed: build.mutation<
      PostV2AdminClaimRulesSeedApiResponse,
      PostV2AdminClaimRulesSeedApiArg
    >({
      query: () => ({ url: `/v2/admin/claim-rules/seed`, method: "POST" }),
    }),
    getV2AdminClaimsByClaimIdReadiness: build.query<
      GetV2AdminClaimsByClaimIdReadinessApiResponse,
      GetV2AdminClaimsByClaimIdReadinessApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/claims/${queryArg.claimId}/readiness`,
      }),
    }),
    listOrganizationImportSessions: build.query<
      ListOrganizationImportSessionsApiResponse,
      ListOrganizationImportSessionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/organizations/${queryArg.organizationId}/import-sessions`,
      }),
    }),
    mergeMultiplePatients: build.mutation<
      MergeMultiplePatientsApiResponse,
      MergeMultiplePatientsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/patients/merge-multiple`,
        method: "POST",
        body: queryArg.mergeMultiplePatientsRequest,
      }),
    }),
    deleteImportSession: build.mutation<
      DeleteImportSessionApiResponse,
      DeleteImportSessionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}`,
        method: "DELETE",
      }),
    }),
    getImportSessionStatus: build.query<
      GetImportSessionStatusApiResponse,
      GetImportSessionStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}`,
      }),
    }),
    exportImportResults: build.query<
      ExportImportResultsApiResponse,
      ExportImportResultsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}/export`,
      }),
    }),
    importSelectedPatients: build.mutation<
      ImportSelectedPatientsApiResponse,
      ImportSelectedPatientsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}/import`,
        method: "POST",
        body: queryArg.extractedPatientsRequest,
      }),
    }),
    listImportOperations: build.query<
      ListImportOperationsApiResponse,
      ListImportOperationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}/import-operations`,
      }),
    }),
    getImportOperationStatus: build.query<
      GetImportOperationStatusApiResponse,
      GetImportOperationStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}/import-operations/${queryArg.operationId}`,
      }),
    }),
    importUnmatchedPatients: build.mutation<
      ImportUnmatchedPatientsApiResponse,
      ImportUnmatchedPatientsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}/import-unmatched`,
        method: "POST",
        body: queryArg.importUnmatchedRequest,
      }),
    }),
    getMatchedPatients: build.query<
      GetMatchedPatientsApiResponse,
      GetMatchedPatientsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}/matched-patients`,
        params: {
          limit: queryArg.limit,
          offset: queryArg.offset,
          status: queryArg.status,
        },
      }),
    }),
    bulkUpdatePatientStatus: build.mutation<
      BulkUpdatePatientStatusApiResponse,
      BulkUpdatePatientStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}/patients`,
        method: "PATCH",
        body: queryArg.bulkUpdateStatusRequest,
      }),
    }),
    rejectPatients: build.mutation<
      RejectPatientsApiResponse,
      RejectPatientsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}/reject`,
        method: "POST",
        body: queryArg.rejectPatientsRequest,
      }),
    }),
    uploadImportFile: build.mutation<
      UploadImportFileApiResponse,
      UploadImportFileApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/upload`,
        method: "POST",
        body: queryArg.importUploadFormData,
      }),
    }),
    getV2AdminDocuments: build.query<
      GetV2AdminDocumentsApiResponse,
      GetV2AdminDocumentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/documents`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          document_type: queryArg.documentType,
          organization_id: queryArg.organizationId,
          patient_id: queryArg.patientId,
          include_deleted: queryArg.includeDeleted,
          start_date: queryArg.startDate,
          end_date: queryArg.endDate,
          search: queryArg.search,
          sort_by: queryArg.sortBy,
          sort_order: queryArg.sortOrder,
        },
      }),
    }),
    getV2AdminDocumentsByDocumentId: build.query<
      GetV2AdminDocumentsByDocumentIdApiResponse,
      GetV2AdminDocumentsByDocumentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/documents/${queryArg.documentId}`,
      }),
    }),
    getV2AdminEligibility: build.query<
      GetV2AdminEligibilityApiResponse,
      GetV2AdminEligibilityApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/eligibility`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          sort_by: queryArg.sortBy,
          sort_order: queryArg.sortOrder,
          next_action_owner: queryArg.nextActionOwner,
          status: queryArg.status,
          next_action: queryArg.nextAction,
        },
      }),
    }),
    postV2AdminEligibilityByEligibilityIdOverride: build.mutation<
      PostV2AdminEligibilityByEligibilityIdOverrideApiResponse,
      PostV2AdminEligibilityByEligibilityIdOverrideApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/eligibility/${queryArg.eligibilityId}/override`,
        method: "POST",
        body: queryArg.manualUpdateRequest,
      }),
    }),
    postV2AdminEncountersStartProcessing: build.mutation<
      PostV2AdminEncountersStartProcessingApiResponse,
      PostV2AdminEncountersStartProcessingApiArg
    >({
      query: () => ({
        url: `/v2/admin/encounters/start-processing`,
        method: "POST",
      }),
    }),
    getV2AdminEncountersTelemetryAnalytics: build.query<
      GetV2AdminEncountersTelemetryAnalyticsApiResponse,
      GetV2AdminEncountersTelemetryAnalyticsApiArg
    >({
      query: () => ({ url: `/v2/admin/encounters/telemetry/analytics` }),
    }),
    getV2AdminEncountersTelemetrySessions: build.query<
      GetV2AdminEncountersTelemetrySessionsApiResponse,
      GetV2AdminEncountersTelemetrySessionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/encounters/telemetry/sessions`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          organization_id: queryArg.organizationId,
          user_id: queryArg.userId,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          sort_by: queryArg.sortBy,
          sort_order: queryArg.sortOrder,
        },
      }),
    }),
    getV2AdminEncountersByEncounterId: build.query<
      GetV2AdminEncountersByEncounterIdApiResponse,
      GetV2AdminEncountersByEncounterIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/encounters/${queryArg.encounterId}`,
      }),
    }),
    getV2AdminEntitlements: build.query<
      GetV2AdminEntitlementsApiResponse,
      GetV2AdminEntitlementsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/entitlements`,
        params: {
          organization_id: queryArg.organizationId,
          user_id: queryArg.userId,
        },
      }),
    }),
    deleteV2AdminEntitlementsUsage: build.mutation<
      DeleteV2AdminEntitlementsUsageApiResponse,
      DeleteV2AdminEntitlementsUsageApiArg
    >({
      query: () => ({ url: `/v2/admin/entitlements/usage`, method: "DELETE" }),
    }),
    getV2AdminEntitlementsUsage: build.query<
      GetV2AdminEntitlementsUsageApiResponse,
      GetV2AdminEntitlementsUsageApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/entitlements/usage`,
        params: {
          organization_id: queryArg.organizationId,
          user_id: queryArg.userId,
          capability_id: queryArg.capabilityId,
          usage_period: queryArg.usagePeriod,
          page: queryArg.page,
          per_page: queryArg.perPage,
        },
      }),
    }),
    postV2AdminEntitlementsUsageEmit: build.mutation<
      PostV2AdminEntitlementsUsageEmitApiResponse,
      PostV2AdminEntitlementsUsageEmitApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/entitlements/usage/emit`,
        method: "POST",
        body: queryArg.emitTestUsageRequest,
      }),
    }),
    getV2AdminEventRegistryEvents: build.query<
      GetV2AdminEventRegistryEventsApiResponse,
      GetV2AdminEventRegistryEventsApiArg
    >({
      query: () => ({ url: `/v2/admin/event-registry/events` }),
    }),
    getV2AdminFeedbackSessions: build.query<
      GetV2AdminFeedbackSessionsApiResponse,
      GetV2AdminFeedbackSessionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/feedback-sessions`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          user_id: queryArg.userId,
          organization_id: queryArg.organizationId,
          note_id: queryArg.noteId,
          module_id: queryArg.moduleId,
          start_date: queryArg.startDate,
          end_date: queryArg.endDate,
        },
      }),
    }),
    getV2AdminFeedbackSessionsByNoteByNoteId: build.query<
      GetV2AdminFeedbackSessionsByNoteByNoteIdApiResponse,
      GetV2AdminFeedbackSessionsByNoteByNoteIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/feedback-sessions/by-note/${queryArg.noteId}`,
      }),
    }),
    deleteV2AdminFeedbackSessionsBySessionId: build.mutation<
      DeleteV2AdminFeedbackSessionsBySessionIdApiResponse,
      DeleteV2AdminFeedbackSessionsBySessionIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/feedback-sessions/${queryArg.sessionId}`,
        method: "DELETE",
      }),
    }),
    getV2AdminFeedbackSessionsBySessionId: build.query<
      GetV2AdminFeedbackSessionsBySessionIdApiResponse,
      GetV2AdminFeedbackSessionsBySessionIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/feedback-sessions/${queryArg.sessionId}`,
      }),
    }),
    postV2AdminFormsCreate: build.mutation<
      PostV2AdminFormsCreateApiResponse,
      PostV2AdminFormsCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/forms/create`,
        method: "POST",
        body: queryArg.adminCreateFormRequest,
      }),
    }),
    getV2AdminJotauditDashboardEncounters: build.query<
      GetV2AdminJotauditDashboardEncountersApiResponse,
      GetV2AdminJotauditDashboardEncountersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/jotaudit/dashboard/encounters`,
        params: {
          days: queryArg.days,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          user_ids: queryArg.userIds,
          has_audit: queryArg.hasAudit,
          page: queryArg.page,
          per_page: queryArg.perPage,
          organization_id: queryArg.organizationId,
        },
      }),
    }),
    getV2AdminJotauditDashboardEncountersByEncounterId: build.query<
      GetV2AdminJotauditDashboardEncountersByEncounterIdApiResponse,
      GetV2AdminJotauditDashboardEncountersByEncounterIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/jotaudit/dashboard/encounters/${queryArg.encounterId}`,
        params: {
          organization_id: queryArg.organizationId,
        },
      }),
    }),
    getV2AdminJotauditDashboardNotes: build.query<
      GetV2AdminJotauditDashboardNotesApiResponse,
      GetV2AdminJotauditDashboardNotesApiArg
    >({
      query: () => ({ url: `/v2/admin/jotaudit/dashboard/notes` }),
    }),
    getV2AdminJotauditDashboardNotesDetailByOrganizationIdAndNoteId:
      build.query<
        GetV2AdminJotauditDashboardNotesDetailByOrganizationIdAndNoteIdApiResponse,
        GetV2AdminJotauditDashboardNotesDetailByOrganizationIdAndNoteIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/jotaudit/dashboard/notes/detail/${queryArg.organizationId}/${queryArg.noteId}`,
        }),
      }),
    getV2AdminJotauditDashboardNotesDetailByOrganizationIdAndNoteIdHistory:
      build.query<
        GetV2AdminJotauditDashboardNotesDetailByOrganizationIdAndNoteIdHistoryApiResponse,
        GetV2AdminJotauditDashboardNotesDetailByOrganizationIdAndNoteIdHistoryApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/jotaudit/dashboard/notes/detail/${queryArg.organizationId}/${queryArg.noteId}/history`,
        }),
      }),
    getV2AdminJotauditDashboardNotesDetailByOrganizationIdAndNoteIdRevisionsRevision:
      build.query<
        GetV2AdminJotauditDashboardNotesDetailByOrganizationIdAndNoteIdRevisionsRevisionApiResponse,
        GetV2AdminJotauditDashboardNotesDetailByOrganizationIdAndNoteIdRevisionsRevisionApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/jotaudit/dashboard/notes/detail/${queryArg.organizationId}/${queryArg.noteId}/revisions/${queryArg.revision}`,
        }),
      }),
    getV2AdminJotauditDashboardNotesByOrganizationId: build.query<
      GetV2AdminJotauditDashboardNotesByOrganizationIdApiResponse,
      GetV2AdminJotauditDashboardNotesByOrganizationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/jotaudit/dashboard/notes/${queryArg.organizationId}`,
        params: {
          days: queryArg.days,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          user_ids: queryArg.userIds,
          page: queryArg.page,
          per_page: queryArg.perPage,
          min_quality_score: queryArg.minQualityScore,
          max_quality_score: queryArg.maxQualityScore,
          cpt_mismatch_only: queryArg.cptMismatchOnly,
          is_completed: queryArg.isCompleted,
        },
      }),
    }),
    getV2AdminJotauditDashboardOrganizations: build.query<
      GetV2AdminJotauditDashboardOrganizationsApiResponse,
      GetV2AdminJotauditDashboardOrganizationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/jotaudit/dashboard/organizations`,
        params: {
          search: queryArg.search,
          page: queryArg.page,
          per_page: queryArg.perPage,
        },
      }),
    }),
    getV2AdminJotauditDashboardProviders: build.query<
      GetV2AdminJotauditDashboardProvidersApiResponse,
      GetV2AdminJotauditDashboardProvidersApiArg
    >({
      query: () => ({ url: `/v2/admin/jotaudit/dashboard/providers` }),
    }),
    getV2AdminJotauditDashboardProvidersByOrganizationId: build.query<
      GetV2AdminJotauditDashboardProvidersByOrganizationIdApiResponse,
      GetV2AdminJotauditDashboardProvidersByOrganizationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/jotaudit/dashboard/providers/${queryArg.organizationId}`,
        params: {
          days: queryArg.days,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          user_ids: queryArg.userIds,
        },
      }),
    }),
    getV2AdminJotauditDashboardProvidersByOrganizationIdAndUserId: build.query<
      GetV2AdminJotauditDashboardProvidersByOrganizationIdAndUserIdApiResponse,
      GetV2AdminJotauditDashboardProvidersByOrganizationIdAndUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/jotaudit/dashboard/providers/${queryArg.organizationId}/${queryArg.userId}`,
        params: {
          days: queryArg.days,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          user_ids: queryArg.userIds,
        },
      }),
    }),
    getV2AdminJotauditDashboardRulesComplianceStatsByOrganizationId:
      build.query<
        GetV2AdminJotauditDashboardRulesComplianceStatsByOrganizationIdApiResponse,
        GetV2AdminJotauditDashboardRulesComplianceStatsByOrganizationIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/jotaudit/dashboard/rules/compliance-stats/${queryArg.organizationId}`,
          params: {
            days: queryArg.days,
            date_from: queryArg.dateFrom,
            date_to: queryArg.dateTo,
            user_ids: queryArg.userIds,
            rule_ids: queryArg.ruleIds,
            comparison_mode: queryArg.comparisonMode,
          },
        }),
      }),
    getV2AdminJotauditDashboardRulesByRuleIdAuditsDrilldownAndOrganizationId:
      build.query<
        GetV2AdminJotauditDashboardRulesByRuleIdAuditsDrilldownAndOrganizationIdApiResponse,
        GetV2AdminJotauditDashboardRulesByRuleIdAuditsDrilldownAndOrganizationIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/jotaudit/dashboard/rules/${queryArg.ruleId}/audits/drilldown/${queryArg.organizationId}`,
          params: {
            compliance_status: queryArg.complianceStatus,
            days: queryArg.days,
            date_from: queryArg.dateFrom,
            date_to: queryArg.dateTo,
            user_ids: queryArg.userIds,
            page: queryArg.page,
            per_page: queryArg.perPage,
          },
        }),
      }),
    getV2AdminJotauditDashboardRulesByRuleIdAuditsAndOrganizationId:
      build.query<
        GetV2AdminJotauditDashboardRulesByRuleIdAuditsAndOrganizationIdApiResponse,
        GetV2AdminJotauditDashboardRulesByRuleIdAuditsAndOrganizationIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/jotaudit/dashboard/rules/${queryArg.pathRuleId}/audits/${queryArg.organizationId}`,
          params: {
            rule_id: queryArg.queryRuleId,
            page: queryArg.page,
            per_page: queryArg.perPage,
          },
        }),
      }),
    getV2AdminJotauditDashboardRulesByRuleIdStatsAndOrganizationId: build.query<
      GetV2AdminJotauditDashboardRulesByRuleIdStatsAndOrganizationIdApiResponse,
      GetV2AdminJotauditDashboardRulesByRuleIdStatsAndOrganizationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/jotaudit/dashboard/rules/${queryArg.ruleId}/stats/${queryArg.organizationId}`,
        params: {
          days: queryArg.days,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          user_ids: queryArg.userIds,
        },
      }),
    }),
    getV2AdminJotauditDashboardStats: build.query<
      GetV2AdminJotauditDashboardStatsApiResponse,
      GetV2AdminJotauditDashboardStatsApiArg
    >({
      query: () => ({ url: `/v2/admin/jotaudit/dashboard/stats` }),
    }),
    getV2AdminJotauditDashboardStatsByOrganizationId: build.query<
      GetV2AdminJotauditDashboardStatsByOrganizationIdApiResponse,
      GetV2AdminJotauditDashboardStatsByOrganizationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/jotaudit/dashboard/stats/${queryArg.organizationId}`,
        params: {
          days: queryArg.days,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          user_ids: queryArg.userIds,
        },
      }),
    }),
    postV2AdminJotauditRun: build.mutation<
      PostV2AdminJotauditRunApiResponse,
      PostV2AdminJotauditRunApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/jotaudit/run`,
        method: "POST",
        body: queryArg.runAuditRequest,
      }),
    }),
    getV2AdminJotauditStatusByThreadId: build.query<
      GetV2AdminJotauditStatusByThreadIdApiResponse,
      GetV2AdminJotauditStatusByThreadIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/jotaudit/status/${queryArg.threadId}`,
      }),
    }),
    putV2AdminJotcredOrganizationsByOrganizationIdProvidersAndUserIdActions:
      build.mutation<
        PutV2AdminJotcredOrganizationsByOrganizationIdProvidersAndUserIdActionsApiResponse,
        PutV2AdminJotcredOrganizationsByOrganizationIdProvidersAndUserIdActionsApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/jotcred/organizations/${queryArg.organizationId}/providers/${queryArg.userId}/actions`,
          method: "PUT",
          body: queryArg.setActionItemsRequest,
        }),
      }),
    putV2AdminJotcredOrganizationsByOrganizationIdProvidersAndUserIdApplicationsAppId:
      build.mutation<
        PutV2AdminJotcredOrganizationsByOrganizationIdProvidersAndUserIdApplicationsAppIdApiResponse,
        PutV2AdminJotcredOrganizationsByOrganizationIdProvidersAndUserIdApplicationsAppIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/jotcred/organizations/${queryArg.organizationId}/providers/${queryArg.userId}/applications/${queryArg.appId}`,
          method: "PUT",
          body: queryArg.updatePayerApplicationRequest,
        }),
      }),
    getV2AdminLearningRules: build.query<
      GetV2AdminLearningRulesApiResponse,
      GetV2AdminLearningRulesApiArg
    >({
      query: () => ({ url: `/v2/admin/learning-rules` }),
    }),
    postV2AdminLearningRules: build.mutation<
      PostV2AdminLearningRulesApiResponse,
      PostV2AdminLearningRulesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/learning-rules`,
        method: "POST",
        body: queryArg.createLearningRuleRequest,
      }),
    }),
    postV2AdminLearningRulesSearch: build.mutation<
      PostV2AdminLearningRulesSearchApiResponse,
      PostV2AdminLearningRulesSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/learning-rules/search`,
        method: "POST",
        body: queryArg.learningRuleSearchRequest,
      }),
    }),
    deleteV2AdminLearningRulesByRuleId: build.mutation<
      DeleteV2AdminLearningRulesByRuleIdApiResponse,
      DeleteV2AdminLearningRulesByRuleIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/learning-rules/${queryArg.ruleId}`,
        method: "DELETE",
      }),
    }),
    getV2AdminLearningRulesByRuleId: build.query<
      GetV2AdminLearningRulesByRuleIdApiResponse,
      GetV2AdminLearningRulesByRuleIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/learning-rules/${queryArg.ruleId}`,
      }),
    }),
    putV2AdminLearningRulesByRuleId: build.mutation<
      PutV2AdminLearningRulesByRuleIdApiResponse,
      PutV2AdminLearningRulesByRuleIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/learning-rules/${queryArg.ruleId}`,
        method: "PUT",
        body: queryArg.updateLearningRuleRequest,
      }),
    }),
    postV2AdminNoteProcessingRecoveryErroredSessions: build.mutation<
      PostV2AdminNoteProcessingRecoveryErroredSessionsApiResponse,
      PostV2AdminNoteProcessingRecoveryErroredSessionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/note-processing-recovery/errored-sessions`,
        method: "POST",
        body: queryArg.recoveryTaskRequest,
      }),
    }),
    postV2AdminNoteProcessingRecoveryStuckTranscriptions: build.mutation<
      PostV2AdminNoteProcessingRecoveryStuckTranscriptionsApiResponse,
      PostV2AdminNoteProcessingRecoveryStuckTranscriptionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/note-processing-recovery/stuck-transcriptions`,
        method: "POST",
        body: queryArg.recoveryTaskRequest,
      }),
    }),
    getV2AdminNoteProcessingSessionsBySessionId: build.query<
      GetV2AdminNoteProcessingSessionsBySessionIdApiResponse,
      GetV2AdminNoteProcessingSessionsBySessionIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/note-processing-sessions/${queryArg.sessionId}`,
      }),
    }),
    postV2AdminNoteProcessingWorkflowsEncounterNoteFromV2Template:
      build.mutation<
        PostV2AdminNoteProcessingWorkflowsEncounterNoteFromV2TemplateApiResponse,
        PostV2AdminNoteProcessingWorkflowsEncounterNoteFromV2TemplateApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/note-processing-workflows/encounter-note-from-v2-template`,
          method: "POST",
          body: queryArg.encounterNoteGenerationRequest,
        }),
      }),
    getV2AdminNoteProcessingWorkflowsStatusByTaskId: build.query<
      GetV2AdminNoteProcessingWorkflowsStatusByTaskIdApiResponse,
      GetV2AdminNoteProcessingWorkflowsStatusByTaskIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/note-processing-workflows/status/${queryArg.taskId}`,
      }),
    }),
    postV2AdminNotesWorkflowsEditNote: build.mutation<
      PostV2AdminNotesWorkflowsEditNoteApiResponse,
      PostV2AdminNotesWorkflowsEditNoteApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notes-workflows/edit-note`,
        method: "POST",
        body: queryArg.editNoteRequest,
      }),
    }),
    getV2AdminNotesWorkflowsStatusByTaskId: build.query<
      GetV2AdminNotesWorkflowsStatusByTaskIdApiResponse,
      GetV2AdminNotesWorkflowsStatusByTaskIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notes-workflows/status/${queryArg.taskId}`,
      }),
    }),
    getV2AdminNotesByNoteId: build.query<
      GetV2AdminNotesByNoteIdApiResponse,
      GetV2AdminNotesByNoteIdApiArg
    >({
      query: (queryArg) => ({ url: `/v2/admin/notes/${queryArg.noteId}` }),
    }),
    postV2AdminNotesByNoteIdGeneratePdf: build.mutation<
      PostV2AdminNotesByNoteIdGeneratePdfApiResponse,
      PostV2AdminNotesByNoteIdGeneratePdfApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notes/${queryArg.noteId}/generate-pdf`,
        method: "POST",
      }),
    }),
    getV2AdminNotetemplates: build.query<
      GetV2AdminNotetemplatesApiResponse,
      GetV2AdminNotetemplatesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates`,
        params: {
          scope: queryArg.scope,
          limit: queryArg.limit,
          offset: queryArg.offset,
        },
      }),
    }),
    postV2AdminNotetemplatesApplyFeedback: build.mutation<
      PostV2AdminNotetemplatesApplyFeedbackApiResponse,
      PostV2AdminNotetemplatesApplyFeedbackApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates/apply-feedback`,
        method: "POST",
        body: queryArg.applyFeedbackToTemplateRequest,
      }),
    }),
    postV2AdminNotetemplatesBuildFromTemplate: build.mutation<
      PostV2AdminNotetemplatesBuildFromTemplateApiResponse,
      PostV2AdminNotetemplatesBuildFromTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates/build/from-template`,
        method: "POST",
        body: queryArg.adminTemplateBuildFromTemplateRequest,
      }),
    }),
    postV2AdminNotetemplatesBuildByTaskIdSave: build.mutation<
      PostV2AdminNotetemplatesBuildByTaskIdSaveApiResponse,
      PostV2AdminNotetemplatesBuildByTaskIdSaveApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates/build/${queryArg.taskId}/save`,
        method: "POST",
      }),
    }),
    getV2AdminNotetemplatesBuildByTaskIdStatus: build.query<
      GetV2AdminNotetemplatesBuildByTaskIdStatusApiResponse,
      GetV2AdminNotetemplatesBuildByTaskIdStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates/build/${queryArg.taskId}/status`,
      }),
    }),
    postV2AdminNotetemplatesConvertToOrg: build.mutation<
      PostV2AdminNotetemplatesConvertToOrgApiResponse,
      PostV2AdminNotetemplatesConvertToOrgApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates/convert-to-org`,
        method: "POST",
        body: queryArg.adminConvertToOrgRequest,
      }),
    }),
    postV2AdminNotetemplatesCopy: build.mutation<
      PostV2AdminNotetemplatesCopyApiResponse,
      PostV2AdminNotetemplatesCopyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates/copy`,
        method: "POST",
        body: queryArg.adminCopyNoteTemplateRequest,
      }),
    }),
    postV2AdminNotetemplatesForkForUser: build.mutation<
      PostV2AdminNotetemplatesForkForUserApiResponse,
      PostV2AdminNotetemplatesForkForUserApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates/fork-for-user`,
        method: "POST",
        body: queryArg.adminForkTemplateForUserRequest,
      }),
    }),
    postV2AdminNotetemplatesModelConversionCopyToNew: build.mutation<
      PostV2AdminNotetemplatesModelConversionCopyToNewApiResponse,
      PostV2AdminNotetemplatesModelConversionCopyToNewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates/model-conversion/copy-to-new`,
        method: "POST",
        body: queryArg.copyToNewTemplateRequest,
      }),
    }),
    postV2AdminNotetemplatesModelConversionSave: build.mutation<
      PostV2AdminNotetemplatesModelConversionSaveApiResponse,
      PostV2AdminNotetemplatesModelConversionSaveApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates/model-conversion/save`,
        method: "POST",
        body: queryArg.saveConvertedRevisionRequest,
      }),
    }),
    postV2AdminNotetemplatesModelConversionStart: build.mutation<
      PostV2AdminNotetemplatesModelConversionStartApiResponse,
      PostV2AdminNotetemplatesModelConversionStartApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates/model-conversion/start`,
        method: "POST",
        body: queryArg.startModelConversionRequest,
      }),
    }),
    getV2AdminNotetemplatesModelConversionStatusByThreadId: build.query<
      GetV2AdminNotetemplatesModelConversionStatusByThreadIdApiResponse,
      GetV2AdminNotetemplatesModelConversionStatusByThreadIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates/model-conversion/status/${queryArg.threadId}`,
      }),
    }),
    getV2AdminNotetemplatesOrgByOrganizationId: build.query<
      GetV2AdminNotetemplatesOrgByOrganizationIdApiResponse,
      GetV2AdminNotetemplatesOrgByOrganizationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates/org/${queryArg.organizationId}`,
      }),
    }),
    postV2AdminNotetemplatesOrgByOrganizationId: build.mutation<
      PostV2AdminNotetemplatesOrgByOrganizationIdApiResponse,
      PostV2AdminNotetemplatesOrgByOrganizationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates/org/${queryArg.organizationId}`,
        method: "POST",
        body: queryArg.adminCreateOrgTemplateRequest,
      }),
    }),
    getV2AdminNotetemplatesProviderByProviderId: build.query<
      GetV2AdminNotetemplatesProviderByProviderIdApiResponse,
      GetV2AdminNotetemplatesProviderByProviderIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates/provider/${queryArg.providerId}`,
        params: {
          organization_id: queryArg.organizationId,
        },
      }),
    }),
    getV2AdminNotetemplatesUserByUserId: build.query<
      GetV2AdminNotetemplatesUserByUserIdApiResponse,
      GetV2AdminNotetemplatesUserByUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates/user/${queryArg.userId}`,
      }),
    }),
    deleteV2AdminNotetemplatesUserByUserIdTemplatesAndTemplateId:
      build.mutation<
        DeleteV2AdminNotetemplatesUserByUserIdTemplatesAndTemplateIdApiResponse,
        DeleteV2AdminNotetemplatesUserByUserIdTemplatesAndTemplateIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/notetemplates/user/${queryArg.userId}/templates/${queryArg.templateId}`,
          method: "DELETE",
        }),
      }),
    deleteV2AdminNotetemplatesByTemplateId: build.mutation<
      DeleteV2AdminNotetemplatesByTemplateIdApiResponse,
      DeleteV2AdminNotetemplatesByTemplateIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates/${queryArg.templateId}`,
        method: "DELETE",
      }),
    }),
    getV2AdminNotetemplatesByTemplateId: build.query<
      GetV2AdminNotetemplatesByTemplateIdApiResponse,
      GetV2AdminNotetemplatesByTemplateIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates/${queryArg.templateId}`,
      }),
    }),
    putV2AdminNotetemplatesByTemplateId: build.mutation<
      PutV2AdminNotetemplatesByTemplateIdApiResponse,
      PutV2AdminNotetemplatesByTemplateIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates/${queryArg.templateId}`,
        method: "PUT",
        body: queryArg.adminUpdateNoteTemplateRequest,
      }),
    }),
    getV2AdminNotetemplatesByTemplateIdRevisions: build.query<
      GetV2AdminNotetemplatesByTemplateIdRevisionsApiResponse,
      GetV2AdminNotetemplatesByTemplateIdRevisionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates/${queryArg.templateId}/revisions`,
      }),
    }),
    getV2AdminNotetemplatesByTemplateIdRevisionsAndVersion: build.query<
      GetV2AdminNotetemplatesByTemplateIdRevisionsAndVersionApiResponse,
      GetV2AdminNotetemplatesByTemplateIdRevisionsAndVersionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates/${queryArg.templateId}/revisions/${queryArg.version}`,
      }),
    }),
    getV2AdminObservabilityHoneycombNoteDebuggingUrl: build.query<
      GetV2AdminObservabilityHoneycombNoteDebuggingUrlApiResponse,
      GetV2AdminObservabilityHoneycombNoteDebuggingUrlApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/observability/honeycomb/note-debugging-url`,
        params: {
          transcription_id: queryArg.transcriptionId,
          note_processing_id: queryArg.noteProcessingId,
          note_id: queryArg.noteId,
          center_time: queryArg.centerTime,
          time_range_hours: queryArg.timeRangeHours,
          team: queryArg.team,
          environment: queryArg.environment,
        },
      }),
    }),
    getV2AdminOrganizations: build.query<
      GetV2AdminOrganizationsApiResponse,
      GetV2AdminOrganizationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations`,
        params: {
          search: queryArg.search,
          page: queryArg.page,
          per_page: queryArg.perPage,
        },
      }),
    }),
    getV2AdminOrganizationsByOrganizationId: build.query<
      GetV2AdminOrganizationsByOrganizationIdApiResponse,
      GetV2AdminOrganizationsByOrganizationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}`,
      }),
    }),
    patchV2AdminOrganizationsByOrganizationId: build.mutation<
      PatchV2AdminOrganizationsByOrganizationIdApiResponse,
      PatchV2AdminOrganizationsByOrganizationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}`,
        method: "PATCH",
        body: queryArg.updateOrganizationRequest,
      }),
    }),
    putV2AdminOrganizationsByOrganizationIdBaa: build.mutation<
      PutV2AdminOrganizationsByOrganizationIdBaaApiResponse,
      PutV2AdminOrganizationsByOrganizationIdBaaApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/baa`,
        method: "PUT",
        body: queryArg.adminUpdateStatusRequest,
      }),
    }),
    getV2AdminOrganizationsByOrganizationIdClinicDocuments: build.query<
      GetV2AdminOrganizationsByOrganizationIdClinicDocumentsApiResponse,
      GetV2AdminOrganizationsByOrganizationIdClinicDocumentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/clinic-documents`,
        params: {
          scope_type: queryArg.scopeType,
          scope_id: queryArg.scopeId,
          doc_kind: queryArg.docKind,
          processing_status: queryArg.processingStatus,
          search: queryArg.search,
          limit: queryArg.limit,
          offset: queryArg.offset,
        },
      }),
    }),
    getV2AdminOrganizationsByOrganizationIdClinicDocumentsSectionsAndSectionId:
      build.query<
        GetV2AdminOrganizationsByOrganizationIdClinicDocumentsSectionsAndSectionIdApiResponse,
        GetV2AdminOrganizationsByOrganizationIdClinicDocumentsSectionsAndSectionIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/clinic-documents/sections/${queryArg.sectionId}`,
        }),
      }),
    getV2AdminOrganizationsByOrganizationIdClinicDocumentsSectionsAndSectionIdContent:
      build.query<
        GetV2AdminOrganizationsByOrganizationIdClinicDocumentsSectionsAndSectionIdContentApiResponse,
        GetV2AdminOrganizationsByOrganizationIdClinicDocumentsSectionsAndSectionIdContentApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/clinic-documents/sections/${queryArg.sectionId}/content`,
        }),
      }),
    getV2AdminOrganizationsByOrganizationIdClinicDocumentsAndClinicDocumentId:
      build.query<
        GetV2AdminOrganizationsByOrganizationIdClinicDocumentsAndClinicDocumentIdApiResponse,
        GetV2AdminOrganizationsByOrganizationIdClinicDocumentsAndClinicDocumentIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/clinic-documents/${queryArg.clinicDocumentId}`,
        }),
      }),
    getV2AdminOrganizationsByOrganizationIdClinicDocumentsAndClinicDocumentIdExtractionResultsTaskName:
      build.query<
        GetV2AdminOrganizationsByOrganizationIdClinicDocumentsAndClinicDocumentIdExtractionResultsTaskNameApiResponse,
        GetV2AdminOrganizationsByOrganizationIdClinicDocumentsAndClinicDocumentIdExtractionResultsTaskNameApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/clinic-documents/${queryArg.clinicDocumentId}/extraction-results/${queryArg.taskName}`,
        }),
      }),
    getV2AdminOrganizationsByOrganizationIdClinicDocumentsAndClinicDocumentIdFile:
      build.query<
        GetV2AdminOrganizationsByOrganizationIdClinicDocumentsAndClinicDocumentIdFileApiResponse,
        GetV2AdminOrganizationsByOrganizationIdClinicDocumentsAndClinicDocumentIdFileApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/clinic-documents/${queryArg.clinicDocumentId}/file`,
          params: {
            disposition: queryArg.disposition,
          },
        }),
      }),
    getV2AdminOrganizationsByOrganizationIdClinicDocumentsAndClinicDocumentIdSections:
      build.query<
        GetV2AdminOrganizationsByOrganizationIdClinicDocumentsAndClinicDocumentIdSectionsApiResponse,
        GetV2AdminOrganizationsByOrganizationIdClinicDocumentsAndClinicDocumentIdSectionsApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/clinic-documents/${queryArg.clinicDocumentId}/sections`,
        }),
      }),
    getV2AdminOrganizationsByOrganizationIdClinicDocumentsAndClinicDocumentIdStatus:
      build.query<
        GetV2AdminOrganizationsByOrganizationIdClinicDocumentsAndClinicDocumentIdStatusApiResponse,
        GetV2AdminOrganizationsByOrganizationIdClinicDocumentsAndClinicDocumentIdStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/clinic-documents/${queryArg.clinicDocumentId}/status`,
        }),
      }),
    putV2AdminOrganizationsByOrganizationIdCoi: build.mutation<
      PutV2AdminOrganizationsByOrganizationIdCoiApiResponse,
      PutV2AdminOrganizationsByOrganizationIdCoiApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/coi`,
        method: "PUT",
        body: queryArg.adminUpdateStatusRequest,
      }),
    }),
    postV2AdminOrganizationsByOrganizationIdCreateSubscription: build.mutation<
      PostV2AdminOrganizationsByOrganizationIdCreateSubscriptionApiResponse,
      PostV2AdminOrganizationsByOrganizationIdCreateSubscriptionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/create-subscription`,
        method: "POST",
        body: queryArg.createSubscriptionRequest,
      }),
    }),
    putV2AdminOrganizationsByOrganizationIdDataRetention: build.mutation<
      PutV2AdminOrganizationsByOrganizationIdDataRetentionApiResponse,
      PutV2AdminOrganizationsByOrganizationIdDataRetentionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/data-retention`,
        method: "PUT",
        body: queryArg.adminUpdateStatusRequest,
      }),
    }),
    getV2AdminOrganizationsByOrganizationIdDataSecurity: build.query<
      GetV2AdminOrganizationsByOrganizationIdDataSecurityApiResponse,
      GetV2AdminOrganizationsByOrganizationIdDataSecurityApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/data-security`,
      }),
    }),
    getV2AdminOrganizationsByOrganizationIdDocuments: build.query<
      GetV2AdminOrganizationsByOrganizationIdDocumentsApiResponse,
      GetV2AdminOrganizationsByOrganizationIdDocumentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.pathOrganizationId}/documents`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          document_type: queryArg.documentType,
          organization_id: queryArg.queryOrganizationId,
          patient_id: queryArg.patientId,
          include_deleted: queryArg.includeDeleted,
          start_date: queryArg.startDate,
          end_date: queryArg.endDate,
          search: queryArg.search,
          sort_by: queryArg.sortBy,
          sort_order: queryArg.sortOrder,
        },
      }),
    }),
    getV2AdminOrganizationsByOrganizationIdEprescriptionsPatientsSearch:
      build.query<
        GetV2AdminOrganizationsByOrganizationIdEprescriptionsPatientsSearchApiResponse,
        GetV2AdminOrganizationsByOrganizationIdEprescriptionsPatientsSearchApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/eprescriptions/patients/search`,
          params: {
            firstname: queryArg.firstname,
            lastname: queryArg.lastname,
            dob: queryArg.dob,
            page: queryArg.page,
          },
        }),
      }),
    getV2AdminOrganizationsByOrganizationIdEprescriptionsPatientsAndDosespotPatientId:
      build.query<
        GetV2AdminOrganizationsByOrganizationIdEprescriptionsPatientsAndDosespotPatientIdApiResponse,
        GetV2AdminOrganizationsByOrganizationIdEprescriptionsPatientsAndDosespotPatientIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/eprescriptions/patients/${queryArg.dosespotPatientId}`,
        }),
      }),
    putV2AdminOrganizationsByOrganizationIdEprescriptionsPatientsAndDosespotPatientId:
      build.mutation<
        PutV2AdminOrganizationsByOrganizationIdEprescriptionsPatientsAndDosespotPatientIdApiResponse,
        PutV2AdminOrganizationsByOrganizationIdEprescriptionsPatientsAndDosespotPatientIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/eprescriptions/patients/${queryArg.dosespotPatientId}`,
          method: "PUT",
        }),
      }),
    postV2AdminOrganizationsByOrganizationIdExtendTrial: build.mutation<
      PostV2AdminOrganizationsByOrganizationIdExtendTrialApiResponse,
      PostV2AdminOrganizationsByOrganizationIdExtendTrialApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/extend-trial`,
        method: "POST",
        body: queryArg.extendTrialRequest,
      }),
    }),
    getV2AdminOrganizationsByOrganizationIdForms: build.query<
      GetV2AdminOrganizationsByOrganizationIdFormsApiResponse,
      GetV2AdminOrganizationsByOrganizationIdFormsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/forms`,
      }),
    }),
    postV2AdminOrganizationsByOrganizationIdForms: build.mutation<
      PostV2AdminOrganizationsByOrganizationIdFormsApiResponse,
      PostV2AdminOrganizationsByOrganizationIdFormsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/forms`,
        method: "POST",
        body: queryArg.adminFormCreateRequest,
      }),
    }),
    deleteV2AdminOrganizationsByOrganizationIdFormsAndFormId: build.mutation<
      DeleteV2AdminOrganizationsByOrganizationIdFormsAndFormIdApiResponse,
      DeleteV2AdminOrganizationsByOrganizationIdFormsAndFormIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/forms/${queryArg.formId}`,
        method: "DELETE",
      }),
    }),
    getV2AdminOrganizationsByOrganizationIdInvitations: build.query<
      GetV2AdminOrganizationsByOrganizationIdInvitationsApiResponse,
      GetV2AdminOrganizationsByOrganizationIdInvitationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/invitations`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          status: queryArg.status,
          email: queryArg.email,
          include_expired: queryArg.includeExpired,
        },
      }),
    }),
    postV2AdminOrganizationsByOrganizationIdInvitations: build.mutation<
      PostV2AdminOrganizationsByOrganizationIdInvitationsApiResponse,
      PostV2AdminOrganizationsByOrganizationIdInvitationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/invitations`,
        method: "POST",
        body: queryArg.adminSendInvitationRequest,
      }),
    }),
    deleteV2AdminOrganizationsByOrganizationIdInvitationsAndInvitationId:
      build.mutation<
        DeleteV2AdminOrganizationsByOrganizationIdInvitationsAndInvitationIdApiResponse,
        DeleteV2AdminOrganizationsByOrganizationIdInvitationsAndInvitationIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/invitations/${queryArg.invitationId}`,
          method: "DELETE",
        }),
      }),
    getV2AdminOrganizationsByOrganizationIdInvitationsAndInvitationId:
      build.query<
        GetV2AdminOrganizationsByOrganizationIdInvitationsAndInvitationIdApiResponse,
        GetV2AdminOrganizationsByOrganizationIdInvitationsAndInvitationIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/invitations/${queryArg.invitationId}`,
        }),
      }),
    postV2AdminOrganizationsByOrganizationIdInvitationsAndInvitationIdResend:
      build.mutation<
        PostV2AdminOrganizationsByOrganizationIdInvitationsAndInvitationIdResendApiResponse,
        PostV2AdminOrganizationsByOrganizationIdInvitationsAndInvitationIdResendApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/invitations/${queryArg.invitationId}/resend`,
          method: "POST",
        }),
      }),
    postV2AdminOrganizationsByOrganizationIdMembers: build.mutation<
      PostV2AdminOrganizationsByOrganizationIdMembersApiResponse,
      PostV2AdminOrganizationsByOrganizationIdMembersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/members`,
        method: "POST",
        body: queryArg.addMemberRequest,
      }),
    }),
    deleteV2AdminOrganizationsByOrganizationIdMembersAndUserId: build.mutation<
      DeleteV2AdminOrganizationsByOrganizationIdMembersAndUserIdApiResponse,
      DeleteV2AdminOrganizationsByOrganizationIdMembersAndUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/members/${queryArg.userId}`,
        method: "DELETE",
        params: {
          role: queryArg.role,
        },
      }),
    }),
    getV2AdminOrganizationsByOrganizationIdMembersAndUserIdMembershipInfo:
      build.query<
        GetV2AdminOrganizationsByOrganizationIdMembersAndUserIdMembershipInfoApiResponse,
        GetV2AdminOrganizationsByOrganizationIdMembersAndUserIdMembershipInfoApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/members/${queryArg.userId}/membership-info`,
        }),
      }),
    patchV2AdminOrganizationsByOrganizationIdMembersAndUserIdMembershipInfo:
      build.mutation<
        PatchV2AdminOrganizationsByOrganizationIdMembersAndUserIdMembershipInfoApiResponse,
        PatchV2AdminOrganizationsByOrganizationIdMembersAndUserIdMembershipInfoApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/members/${queryArg.userId}/membership-info`,
          method: "PATCH",
          body: queryArg.updateMembershipInfoRequest,
        }),
      }),
    postV2AdminOrganizationsByOrganizationIdMembersAndUserIdReactivate:
      build.mutation<
        PostV2AdminOrganizationsByOrganizationIdMembersAndUserIdReactivateApiResponse,
        PostV2AdminOrganizationsByOrganizationIdMembersAndUserIdReactivateApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/members/${queryArg.userId}/reactivate`,
          method: "POST",
        }),
      }),
    patchV2AdminOrganizationsByOrganizationIdMembersAndUserIdRoles:
      build.mutation<
        PatchV2AdminOrganizationsByOrganizationIdMembersAndUserIdRolesApiResponse,
        PatchV2AdminOrganizationsByOrganizationIdMembersAndUserIdRolesApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/members/${queryArg.userId}/roles`,
          method: "PATCH",
          body: queryArg.updateUserRolesRequest,
        }),
      }),
    postV2AdminOrganizationsByOrganizationIdMembersAndUserIdRoles:
      build.mutation<
        PostV2AdminOrganizationsByOrganizationIdMembersAndUserIdRolesApiResponse,
        PostV2AdminOrganizationsByOrganizationIdMembersAndUserIdRolesApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/members/${queryArg.userId}/roles`,
          method: "POST",
          body: queryArg.addUserRoleRequest,
        }),
      }),
    postV2AdminOrganizationsByOrganizationIdMerge: build.mutation<
      PostV2AdminOrganizationsByOrganizationIdMergeApiResponse,
      PostV2AdminOrganizationsByOrganizationIdMergeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/merge`,
        method: "POST",
        body: queryArg.mergeOrganizationsRequest,
      }),
    }),
    getV2AdminOrganizationsByOrganizationIdPatientVisibility: build.query<
      GetV2AdminOrganizationsByOrganizationIdPatientVisibilityApiResponse,
      GetV2AdminOrganizationsByOrganizationIdPatientVisibilityApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/patient-visibility`,
      }),
    }),
    patchV2AdminOrganizationsByOrganizationIdPatientVisibility: build.mutation<
      PatchV2AdminOrganizationsByOrganizationIdPatientVisibilityApiResponse,
      PatchV2AdminOrganizationsByOrganizationIdPatientVisibilityApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/patient-visibility`,
        method: "PATCH",
        body: queryArg.updatePatientVisibilityRequest,
      }),
    }),
    getV2AdminOrganizationsByOrganizationIdProviders: build.query<
      GetV2AdminOrganizationsByOrganizationIdProvidersApiResponse,
      GetV2AdminOrganizationsByOrganizationIdProvidersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/providers`,
      }),
    }),
    getV2AdminOrganizationsByOrganizationIdSubscriptionDashboardUrl:
      build.query<
        GetV2AdminOrganizationsByOrganizationIdSubscriptionDashboardUrlApiResponse,
        GetV2AdminOrganizationsByOrganizationIdSubscriptionDashboardUrlApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/subscription-dashboard-url`,
        }),
      }),
    postV2AdminOrganizationsByOrganizationIdSyncSubscription: build.mutation<
      PostV2AdminOrganizationsByOrganizationIdSyncSubscriptionApiResponse,
      PostV2AdminOrganizationsByOrganizationIdSyncSubscriptionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/sync-subscription`,
        method: "POST",
      }),
    }),
    getV2AdminOrganizationsByOrganizationIdTemplates: build.query<
      GetV2AdminOrganizationsByOrganizationIdTemplatesApiResponse,
      GetV2AdminOrganizationsByOrganizationIdTemplatesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/templates`,
      }),
    }),
    postV2AdminOrganizationsByOrganizationIdTemplates: build.mutation<
      PostV2AdminOrganizationsByOrganizationIdTemplatesApiResponse,
      PostV2AdminOrganizationsByOrganizationIdTemplatesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/templates`,
        method: "POST",
        body: queryArg.adminTemplateCreateRequest,
      }),
    }),
    deleteV2AdminOrganizationsByOrganizationIdTemplatesAndTemplateId:
      build.mutation<
        DeleteV2AdminOrganizationsByOrganizationIdTemplatesAndTemplateIdApiResponse,
        DeleteV2AdminOrganizationsByOrganizationIdTemplatesAndTemplateIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/templates/${queryArg.templateId}`,
          method: "DELETE",
        }),
      }),
    putV2AdminOrganizationsByOrganizationIdTemplatesAndTemplateId:
      build.mutation<
        PutV2AdminOrganizationsByOrganizationIdTemplatesAndTemplateIdApiResponse,
        PutV2AdminOrganizationsByOrganizationIdTemplatesAndTemplateIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/templates/${queryArg.templateId}`,
          method: "PUT",
          body: queryArg.adminTemplateUpdateRequest,
        }),
      }),
    getV2AdminOrgsByOrganizationIdBillingEntities: build.query<
      GetV2AdminOrgsByOrganizationIdBillingEntitiesApiResponse,
      GetV2AdminOrgsByOrganizationIdBillingEntitiesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/billing-entities`,
      }),
    }),
    postV2AdminOrgsByOrganizationIdBillingEntities: build.mutation<
      PostV2AdminOrgsByOrganizationIdBillingEntitiesApiResponse,
      PostV2AdminOrgsByOrganizationIdBillingEntitiesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/billing-entities`,
        method: "POST",
        body: queryArg.createBillingEntityRequest,
      }),
    }),
    deleteV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityId:
      build.mutation<
        DeleteV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiResponse,
        DeleteV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/orgs/${queryArg.organizationId}/billing-entities/${queryArg.billingEntityId}`,
          method: "DELETE",
        }),
      }),
    getV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityId:
      build.query<
        GetV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiResponse,
        GetV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/orgs/${queryArg.organizationId}/billing-entities/${queryArg.billingEntityId}`,
        }),
      }),
    putV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityId:
      build.mutation<
        PutV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiResponse,
        PutV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/orgs/${queryArg.organizationId}/billing-entities/${queryArg.billingEntityId}`,
          method: "PUT",
          body: queryArg.updateBillingEntityRequest,
        }),
      }),
    getV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdPayersPayerIdReadiness:
      build.query<
        GetV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdPayersPayerIdReadinessApiResponse,
        GetV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdPayersPayerIdReadinessApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/orgs/${queryArg.organizationId}/billing-entities/${queryArg.billingEntityId}/payers/${queryArg.payerId}/readiness`,
        }),
      }),
    postV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdSetDefault:
      build.mutation<
        PostV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdSetDefaultApiResponse,
        PostV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdSetDefaultApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/orgs/${queryArg.organizationId}/billing-entities/${queryArg.billingEntityId}/set-default`,
          method: "POST",
        }),
      }),
    postV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdSyncToStedi:
      build.mutation<
        PostV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdSyncToStediApiResponse,
        PostV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdSyncToStediApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/orgs/${queryArg.organizationId}/billing-entities/${queryArg.billingEntityId}/sync-to-stedi`,
          method: "POST",
        }),
      }),
    getV2AdminOrgsByOrganizationIdBillingReadiness: build.query<
      GetV2AdminOrgsByOrganizationIdBillingReadinessApiResponse,
      GetV2AdminOrgsByOrganizationIdBillingReadinessApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/billing-readiness`,
      }),
    }),
    getV2AdminOrgsByOrganizationIdBillingPayerDocs: build.query<
      GetV2AdminOrgsByOrganizationIdBillingPayerDocsApiResponse,
      GetV2AdminOrgsByOrganizationIdBillingPayerDocsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/billing/payer-docs`,
      }),
    }),
    getV2AdminOrgsByOrganizationIdBillingPayerDocsAndPayerKey: build.query<
      GetV2AdminOrgsByOrganizationIdBillingPayerDocsAndPayerKeyApiResponse,
      GetV2AdminOrgsByOrganizationIdBillingPayerDocsAndPayerKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/billing/payer-docs/${queryArg.payerKey}`,
      }),
    }),
    putV2AdminOrgsByOrganizationIdBillingPayerDocsAndPayerKey: build.mutation<
      PutV2AdminOrgsByOrganizationIdBillingPayerDocsAndPayerKeyApiResponse,
      PutV2AdminOrgsByOrganizationIdBillingPayerDocsAndPayerKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/billing/payer-docs/${queryArg.payerKey}`,
        method: "PUT",
        body: queryArg.payerDocUpsertRequest,
      }),
    }),
    getV2AdminOrgsByOrganizationIdEnrollments: build.query<
      GetV2AdminOrgsByOrganizationIdEnrollmentsApiResponse,
      GetV2AdminOrgsByOrganizationIdEnrollmentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/enrollments`,
      }),
    }),
    postV2AdminOrgsByOrganizationIdEnrollments: build.mutation<
      PostV2AdminOrgsByOrganizationIdEnrollmentsApiResponse,
      PostV2AdminOrgsByOrganizationIdEnrollmentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/enrollments`,
        method: "POST",
        body: queryArg.initiateEnrollmentRequest,
      }),
    }),
    postV2AdminOrgsByOrganizationIdEnrollmentsSyncAll: build.mutation<
      PostV2AdminOrgsByOrganizationIdEnrollmentsSyncAllApiResponse,
      PostV2AdminOrgsByOrganizationIdEnrollmentsSyncAllApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/enrollments/sync-all`,
        method: "POST",
      }),
    }),
    getV2AdminOrgsByOrganizationIdEnrollmentsAndEnrollmentId: build.query<
      GetV2AdminOrgsByOrganizationIdEnrollmentsAndEnrollmentIdApiResponse,
      GetV2AdminOrgsByOrganizationIdEnrollmentsAndEnrollmentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/enrollments/${queryArg.enrollmentId}`,
      }),
    }),
    postV2AdminOrgsByOrganizationIdEnrollmentsAndEnrollmentIdSync:
      build.mutation<
        PostV2AdminOrgsByOrganizationIdEnrollmentsAndEnrollmentIdSyncApiResponse,
        PostV2AdminOrgsByOrganizationIdEnrollmentsAndEnrollmentIdSyncApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/orgs/${queryArg.organizationId}/enrollments/${queryArg.enrollmentId}/sync`,
          method: "POST",
        }),
      }),
    getV2AdminOrgsByOrganizationIdRemittances: build.query<
      GetV2AdminOrgsByOrganizationIdRemittancesApiResponse,
      GetV2AdminOrgsByOrganizationIdRemittancesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/remittances`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
        },
      }),
    }),
    getV2AdminOrgsByOrganizationIdRemittancesClaimsAndClaimIdSummary:
      build.query<
        GetV2AdminOrgsByOrganizationIdRemittancesClaimsAndClaimIdSummaryApiResponse,
        GetV2AdminOrgsByOrganizationIdRemittancesClaimsAndClaimIdSummaryApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/orgs/${queryArg.organizationId}/remittances/claims/${queryArg.claimId}/summary`,
        }),
      }),
    getV2AdminOrgsByOrganizationIdRemittancesAndRemittanceId: build.query<
      GetV2AdminOrgsByOrganizationIdRemittancesAndRemittanceIdApiResponse,
      GetV2AdminOrgsByOrganizationIdRemittancesAndRemittanceIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/remittances/${queryArg.remittanceId}`,
      }),
    }),
    postV2AdminOrgsByOrganizationIdStediConnect: build.mutation<
      PostV2AdminOrgsByOrganizationIdStediConnectApiResponse,
      PostV2AdminOrgsByOrganizationIdStediConnectApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/stedi/connect`,
        method: "POST",
        body: queryArg.connectStediRequest,
      }),
    }),
    deleteV2AdminOrgsByOrganizationIdStediDisconnect: build.mutation<
      DeleteV2AdminOrgsByOrganizationIdStediDisconnectApiResponse,
      DeleteV2AdminOrgsByOrganizationIdStediDisconnectApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/stedi/disconnect`,
        method: "DELETE",
      }),
    }),
    getV2AdminOrgsByOrganizationIdStediStatus: build.query<
      GetV2AdminOrgsByOrganizationIdStediStatusApiResponse,
      GetV2AdminOrgsByOrganizationIdStediStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/stedi/status`,
      }),
    }),
    getV2AdminOrgsByOrganizationIdStediTransactions: build.query<
      GetV2AdminOrgsByOrganizationIdStediTransactionsApiResponse,
      GetV2AdminOrgsByOrganizationIdStediTransactionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/stedi/transactions`,
        params: {
          page_size: queryArg.pageSize,
          page_token: queryArg.pageToken,
          from_date: queryArg.fromDate,
          to_date: queryArg.toDate,
          direction: queryArg.direction,
          mode: queryArg.mode,
          status: queryArg.status,
          transaction_set_id: queryArg.transactionSetId,
        },
      }),
    }),
    getV2AdminOrgsByOrganizationIdStediTransactionsAndTransactionId:
      build.query<
        GetV2AdminOrgsByOrganizationIdStediTransactionsAndTransactionIdApiResponse,
        GetV2AdminOrgsByOrganizationIdStediTransactionsAndTransactionIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/orgs/${queryArg.organizationId}/stedi/transactions/${queryArg.transactionId}`,
        }),
      }),
    postV2AdminOrgsByOrganizationIdStediVerify: build.mutation<
      PostV2AdminOrgsByOrganizationIdStediVerifyApiResponse,
      PostV2AdminOrgsByOrganizationIdStediVerifyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/stedi/verify`,
        method: "POST",
      }),
    }),
    postV2AdminPatientIntelligenceRegenerate: build.mutation<
      PostV2AdminPatientIntelligenceRegenerateApiResponse,
      PostV2AdminPatientIntelligenceRegenerateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/patient-intelligence/regenerate`,
        method: "POST",
        body: queryArg.regeneratePatientIntelligenceRequest,
      }),
    }),
    postV2AdminPayersSync: build.mutation<
      PostV2AdminPayersSyncApiResponse,
      PostV2AdminPayersSyncApiArg
    >({
      query: () => ({ url: `/v2/admin/payers/sync`, method: "POST" }),
    }),
    getV2AdminPayersSyncStatus: build.query<
      GetV2AdminPayersSyncStatusApiResponse,
      GetV2AdminPayersSyncStatusApiArg
    >({
      query: () => ({ url: `/v2/admin/payers/sync-status` }),
    }),
    getV2AdminProspects: build.query<
      GetV2AdminProspectsApiResponse,
      GetV2AdminProspectsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/prospects`,
        params: {
          page: queryArg.page,
          page_size: queryArg.pageSize,
          organization: queryArg.organization,
          email: queryArg.email,
          enriched: queryArg.enriched,
          sort_by: queryArg.sortBy,
          sort_order: queryArg.sortOrder,
        },
      }),
    }),
    getV2AdminProspectsByProspectSegmentId: build.query<
      GetV2AdminProspectsByProspectSegmentIdApiResponse,
      GetV2AdminProspectsByProspectSegmentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/prospects/${queryArg.prospectSegmentId}`,
      }),
    }),
    getV2AdminProvidersByProviderId: build.query<
      GetV2AdminProvidersByProviderIdApiResponse,
      GetV2AdminProvidersByProviderIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/providers/${queryArg.providerId}`,
      }),
    }),
    getV2AdminProvidersByProviderIdAppointments: build.query<
      GetV2AdminProvidersByProviderIdAppointmentsApiResponse,
      GetV2AdminProvidersByProviderIdAppointmentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/providers/${queryArg.providerId}/appointments`,
      }),
    }),
    getV2AdminProvidersByProviderIdEncounterTypes: build.query<
      GetV2AdminProvidersByProviderIdEncounterTypesApiResponse,
      GetV2AdminProvidersByProviderIdEncounterTypesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/providers/${queryArg.providerId}/encounter-types`,
      }),
    }),
    postV2AdminProvidersByProviderIdEncounterTypes: build.mutation<
      PostV2AdminProvidersByProviderIdEncounterTypesApiResponse,
      PostV2AdminProvidersByProviderIdEncounterTypesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/providers/${queryArg.providerId}/encounter-types`,
        method: "POST",
        body: queryArg.encounterTypeCreate,
      }),
    }),
    deleteV2AdminProvidersByProviderIdEncounterTypesAndEncounterTypeId:
      build.mutation<
        DeleteV2AdminProvidersByProviderIdEncounterTypesAndEncounterTypeIdApiResponse,
        DeleteV2AdminProvidersByProviderIdEncounterTypesAndEncounterTypeIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/providers/${queryArg.providerId}/encounter-types/${queryArg.encounterTypeId}`,
          method: "DELETE",
        }),
      }),
    getV2AdminProvidersByProviderIdEncounterTypesAndEncounterTypeId:
      build.query<
        GetV2AdminProvidersByProviderIdEncounterTypesAndEncounterTypeIdApiResponse,
        GetV2AdminProvidersByProviderIdEncounterTypesAndEncounterTypeIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/providers/${queryArg.providerId}/encounter-types/${queryArg.encounterTypeId}`,
        }),
      }),
    patchV2AdminProvidersByProviderIdEncounterTypesAndEncounterTypeId:
      build.mutation<
        PatchV2AdminProvidersByProviderIdEncounterTypesAndEncounterTypeIdApiResponse,
        PatchV2AdminProvidersByProviderIdEncounterTypesAndEncounterTypeIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/providers/${queryArg.providerId}/encounter-types/${queryArg.encounterTypeId}`,
          method: "PATCH",
          body: queryArg.encounterTypeUpdate,
        }),
      }),
    getV2AdminProvidersByProviderIdEncounters: build.query<
      GetV2AdminProvidersByProviderIdEncountersApiResponse,
      GetV2AdminProvidersByProviderIdEncountersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/providers/${queryArg.providerId}/encounters`,
      }),
    }),
    deleteV2AdminProvidersByProviderIdGoogleSync: build.mutation<
      DeleteV2AdminProvidersByProviderIdGoogleSyncApiResponse,
      DeleteV2AdminProvidersByProviderIdGoogleSyncApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/providers/${queryArg.providerId}/google-sync`,
        method: "DELETE",
      }),
    }),
    postV2AdminProvidersByProviderIdGoogleSync: build.mutation<
      PostV2AdminProvidersByProviderIdGoogleSyncApiResponse,
      PostV2AdminProvidersByProviderIdGoogleSyncApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/providers/${queryArg.providerId}/google-sync`,
        method: "POST",
      }),
    }),
    getV2AdminProvidersByProviderIdGoogleSyncStatus: build.query<
      GetV2AdminProvidersByProviderIdGoogleSyncStatusApiResponse,
      GetV2AdminProvidersByProviderIdGoogleSyncStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/providers/${queryArg.providerId}/google-sync/status`,
      }),
    }),
    getV2AdminProvidersByProviderIdNoteProcessingSessions: build.query<
      GetV2AdminProvidersByProviderIdNoteProcessingSessionsApiResponse,
      GetV2AdminProvidersByProviderIdNoteProcessingSessionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/providers/${queryArg.providerId}/note-processing-sessions`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          encounter_id: queryArg.encounterId,
          transcription_session_id: queryArg.transcriptionSessionId,
          note_id: queryArg.noteId,
          status: queryArg.status,
          search: queryArg.search,
        },
      }),
    }),
    getV2AdminProvidersByProviderIdNotes: build.query<
      GetV2AdminProvidersByProviderIdNotesApiResponse,
      GetV2AdminProvidersByProviderIdNotesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/providers/${queryArg.providerId}/notes`,
      }),
    }),
    patchV2AdminProvidersByProviderIdProfile: build.mutation<
      PatchV2AdminProvidersByProviderIdProfileApiResponse,
      PatchV2AdminProvidersByProviderIdProfileApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/providers/${queryArg.providerId}/profile`,
        method: "PATCH",
        body: queryArg.updateProviderProfileRequest,
      }),
    }),
    getV2AdminProvidersByProviderIdTranscriptions: build.query<
      GetV2AdminProvidersByProviderIdTranscriptionsApiResponse,
      GetV2AdminProvidersByProviderIdTranscriptionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/providers/${queryArg.providerId}/transcriptions`,
      }),
    }),
    getV2AdminRoles: build.query<
      GetV2AdminRolesApiResponse,
      GetV2AdminRolesApiArg
    >({
      query: () => ({ url: `/v2/admin/roles` }),
    }),
    getV2AdminRules: build.query<
      GetV2AdminRulesApiResponse,
      GetV2AdminRulesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/rules`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          organization_id: queryArg.organizationId,
          scope: queryArg.scope,
          rule_type: queryArg.ruleType,
        },
      }),
    }),
    postV2AdminRules: build.mutation<
      PostV2AdminRulesApiResponse,
      PostV2AdminRulesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/rules`,
        method: "POST",
        body: queryArg.createRuleRequest,
      }),
    }),
    getV2AdminRulesSearch: build.query<
      GetV2AdminRulesSearchApiResponse,
      GetV2AdminRulesSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/rules/search`,
        params: {
          q: queryArg.q,
          top_k: queryArg.topK,
          organization_id: queryArg.organizationId,
          rule_type: queryArg.ruleType,
        },
      }),
    }),
    postV2AdminRulesSearch: build.mutation<
      PostV2AdminRulesSearchApiResponse,
      PostV2AdminRulesSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/rules/search`,
        method: "POST",
        body: queryArg.ruleSearchRequest,
      }),
    }),
    deleteV2AdminRulesByRuleId: build.mutation<
      DeleteV2AdminRulesByRuleIdApiResponse,
      DeleteV2AdminRulesByRuleIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/rules/${queryArg.ruleId}`,
        method: "DELETE",
      }),
    }),
    getV2AdminRulesByRuleId: build.query<
      GetV2AdminRulesByRuleIdApiResponse,
      GetV2AdminRulesByRuleIdApiArg
    >({
      query: (queryArg) => ({ url: `/v2/admin/rules/${queryArg.ruleId}` }),
    }),
    putV2AdminRulesByRuleId: build.mutation<
      PutV2AdminRulesByRuleIdApiResponse,
      PutV2AdminRulesByRuleIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/rules/${queryArg.ruleId}`,
        method: "PUT",
        body: queryArg.updateRuleRequest,
      }),
    }),
    postV2AdminRulesByRuleIdDisable: build.mutation<
      PostV2AdminRulesByRuleIdDisableApiResponse,
      PostV2AdminRulesByRuleIdDisableApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/rules/${queryArg.ruleId}/disable`,
        method: "POST",
        body: queryArg.adminRuleDisableRequest,
      }),
    }),
    postV2AdminRulesByRuleIdEnable: build.mutation<
      PostV2AdminRulesByRuleIdEnableApiResponse,
      PostV2AdminRulesByRuleIdEnableApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/rules/${queryArg.ruleId}/enable`,
        method: "POST",
        body: queryArg.adminRuleDisableRequest,
      }),
    }),
    postV2AdminRulesByRuleIdFork: build.mutation<
      PostV2AdminRulesByRuleIdForkApiResponse,
      PostV2AdminRulesByRuleIdForkApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/rules/${queryArg.ruleId}/fork`,
        method: "POST",
        body: queryArg.adminRuleForkRequest,
      }),
    }),
    postV2AdminRulesByRuleIdRevert: build.mutation<
      PostV2AdminRulesByRuleIdRevertApiResponse,
      PostV2AdminRulesByRuleIdRevertApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/rules/${queryArg.ruleId}/revert`,
        method: "POST",
        body: queryArg.adminRuleRevertRequest,
      }),
    }),
    getV2AdminRulesByRuleIdRevisions: build.query<
      GetV2AdminRulesByRuleIdRevisionsApiResponse,
      GetV2AdminRulesByRuleIdRevisionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/rules/${queryArg.ruleId}/revisions`,
      }),
    }),
    getV2AdminTemplatesAsyncTaskStatus: build.query<
      GetV2AdminTemplatesAsyncTaskStatusApiResponse,
      GetV2AdminTemplatesAsyncTaskStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/templates/async-task-status`,
        params: {
          async_task_id: queryArg.asyncTaskId,
        },
      }),
    }),
    postV2AdminTemplatesConvert: build.mutation<
      PostV2AdminTemplatesConvertApiResponse,
      PostV2AdminTemplatesConvertApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/templates/convert`,
        method: "POST",
        body: queryArg.convertLegacyTemplateRequest,
      }),
    }),
    postV2AdminTemplatesCopy: build.mutation<
      PostV2AdminTemplatesCopyApiResponse,
      PostV2AdminTemplatesCopyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/templates/copy`,
        method: "POST",
        body: queryArg.copyTemplatesRequest,
      }),
    }),
    postV2AdminTemplatesSingleModuleGeneration: build.mutation<
      PostV2AdminTemplatesSingleModuleGenerationApiResponse,
      PostV2AdminTemplatesSingleModuleGenerationApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/templates/single-module-generation`,
        method: "POST",
        body: queryArg.singleModuleGenerationRequest,
      }),
    }),
    getV2AdminTemplatesUserTemplates: build.query<
      GetV2AdminTemplatesUserTemplatesApiResponse,
      GetV2AdminTemplatesUserTemplatesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/templates/user-templates`,
        params: {
          user_id: queryArg.userId,
          search_query: queryArg.searchQuery,
        },
      }),
    }),
    getV2AdminTranscriptionsByTranscriptionSessionId: build.query<
      GetV2AdminTranscriptionsByTranscriptionSessionIdApiResponse,
      GetV2AdminTranscriptionsByTranscriptionSessionIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/transcriptions/${queryArg.transcriptionSessionId}`,
      }),
    }),
    postV2AdminUploadCsvProspects: build.mutation<
      PostV2AdminUploadCsvProspectsApiResponse,
      PostV2AdminUploadCsvProspectsApiArg
    >({
      query: () => ({ url: `/v2/admin/upload-csv-prospects`, method: "POST" }),
    }),
    postV2AdminUploadCsvProviders: build.mutation<
      PostV2AdminUploadCsvProvidersApiResponse,
      PostV2AdminUploadCsvProvidersApiArg
    >({
      query: () => ({ url: `/v2/admin/upload-csv-providers`, method: "POST" }),
    }),
    deleteV2AdminUsersByUserIdVoiceEnrollment: build.mutation<
      DeleteV2AdminUsersByUserIdVoiceEnrollmentApiResponse,
      DeleteV2AdminUsersByUserIdVoiceEnrollmentApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/users/${queryArg.userId}/voice-enrollment`,
        method: "DELETE",
      }),
    }),
    getV2AdminUsersByUserIdVoiceEnrollment: build.query<
      GetV2AdminUsersByUserIdVoiceEnrollmentApiResponse,
      GetV2AdminUsersByUserIdVoiceEnrollmentApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/users/${queryArg.userId}/voice-enrollment`,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type PostV2AdminAgentChatApiResponse = unknown;
export type PostV2AdminAgentChatApiArg = {
  agentChatRequest: AgentChatRequest;
};
export type PostV2AdminAgentExportPdfApiResponse = unknown;
export type PostV2AdminAgentExportPdfApiArg = {
  exportPdfRequest: ExportPdfRequest;
};
export type GetV2AdminAgentSessionsApiResponse = unknown;
export type GetV2AdminAgentSessionsApiArg = void;
export type GetV2AdminAgentSkillsApiResponse = unknown;
export type GetV2AdminAgentSkillsApiArg = void;
export type PostV2AdminAnalyzeExternalProviderApiResponse =
  /** status 202 Accepted */ CustomerInsightsRequestResponse;
export type PostV2AdminAnalyzeExternalProviderApiArg = {
  externalProviderAnalyzeRequest: ExternalProviderAnalyzeRequest;
};
export type PostV2AdminAnalyzeProviderApiResponse =
  /** status 202 Accepted */ CustomerInsightsRequestResponse;
export type PostV2AdminAnalyzeProviderApiArg = {
  customerInsightsAnalyzeRequest: CustomerInsightsAnalyzeRequest;
};
export type GetV2AdminApplicationConfigFeaturesApiResponse =
  /** status 200 OK */ AvailableFeatureFlagsResponse;
export type GetV2AdminApplicationConfigFeaturesApiArg = void;
export type GetV2AdminApplicationConfigFeaturesByFeatureNameByOrganizationApiResponse =
  /** status 200 OK */ FeatureFlagByOrganizationResponse;
export type GetV2AdminApplicationConfigFeaturesByFeatureNameByOrganizationApiArg =
  {
    featureName: string;
  };
export type GetV2AdminApplicationConfigFeaturesByFeatureNameStatsApiResponse =
  /** status 200 OK */ FeatureFlagStatsResponse;
export type GetV2AdminApplicationConfigFeaturesByFeatureNameStatsApiArg = {
  featureName: string;
};
export type GetV2AdminApplicationConfigStatsigGatesApiResponse =
  /** status 200 OK */ ListGatesResponse;
export type GetV2AdminApplicationConfigStatsigGatesApiArg = void;
export type GetV2AdminApplicationConfigStatsigGatesByGateIdOverridesApiResponse =
  /** status 200 OK */ GateOverridesResponse;
export type GetV2AdminApplicationConfigStatsigGatesByGateIdOverridesApiArg = {
  gateId: string;
};
export type PatchV2AdminApplicationConfigStatsigGatesByGateIdOverridesApiResponse =
  /** status 200 OK */ GateOverridesResponse;
export type PatchV2AdminApplicationConfigStatsigGatesByGateIdOverridesApiArg = {
  gateId: string;
  addGateOverridesRequest: AddGateOverridesRequest;
};
export type PutV2AdminApplicationConfigStatsigGatesByGateIdOverridesApiResponse =
  /** status 200 OK */ GateOverridesResponse;
export type PutV2AdminApplicationConfigStatsigGatesByGateIdOverridesApiArg = {
  gateId: string;
  updateGateOverridesRequest: UpdateGateOverridesRequest;
};
export type PostV2AdminApplicationConfigStatsigGatesByGateIdOverridesRemoveApiResponse =
  /** status 200 OK */ GateOverridesResponse;
export type PostV2AdminApplicationConfigStatsigGatesByGateIdOverridesRemoveApiArg =
  {
    gateId: string;
    removeGateOverridesRequest: RemoveGateOverridesRequest;
  };
export type GetV2AdminApplicationConfigStatsigUsersByUserIdGatesApiResponse =
  /** status 200 OK */ UserGatesResponse;
export type GetV2AdminApplicationConfigStatsigUsersByUserIdGatesApiArg = {
  userId: string;
};
export type PostV2AdminAppointmentsMaterializeApiResponse =
  /** status 200 OK */
    | MaterializationResultResponse
    | /** status 202 Accepted */ MaterializationTaskResponse;
export type PostV2AdminAppointmentsMaterializeApiArg = {
  materializationRequest: MaterializationRequest;
};
export type GetV2AdminAppointmentsMaterializeByTaskIdApiResponse =
  /** status 200 OK */ TaskStatusResponse;
export type GetV2AdminAppointmentsMaterializeByTaskIdApiArg = {
  taskId: string;
};
export type GetV2AdminAppointmentsByAppointmentIdApiResponse =
  /** status 200 OK */ AdminAppointmentDetailResponse;
export type GetV2AdminAppointmentsByAppointmentIdApiArg = {
  appointmentId: string;
};
export type GetV2AdminBillingDashboardOrganizationsApiResponse =
  /** status 200 OK */ OrganizationBillingListResponse;
export type GetV2AdminBillingDashboardOrganizationsApiArg = {
  /** Search organizations by name */
  search?: string | null;
  /** Column to sort by (e.g. claims_needs_attention, denial_rate_pct, oldest_draft_age_days) */
  sortBy?: string;
  /** Sort direction: asc or desc */
  sortDir?: string;
  /** Page number */
  page?: number;
  /** Items per page (max 100) */
  perPage?: number;
};
export type GetV2AdminBillingDashboardOrganizationsByOrganizationIdApiResponse =
  /** status 200 OK */ OrganizationBillingDetailResponse;
export type GetV2AdminBillingDashboardOrganizationsByOrganizationIdApiArg = {
  organizationId: string;
};
export type PostV2AdminBulkAnalyzeProvidersApiResponse =
  /** status 200 OK */ CustomerInsightsSyncResponse;
export type PostV2AdminBulkAnalyzeProvidersApiArg = {
  customerInsightsBulkAnalyzeRequest: CustomerInsightsBulkAnalyzeRequest;
};
export type GetV2AdminBundleAssignmentsApiResponse =
  /** status 200 OK */ BundleAssignmentListResponse;
export type GetV2AdminBundleAssignmentsApiArg = {
  /** Filter by organization (required) */
  organizationId?: string | null;
  /** Filter by user within organization (optional) */
  userId?: string | null;
  /** Filter by status */
  status?: string | null;
};
export type PostV2AdminBundleAssignmentsApiResponse =
  /** status 201 Created */ BundleAssignmentResponse2;
export type PostV2AdminBundleAssignmentsApiArg = {
  createAssignmentRequest: CreateAssignmentRequest;
};
export type PostV2AdminBundleAssignmentsOrganizationsByOrganizationIdSyncBundlesApiResponse =
  /** status 200 OK */ SyncBundlesResponse;
export type PostV2AdminBundleAssignmentsOrganizationsByOrganizationIdSyncBundlesApiArg =
  {
    organizationId: string;
  };
export type GetV2AdminBundleAssignmentsByAssignmentIdApiResponse =
  /** status 200 OK */ BundleAssignmentResponse2;
export type GetV2AdminBundleAssignmentsByAssignmentIdApiArg = {
  assignmentId: string;
};
export type PostV2AdminBundleAssignmentsByAssignmentIdReplaceApiResponse =
  /** status 200 OK */ BundleAssignmentResponse2;
export type PostV2AdminBundleAssignmentsByAssignmentIdReplaceApiArg = {
  assignmentId: string;
  replaceBundleRequest: ReplaceBundleRequest;
};
export type PutV2AdminBundleAssignmentsByAssignmentIdStatusApiResponse =
  /** status 200 OK */ BundleAssignmentResponse2;
export type PutV2AdminBundleAssignmentsByAssignmentIdStatusApiArg = {
  assignmentId: string;
  updateAssignmentStatusRequest: UpdateAssignmentStatusRequest;
};
export type GetV2AdminBundlesApiResponse =
  /** status 200 OK */ BundleListResponse;
export type GetV2AdminBundlesApiArg = void;
export type GetV2AdminBundlesByBundleIdApiResponse =
  /** status 200 OK */ BundleResponse2;
export type GetV2AdminBundlesByBundleIdApiArg = {
  bundleId: string;
};
export type GetV2AdminBundlesByBundleIdAssignmentsApiResponse =
  /** status 200 OK */ ListResponseEnrichedBundleAssignmentResponse;
export type GetV2AdminBundlesByBundleIdAssignmentsApiArg = {
  bundleId: string;
  /** Page number (1-based) */
  page?: number;
  /** Items per page (max 1000) */
  perPage?: number;
  /** Filter by assignment status */
  status?: ("pending" | "active" | "canceled" | "expired") | null;
};
export type PostV2AdminCanonicalServiceTypesSeedApiResponse =
  /** status 200 OK */ CanonicalServiceTypeSeedResponse;
export type PostV2AdminCanonicalServiceTypesSeedApiArg = void;
export type DeleteV2AdminCanonicalServiceTypesBySlugApiResponse =
  /** status 200 OK */ CanonicalServiceTypeDeleteResponse;
export type DeleteV2AdminCanonicalServiceTypesBySlugApiArg = {
  slug: string;
};
export type GetV2AdminCapabilitiesApiResponse =
  /** status 200 OK */ CapabilityListResponse;
export type GetV2AdminCapabilitiesApiArg = void;
export type GetV2AdminCapabilitiesByCapabilityIdApiResponse =
  /** status 200 OK */ CapabilityResponse2;
export type GetV2AdminCapabilitiesByCapabilityIdApiArg = {
  capabilityId: string;
};
export type PostV2AdminChatbotConversationsInitiateApiResponse =
  /** status 200 OK */ InitiateConversationResponse;
export type PostV2AdminChatbotConversationsInitiateApiArg = {
  initiateConversationRequest: InitiateConversationRequest;
};
export type PostV2AdminClaimRulesSeedApiResponse =
  /** status 200 OK */ RuleSeedResponse;
export type PostV2AdminClaimRulesSeedApiArg = void;
export type GetV2AdminClaimsByClaimIdReadinessApiResponse =
  /** status 200 OK */ ClaimSubmissionReadinessResponse;
export type GetV2AdminClaimsByClaimIdReadinessApiArg = {
  claimId: string;
};
export type ListOrganizationImportSessionsApiResponse =
  /** status 200 OK */ ImportSessionListResponse;
export type ListOrganizationImportSessionsApiArg = {
  organizationId: string;
};
export type MergeMultiplePatientsApiResponse =
  /** status 200 OK */ MergeMultiplePatientsResponse;
export type MergeMultiplePatientsApiArg = {
  mergeMultiplePatientsRequest: MergeMultiplePatientsRequest;
};
export type DeleteImportSessionApiResponse = unknown;
export type DeleteImportSessionApiArg = {
  sessionId: string;
};
export type GetImportSessionStatusApiResponse =
  /** status 200 OK */ ImportSessionStatusResponse2;
export type GetImportSessionStatusApiArg = {
  sessionId: string;
};
export type ExportImportResultsApiResponse =
  /** status 200 OK */ MigratedDataResponse;
export type ExportImportResultsApiArg = {
  sessionId: string;
};
export type ImportSelectedPatientsApiResponse =
  /** status 200 OK */ ExtractedPatientsResponse;
export type ImportSelectedPatientsApiArg = {
  sessionId: string;
  extractedPatientsRequest: ExtractedPatientsRequest;
};
export type ListImportOperationsApiResponse =
  /** status 200 OK */ ImportOperationListResponse;
export type ListImportOperationsApiArg = {
  sessionId: string;
};
export type GetImportOperationStatusApiResponse =
  /** status 200 OK */ ImportOperationStatusResponse2;
export type GetImportOperationStatusApiArg = {
  sessionId: string;
  operationId: string;
};
export type ImportUnmatchedPatientsApiResponse =
  /** status 200 OK */ ImportUnmatchedResponse;
export type ImportUnmatchedPatientsApiArg = {
  sessionId: string;
  importUnmatchedRequest: ImportUnmatchedRequest;
};
export type GetMatchedPatientsApiResponse =
  /** status 200 OK */ MatchedPatientsResponse;
export type GetMatchedPatientsApiArg = {
  sessionId: string;
  /** Maximum number of patients to return */
  limit?: number;
  /** Number of patients to skip for pagination */
  offset?: number;
  /** Filter by import status (e.g., 'NEW', 'MATCHED', 'IMPORTED') */
  status?: string | null;
};
export type BulkUpdatePatientStatusApiResponse =
  /** status 200 OK */ BulkUpdateStatusResponse;
export type BulkUpdatePatientStatusApiArg = {
  sessionId: string;
  bulkUpdateStatusRequest: BulkUpdateStatusRequest;
};
export type RejectPatientsApiResponse =
  /** status 200 OK */ RejectPatientsResponse;
export type RejectPatientsApiArg = {
  sessionId: string;
  rejectPatientsRequest: RejectPatientsRequest;
};
export type UploadImportFileApiResponse =
  /** status 200 OK */ ImportSessionCreateResponse;
export type UploadImportFileApiArg = {
  importUploadFormData: ImportUploadFormData;
};
export type GetV2AdminDocumentsApiResponse =
  /** status 200 OK */ DocumentListResponse;
export type GetV2AdminDocumentsApiArg = {
  /** Page number (1-based) */
  page?: number;
  /** Items per page */
  perPage?: number;
  /** Filter by document type (e.g., 'lab_order', 'claim', 'form') */
  documentType?: string | null;
  /** Filter by organization ID */
  organizationId?: string | null;
  /** Filter by patient ID */
  patientId?: string | null;
  /** Whether to include soft-deleted documents */
  includeDeleted?: boolean;
  /** Start date for filtering (ISO 8601 format) */
  startDate?: string | null;
  /** End date for filtering (ISO 8601 format) */
  endDate?: string | null;
  /** Text search on filename and document title */
  search?: string | null;
  /** Field to sort by (created_at, updated_at, filename, size_bytes) */
  sortBy?: string;
  /** Sort order (asc or desc) */
  sortOrder?: string;
};
export type GetV2AdminDocumentsByDocumentIdApiResponse =
  /** status 200 OK */ DocumentDetailResponse;
export type GetV2AdminDocumentsByDocumentIdApiArg = {
  documentId: string;
};
export type GetV2AdminEligibilityApiResponse =
  /** status 200 OK */ AdminEligibilityListResponse;
export type GetV2AdminEligibilityApiArg = {
  /** Page number (1-based) */
  page?: number;
  /** Items per page (max 1000) */
  perPage?: number;
  /** Field to sort by */
  sortBy?: string | null;
  /** Sort direction (asc or desc) */
  sortOrder?: string | null;
  /** Filter by next action owner (provider/biller/system) */
  nextActionOwner?: string | null;
  /** Filter by status (eligible/needs_review/blocked) */
  status?: string | null;
  /** Filter by next action (none/portal_review/phone_verify/block) */
  nextAction?: string | null;
};
export type PostV2AdminEligibilityByEligibilityIdOverrideApiResponse =
  /** status 200 OK */ EligibilityCheckResponse;
export type PostV2AdminEligibilityByEligibilityIdOverrideApiArg = {
  eligibilityId: string;
  manualUpdateRequest: ManualUpdateRequest;
};
export type PostV2AdminEncountersStartProcessingApiResponse =
  /** status 200 OK */ StartProcessingResponse;
export type PostV2AdminEncountersStartProcessingApiArg = void;
export type GetV2AdminEncountersTelemetryAnalyticsApiResponse =
  /** status 200 OK */ AdminTelemetryAnalyticsResponse;
export type GetV2AdminEncountersTelemetryAnalyticsApiArg = void;
export type GetV2AdminEncountersTelemetrySessionsApiResponse =
  /** status 200 OK */ ListResponseAdminTelemetrySessionListItem;
export type GetV2AdminEncountersTelemetrySessionsApiArg = {
  /** Page number (1-based) */
  page?: number;
  /** Items per page (max 1000) */
  perPage?: number;
  /** Filter by organization ID */
  organizationId?: string | null;
  /** Filter by user/provider ID */
  userId?: string | null;
  /** Filter sessions created on or after this date (inclusive) */
  dateFrom?: string | null;
  /** Filter sessions created on or before this date (inclusive) */
  dateTo?: string | null;
  /** Field to sort by: 'created_at' or 'updated_at' */
  sortBy?: string | null;
  /** Sort direction: 'asc' or 'desc' */
  sortOrder?: string | null;
};
export type GetV2AdminEncountersByEncounterIdApiResponse =
  /** status 200 OK */ AdminEncounterDetailResponse;
export type GetV2AdminEncountersByEncounterIdApiArg = {
  encounterId: string;
};
export type GetV2AdminEntitlementsApiResponse =
  /** status 200 OK */ EntitlementListResponse;
export type GetV2AdminEntitlementsApiArg = {
  /** Organization ID (required) */
  organizationId?: string | null;
  /** User ID (required) */
  userId?: string | null;
};
export type DeleteV2AdminEntitlementsUsageApiResponse =
  /** status 200 OK */ DeleteTestUsageResponse;
export type DeleteV2AdminEntitlementsUsageApiArg = void;
export type GetV2AdminEntitlementsUsageApiResponse =
  /** status 200 OK */ UsageEventListResponse;
export type GetV2AdminEntitlementsUsageApiArg = {
  /** Organization ID (required) */
  organizationId?: string | null;
  /** User ID (required) */
  userId?: string | null;
  /** Capability ID (required) */
  capabilityId?: string | null;
  /** Usage period: daily, weekly, monthly (required) */
  usagePeriod?: string | null;
  /** Page number */
  page?: number;
  /** Items per page */
  perPage?: number;
};
export type PostV2AdminEntitlementsUsageEmitApiResponse =
  /** status 200 OK */ EmitTestUsageResponse;
export type PostV2AdminEntitlementsUsageEmitApiArg = {
  emitTestUsageRequest: EmitTestUsageRequest;
};
export type GetV2AdminEventRegistryEventsApiResponse =
  /** status 200 OK */ EventRegistryResponse;
export type GetV2AdminEventRegistryEventsApiArg = void;
export type GetV2AdminFeedbackSessionsApiResponse =
  /** status 200 OK */ ListResponseFeedbackSessionListItemResponse;
export type GetV2AdminFeedbackSessionsApiArg = {
  /** Page number (1-based) */
  page?: number;
  /** Items per page (max 1000) */
  perPage?: number;
  /** Filter by provider/user ID */
  userId?: string | null;
  /** Filter by organization ID */
  organizationId?: string | null;
  /** Filter by note ID */
  noteId?: string | null;
  /** Filter by module ID (from section feedback) */
  moduleId?: string | null;
  /** Filter by start date (inclusive) */
  startDate?: string | null;
  /** Filter by end date (inclusive) */
  endDate?: string | null;
};
export type GetV2AdminFeedbackSessionsByNoteByNoteIdApiResponse =
  /** status 200 OK */ FeedbackSessionResponse;
export type GetV2AdminFeedbackSessionsByNoteByNoteIdApiArg = {
  noteId: string;
};
export type DeleteV2AdminFeedbackSessionsBySessionIdApiResponse =
  /** status 200 OK */ FeedbackSessionDeleteResponse;
export type DeleteV2AdminFeedbackSessionsBySessionIdApiArg = {
  sessionId: string;
};
export type GetV2AdminFeedbackSessionsBySessionIdApiResponse =
  /** status 200 OK */ AdminFeedbackSessionResponse;
export type GetV2AdminFeedbackSessionsBySessionIdApiArg = {
  sessionId: string;
};
export type PostV2AdminFormsCreateApiResponse =
  /** status 200 OK */ FormResponse;
export type PostV2AdminFormsCreateApiArg = {
  adminCreateFormRequest: AdminCreateFormRequest;
};
export type GetV2AdminJotauditDashboardEncountersApiResponse =
  /** status 200 OK */ EncounterAuditListResponse;
export type GetV2AdminJotauditDashboardEncountersApiArg = {
  /** Period in days */
  days?: number | null;
  /** Explicit start date (ISO 8601 format, e.g., 2024-01-01T00:00:00Z) */
  dateFrom?: string | null;
  /** Explicit end date (ISO 8601 format, e.g., 2024-01-31T23:59:59Z) */
  dateTo?: string | null;
  /** Comma-separated provider IDs to filter by */
  userIds?: string | null;
  /** Filter to encounters with/without audits (true=with audit, false=without audit) */
  hasAudit?: boolean | null;
  /** Page number (default 1) */
  page?: number;
  /** Items per page (default 20, max 100) */
  perPage?: number;
  /** Organization ID to filter encounters by (required for admin) */
  organizationId: string;
};
export type GetV2AdminJotauditDashboardEncountersByEncounterIdApiResponse =
  /** status 200 OK */ EncounterAuditDetailResponse;
export type GetV2AdminJotauditDashboardEncountersByEncounterIdApiArg = {
  encounterId: string;
  /** Organization ID for context (required for admin) */
  organizationId: string;
};
export type GetV2AdminJotauditDashboardNotesApiResponse =
  /** status 200 OK */ NoteAuditListResponse;
export type GetV2AdminJotauditDashboardNotesApiArg = void;
export type GetV2AdminJotauditDashboardNotesDetailByOrganizationIdAndNoteIdApiResponse =
  /** status 200 OK */ NoteAuditDetailResponse3;
export type GetV2AdminJotauditDashboardNotesDetailByOrganizationIdAndNoteIdApiArg =
  {
    organizationId: string;
    noteId: string;
  };
export type GetV2AdminJotauditDashboardNotesDetailByOrganizationIdAndNoteIdHistoryApiResponse =
  /** status 200 OK */ RevisionHistoryResponse;
export type GetV2AdminJotauditDashboardNotesDetailByOrganizationIdAndNoteIdHistoryApiArg =
  {
    organizationId: string;
    noteId: string;
  };
export type GetV2AdminJotauditDashboardNotesDetailByOrganizationIdAndNoteIdRevisionsRevisionApiResponse =
  /** status 200 OK */ AuditRevisionDetailResponse4;
export type GetV2AdminJotauditDashboardNotesDetailByOrganizationIdAndNoteIdRevisionsRevisionApiArg =
  {
    organizationId: string;
    noteId: string;
    revision: number;
  };
export type GetV2AdminJotauditDashboardNotesByOrganizationIdApiResponse =
  /** status 200 OK */ NoteAuditListResponse;
export type GetV2AdminJotauditDashboardNotesByOrganizationIdApiArg = {
  organizationId: string;
  /** Period in days */
  days?: number | null;
  /** Explicit start date (ISO 8601 format, e.g., 2024-01-01T00:00:00Z) */
  dateFrom?: string | null;
  /** Explicit end date (ISO 8601 format, e.g., 2024-01-31T23:59:59Z) */
  dateTo?: string | null;
  /** Comma-separated provider IDs to filter by */
  userIds?: string | null;
  /** Page number (default 1) */
  page?: number;
  /** Items per page (default 20, max 100) */
  perPage?: number;
  /** Minimum quality score (1-5) */
  minQualityScore?: number | null;
  /** Maximum quality score (1-5) */
  maxQualityScore?: number | null;
  /** Filter to only notes with CPT code mismatches */
  cptMismatchOnly?: boolean | null;
  /** Filter by completion status (true=completed/signed, false=unsigned/draft) */
  isCompleted?: boolean | null;
};
export type GetV2AdminJotauditDashboardOrganizationsApiResponse =
  /** status 200 OK */ OrganizationListResponse;
export type GetV2AdminJotauditDashboardOrganizationsApiArg = {
  /** Search organizations by name */
  search?: string | null;
  /** Page number (default 1) */
  page?: number;
  /** Items per page (default 20, max 100) */
  perPage?: number;
};
export type GetV2AdminJotauditDashboardProvidersApiResponse =
  /** status 200 OK */ ProviderListResponse;
export type GetV2AdminJotauditDashboardProvidersApiArg = void;
export type GetV2AdminJotauditDashboardProvidersByOrganizationIdApiResponse =
  /** status 200 OK */ ProviderListResponse;
export type GetV2AdminJotauditDashboardProvidersByOrganizationIdApiArg = {
  organizationId: string;
  /** Period in days (default 30) */
  days?: number | null;
  /** Explicit start date (ISO 8601 format, e.g., 2024-01-01T00:00:00Z) */
  dateFrom?: string | null;
  /** Explicit end date (ISO 8601 format, e.g., 2024-01-31T23:59:59Z) */
  dateTo?: string | null;
  /** Comma-separated provider IDs to filter by */
  userIds?: string | null;
};
export type GetV2AdminJotauditDashboardProvidersByOrganizationIdAndUserIdApiResponse =
  /** status 200 OK */ ProviderSummaryResponse2;
export type GetV2AdminJotauditDashboardProvidersByOrganizationIdAndUserIdApiArg =
  {
    organizationId: string;
    userId: string;
    /** Period in days (default 30) */
    days?: number | null;
    /** Explicit start date (ISO 8601 format, e.g., 2024-01-01T00:00:00Z) */
    dateFrom?: string | null;
    /** Explicit end date (ISO 8601 format, e.g., 2024-01-31T23:59:59Z) */
    dateTo?: string | null;
    /** Comma-separated provider IDs to filter by */
    userIds?: string | null;
  };
export type GetV2AdminJotauditDashboardRulesComplianceStatsByOrganizationIdApiResponse =
  /** status 200 OK */ RuleComplianceStatsListResponse;
export type GetV2AdminJotauditDashboardRulesComplianceStatsByOrganizationIdApiArg =
  {
    organizationId: string;
    /** Period in days */
    days?: number | null;
    /** Explicit start date (ISO 8601 format, e.g., 2024-01-01T00:00:00Z) */
    dateFrom?: string | null;
    /** Explicit end date (ISO 8601 format, e.g., 2024-01-31T23:59:59Z) */
    dateTo?: string | null;
    /** Comma-separated provider IDs to filter by */
    userIds?: string | null;
    /** Comma-separated rule IDs to filter by */
    ruleIds?: string | null;
    /** Include per-provider breakdown in aggregations */
    comparisonMode?: boolean | null;
  };
export type GetV2AdminJotauditDashboardRulesByRuleIdAuditsDrilldownAndOrganizationIdApiResponse =
  /** status 200 OK */ RuleAuditsListResponse;
export type GetV2AdminJotauditDashboardRulesByRuleIdAuditsDrilldownAndOrganizationIdApiArg =
  {
    ruleId: string;
    organizationId: string;
    /** Filter by compliance status: 'yes', 'warning', or 'no' */
    complianceStatus?: string | null;
    /** Period in days */
    days?: number | null;
    /** Explicit start date (ISO 8601 format, e.g., 2024-01-01T00:00:00Z) */
    dateFrom?: string | null;
    /** Explicit end date (ISO 8601 format, e.g., 2024-01-31T23:59:59Z) */
    dateTo?: string | null;
    /** Comma-separated provider IDs to filter by */
    userIds?: string | null;
    /** Page number (default 1) */
    page?: number;
    /** Items per page (default 20, max 100) */
    perPage?: number;
  };
export type GetV2AdminJotauditDashboardRulesByRuleIdAuditsAndOrganizationIdApiResponse =
  /** status 200 OK */ AuditsByRuleResponse;
export type GetV2AdminJotauditDashboardRulesByRuleIdAuditsAndOrganizationIdApiArg =
  {
    pathRuleId: string;
    organizationId: string;
    /** Rule ID to search for */
    queryRuleId: string;
    page?: number;
    perPage?: number;
  };
export type GetV2AdminJotauditDashboardRulesByRuleIdStatsAndOrganizationIdApiResponse =
  /** status 200 OK */ RuleDetailStatsResponse;
export type GetV2AdminJotauditDashboardRulesByRuleIdStatsAndOrganizationIdApiArg =
  {
    ruleId: string;
    organizationId: string;
    /** Period in days (default 30) */
    days?: number | null;
    /** Explicit start date (ISO 8601 format, e.g., 2024-01-01T00:00:00Z) */
    dateFrom?: string | null;
    /** Explicit end date (ISO 8601 format, e.g., 2024-01-31T23:59:59Z) */
    dateTo?: string | null;
    /** Comma-separated provider IDs to filter by */
    userIds?: string | null;
  };
export type GetV2AdminJotauditDashboardStatsApiResponse =
  /** status 200 OK */ GlobalDashboardStatsResponse;
export type GetV2AdminJotauditDashboardStatsApiArg = void;
export type GetV2AdminJotauditDashboardStatsByOrganizationIdApiResponse =
  /** status 200 OK */ OrgDashboardStatsResponse;
export type GetV2AdminJotauditDashboardStatsByOrganizationIdApiArg = {
  organizationId: string;
  /** Period in days (default 30) */
  days?: number | null;
  /** Explicit start date (ISO 8601 format, e.g., 2024-01-01T00:00:00Z) */
  dateFrom?: string | null;
  /** Explicit end date (ISO 8601 format, e.g., 2024-01-31T23:59:59Z) */
  dateTo?: string | null;
  /** Comma-separated provider IDs to filter by */
  userIds?: string | null;
};
export type PostV2AdminJotauditRunApiResponse =
  /** status 200 OK */ RunAuditResponse;
export type PostV2AdminJotauditRunApiArg = {
  runAuditRequest: RunAuditRequest;
};
export type GetV2AdminJotauditStatusByThreadIdApiResponse =
  /** status 200 OK */ AuditStatusResponse;
export type GetV2AdminJotauditStatusByThreadIdApiArg = {
  threadId: string;
};
export type PutV2AdminJotcredOrganizationsByOrganizationIdProvidersAndUserIdActionsApiResponse =
  /** status 200 OK */ AdminBasicResponse;
export type PutV2AdminJotcredOrganizationsByOrganizationIdProvidersAndUserIdActionsApiArg =
  {
    organizationId: string;
    userId: string;
    setActionItemsRequest: SetActionItemsRequest;
  };
export type PutV2AdminJotcredOrganizationsByOrganizationIdProvidersAndUserIdApplicationsAppIdApiResponse =
  /** status 200 OK */ AdminBasicResponse;
export type PutV2AdminJotcredOrganizationsByOrganizationIdProvidersAndUserIdApplicationsAppIdApiArg =
  {
    organizationId: string;
    userId: string;
    appId: string;
    updatePayerApplicationRequest: UpdatePayerApplicationRequest;
  };
export type GetV2AdminLearningRulesApiResponse =
  /** status 200 OK */ ListResponse;
export type GetV2AdminLearningRulesApiArg = void;
export type PostV2AdminLearningRulesApiResponse =
  /** status 200 OK */ LearningRuleResponse;
export type PostV2AdminLearningRulesApiArg = {
  createLearningRuleRequest: CreateLearningRuleRequest;
};
export type PostV2AdminLearningRulesSearchApiResponse =
  /** status 200 OK */ LearningRuleSearchResponse;
export type PostV2AdminLearningRulesSearchApiArg = {
  learningRuleSearchRequest: LearningRuleSearchRequest;
};
export type DeleteV2AdminLearningRulesByRuleIdApiResponse = unknown;
export type DeleteV2AdminLearningRulesByRuleIdApiArg = {
  ruleId: string;
};
export type GetV2AdminLearningRulesByRuleIdApiResponse =
  /** status 200 OK */ LearningRuleResponse;
export type GetV2AdminLearningRulesByRuleIdApiArg = {
  ruleId: string;
};
export type PutV2AdminLearningRulesByRuleIdApiResponse =
  /** status 200 OK */ LearningRuleResponse;
export type PutV2AdminLearningRulesByRuleIdApiArg = {
  ruleId: string;
  updateLearningRuleRequest: UpdateLearningRuleRequest;
};
export type PostV2AdminNoteProcessingRecoveryErroredSessionsApiResponse =
  /** status 200 OK */ RecoveryTaskResponse;
export type PostV2AdminNoteProcessingRecoveryErroredSessionsApiArg = {
  recoveryTaskRequest: RecoveryTaskRequest;
};
export type PostV2AdminNoteProcessingRecoveryStuckTranscriptionsApiResponse =
  /** status 200 OK */ RecoveryTaskResponse;
export type PostV2AdminNoteProcessingRecoveryStuckTranscriptionsApiArg = {
  recoveryTaskRequest: RecoveryTaskRequest;
};
export type GetV2AdminNoteProcessingSessionsBySessionIdApiResponse =
  /** status 200 OK */ AdminNoteProcessingSessionDetailResponse;
export type GetV2AdminNoteProcessingSessionsBySessionIdApiArg = {
  sessionId: string;
};
export type PostV2AdminNoteProcessingWorkflowsEncounterNoteFromV2TemplateApiResponse =
  /** status 200 OK */ EncounterNoteGenerationResponse;
export type PostV2AdminNoteProcessingWorkflowsEncounterNoteFromV2TemplateApiArg =
  {
    encounterNoteGenerationRequest: EncounterNoteGenerationRequest;
  };
export type GetV2AdminNoteProcessingWorkflowsStatusByTaskIdApiResponse =
  /** status 200 OK */ WorkflowStatusResponse;
export type GetV2AdminNoteProcessingWorkflowsStatusByTaskIdApiArg = {
  taskId: string;
};
export type PostV2AdminNotesWorkflowsEditNoteApiResponse =
  /** status 200 OK */ WorkflowResponse;
export type PostV2AdminNotesWorkflowsEditNoteApiArg = {
  editNoteRequest: EditNoteRequest;
};
export type GetV2AdminNotesWorkflowsStatusByTaskIdApiResponse =
  /** status 200 OK */ WorkflowStatusResponse;
export type GetV2AdminNotesWorkflowsStatusByTaskIdApiArg = {
  taskId: string;
};
export type GetV2AdminNotesByNoteIdApiResponse =
  /** status 200 OK */ AdminNoteDetailResponse;
export type GetV2AdminNotesByNoteIdApiArg = {
  noteId: string;
};
export type PostV2AdminNotesByNoteIdGeneratePdfApiResponse =
  /** status 200 OK */ GenerateNotePdfResponse;
export type PostV2AdminNotesByNoteIdGeneratePdfApiArg = {
  noteId: string;
};
export type GetV2AdminNotetemplatesApiResponse =
  /** status 200 OK */ AdminNoteTemplateListResponse;
export type GetV2AdminNotetemplatesApiArg = {
  /** Filter by scope: public, org, or user */
  scope?: string | null;
  /** Max results to return */
  limit?: number;
  /** Pagination offset */
  offset?: number;
};
export type PostV2AdminNotetemplatesApplyFeedbackApiResponse =
  /** status 200 OK */ ApplyFeedbackToTemplateResponse;
export type PostV2AdminNotetemplatesApplyFeedbackApiArg = {
  applyFeedbackToTemplateRequest: ApplyFeedbackToTemplateRequest;
};
export type PostV2AdminNotetemplatesBuildFromTemplateApiResponse =
  /** status 200 OK */ AdminTemplateBuildUploadResponse;
export type PostV2AdminNotetemplatesBuildFromTemplateApiArg = {
  adminTemplateBuildFromTemplateRequest: AdminTemplateBuildFromTemplateRequest;
};
export type PostV2AdminNotetemplatesBuildByTaskIdSaveApiResponse =
  /** status 200 OK */ AdminTemplateBuildSaveResponse;
export type PostV2AdminNotetemplatesBuildByTaskIdSaveApiArg = {
  taskId: string;
};
export type GetV2AdminNotetemplatesBuildByTaskIdStatusApiResponse =
  /** status 200 OK */ AdminTemplateBuildStatusResponse;
export type GetV2AdminNotetemplatesBuildByTaskIdStatusApiArg = {
  taskId: string;
};
export type PostV2AdminNotetemplatesConvertToOrgApiResponse =
  /** status 200 OK */ AdminCopyNoteTemplateResponse;
export type PostV2AdminNotetemplatesConvertToOrgApiArg = {
  adminConvertToOrgRequest: AdminConvertToOrgRequest;
};
export type PostV2AdminNotetemplatesCopyApiResponse =
  /** status 200 OK */ AdminCopyNoteTemplateResponse;
export type PostV2AdminNotetemplatesCopyApiArg = {
  adminCopyNoteTemplateRequest: AdminCopyNoteTemplateRequest;
};
export type PostV2AdminNotetemplatesForkForUserApiResponse =
  /** status 200 OK */ AdminForkTemplateForUserResponse;
export type PostV2AdminNotetemplatesForkForUserApiArg = {
  adminForkTemplateForUserRequest: AdminForkTemplateForUserRequest;
};
export type PostV2AdminNotetemplatesModelConversionCopyToNewApiResponse =
  /** status 200 OK */ CopyToNewTemplateResponse;
export type PostV2AdminNotetemplatesModelConversionCopyToNewApiArg = {
  copyToNewTemplateRequest: CopyToNewTemplateRequest;
};
export type PostV2AdminNotetemplatesModelConversionSaveApiResponse =
  /** status 200 OK */ SaveConvertedRevisionResponse;
export type PostV2AdminNotetemplatesModelConversionSaveApiArg = {
  saveConvertedRevisionRequest: SaveConvertedRevisionRequest;
};
export type PostV2AdminNotetemplatesModelConversionStartApiResponse =
  /** status 200 OK */ StartModelConversionResponse;
export type PostV2AdminNotetemplatesModelConversionStartApiArg = {
  startModelConversionRequest: StartModelConversionRequest;
};
export type GetV2AdminNotetemplatesModelConversionStatusByThreadIdApiResponse =
  /** status 200 OK */ ModelConversionStatusResponse;
export type GetV2AdminNotetemplatesModelConversionStatusByThreadIdApiArg = {
  threadId: string;
};
export type GetV2AdminNotetemplatesOrgByOrganizationIdApiResponse =
  /** status 200 OK */ AdminNoteTemplateListResponse;
export type GetV2AdminNotetemplatesOrgByOrganizationIdApiArg = {
  organizationId: string;
};
export type PostV2AdminNotetemplatesOrgByOrganizationIdApiResponse =
  /** status 200 OK */ AdminCopyNoteTemplateResponse;
export type PostV2AdminNotetemplatesOrgByOrganizationIdApiArg = {
  organizationId: string;
  adminCreateOrgTemplateRequest: AdminCreateOrgTemplateRequest;
};
export type GetV2AdminNotetemplatesProviderByProviderIdApiResponse =
  /** status 200 OK */ AdminProviderTemplateListResponse;
export type GetV2AdminNotetemplatesProviderByProviderIdApiArg = {
  providerId: string;
  /** Organization ID of the provider */
  organizationId: string;
};
export type GetV2AdminNotetemplatesUserByUserIdApiResponse =
  /** status 200 OK */ AdminNoteTemplateListResponse;
export type GetV2AdminNotetemplatesUserByUserIdApiArg = {
  userId: string;
};
export type DeleteV2AdminNotetemplatesUserByUserIdTemplatesAndTemplateIdApiResponse =
  /** status 200 OK */ AdminDeleteTemplateResponse;
export type DeleteV2AdminNotetemplatesUserByUserIdTemplatesAndTemplateIdApiArg =
  {
    userId: string;
    templateId: string;
  };
export type DeleteV2AdminNotetemplatesByTemplateIdApiResponse =
  /** status 200 OK */ AdminDeleteTemplateResponse;
export type DeleteV2AdminNotetemplatesByTemplateIdApiArg = {
  templateId: string;
};
export type GetV2AdminNotetemplatesByTemplateIdApiResponse =
  /** status 200 OK */ AdminGetNoteTemplateResponse;
export type GetV2AdminNotetemplatesByTemplateIdApiArg = {
  templateId: string;
};
export type PutV2AdminNotetemplatesByTemplateIdApiResponse =
  /** status 200 OK */ AdminUpdateNoteTemplateResponse;
export type PutV2AdminNotetemplatesByTemplateIdApiArg = {
  templateId: string;
  adminUpdateNoteTemplateRequest: AdminUpdateNoteTemplateRequest;
};
export type GetV2AdminNotetemplatesByTemplateIdRevisionsApiResponse =
  /** status 200 OK */ AdminListRevisionsResponse;
export type GetV2AdminNotetemplatesByTemplateIdRevisionsApiArg = {
  templateId: string;
};
export type GetV2AdminNotetemplatesByTemplateIdRevisionsAndVersionApiResponse =
  /** status 200 OK */ AdminGetRevisionResponse;
export type GetV2AdminNotetemplatesByTemplateIdRevisionsAndVersionApiArg = {
  templateId: string;
  version: number;
};
export type GetV2AdminObservabilityHoneycombNoteDebuggingUrlApiResponse =
  /** status 200 OK */ HoneycombUrlResponse;
export type GetV2AdminObservabilityHoneycombNoteDebuggingUrlApiArg = {
  /** Transcription session ID to search for */
  transcriptionId?: string | null;
  /** Note processing session ID to search for */
  noteProcessingId?: string | null;
  /** Note ID to search for */
  noteId?: string | null;
  /** UTC datetime to center the query around (+/- 1 hour) */
  centerTime?: string | null;
  /** Number of hours to look back from now (1-168 hours) */
  timeRangeHours?: number;
  /** Honeycomb team name */
  team?: string;
  /** Honeycomb environment */
  environment?: string;
};
export type GetV2AdminOrganizationsApiResponse =
  /** status 200 OK */ ListResponseAdminOrganizationResponse;
export type GetV2AdminOrganizationsApiArg = {
  /** Search organizations by name */
  search?: string | null;
  /** Page number (1-based) */
  page?: number;
  /** Items per page */
  perPage?: number;
};
export type GetV2AdminOrganizationsByOrganizationIdApiResponse =
  /** status 200 OK */ AdminOrganizationDetailResponse;
export type GetV2AdminOrganizationsByOrganizationIdApiArg = {
  organizationId: string;
};
export type PatchV2AdminOrganizationsByOrganizationIdApiResponse =
  /** status 200 OK */ UpdateOrganizationResponse;
export type PatchV2AdminOrganizationsByOrganizationIdApiArg = {
  organizationId: string;
  updateOrganizationRequest: UpdateOrganizationRequest;
};
export type PutV2AdminOrganizationsByOrganizationIdBaaApiResponse =
  /** status 200 OK */ AdminUpdateStatusResponse;
export type PutV2AdminOrganizationsByOrganizationIdBaaApiArg = {
  organizationId: string;
  adminUpdateStatusRequest: AdminUpdateStatusRequest;
};
export type GetV2AdminOrganizationsByOrganizationIdClinicDocumentsApiResponse =
  /** status 200 OK */ ClinicDocumentListResponse;
export type GetV2AdminOrganizationsByOrganizationIdClinicDocumentsApiArg = {
  organizationId: string;
  /** Filter by scope: organization, provider, patient */
  scopeType?: string | null;
  /** Filter by specific scope ID (provider_id or patient_id) */
  scopeId?: string | null;
  /** Filter by document kind: contract, fee_schedule, policy, etc. */
  docKind?: string | null;
  /** Filter by status: uploaded, metadata_ready, processing, processed, failed */
  processingStatus?: string | null;
  /** Search title, description, and filename (case-insensitive) */
  search?: string | null;
  /** Max results per page */
  limit?: number;
  /** Offset for pagination */
  offset?: number;
};
export type GetV2AdminOrganizationsByOrganizationIdClinicDocumentsSectionsAndSectionIdApiResponse =
  /** status 200 OK */ SectionDetailResponse;
export type GetV2AdminOrganizationsByOrganizationIdClinicDocumentsSectionsAndSectionIdApiArg =
  {
    organizationId: string;
    sectionId: string;
  };
export type GetV2AdminOrganizationsByOrganizationIdClinicDocumentsSectionsAndSectionIdContentApiResponse =
  /** status 200 OK */ SectionContentResponse;
export type GetV2AdminOrganizationsByOrganizationIdClinicDocumentsSectionsAndSectionIdContentApiArg =
  {
    organizationId: string;
    sectionId: string;
  };
export type GetV2AdminOrganizationsByOrganizationIdClinicDocumentsAndClinicDocumentIdApiResponse =
  /** status 200 OK */ ClinicDocumentDetailResponse;
export type GetV2AdminOrganizationsByOrganizationIdClinicDocumentsAndClinicDocumentIdApiArg =
  {
    organizationId: string;
    clinicDocumentId: string;
  };
export type GetV2AdminOrganizationsByOrganizationIdClinicDocumentsAndClinicDocumentIdExtractionResultsTaskNameApiResponse =
  /** status 200 OK */ ExtractionResultResponse;
export type GetV2AdminOrganizationsByOrganizationIdClinicDocumentsAndClinicDocumentIdExtractionResultsTaskNameApiArg =
  {
    organizationId: string;
    clinicDocumentId: string;
    taskName: string;
  };
export type GetV2AdminOrganizationsByOrganizationIdClinicDocumentsAndClinicDocumentIdFileApiResponse =
  unknown;
export type GetV2AdminOrganizationsByOrganizationIdClinicDocumentsAndClinicDocumentIdFileApiArg =
  {
    organizationId: string;
    clinicDocumentId: string;
    /** Content-Disposition: 'inline' for viewing in browser, 'attachment' for download */
    disposition?: "inline" | "attachment";
  };
export type GetV2AdminOrganizationsByOrganizationIdClinicDocumentsAndClinicDocumentIdSectionsApiResponse =
  /** status 200 OK */ ClinicDocumentSectionsResponse;
export type GetV2AdminOrganizationsByOrganizationIdClinicDocumentsAndClinicDocumentIdSectionsApiArg =
  {
    organizationId: string;
    clinicDocumentId: string;
  };
export type GetV2AdminOrganizationsByOrganizationIdClinicDocumentsAndClinicDocumentIdStatusApiResponse =
  /** status 200 OK */ ClinicDocumentStatusResponse;
export type GetV2AdminOrganizationsByOrganizationIdClinicDocumentsAndClinicDocumentIdStatusApiArg =
  {
    organizationId: string;
    clinicDocumentId: string;
  };
export type PutV2AdminOrganizationsByOrganizationIdCoiApiResponse =
  /** status 200 OK */ AdminUpdateStatusResponse;
export type PutV2AdminOrganizationsByOrganizationIdCoiApiArg = {
  organizationId: string;
  adminUpdateStatusRequest: AdminUpdateStatusRequest;
};
export type PostV2AdminOrganizationsByOrganizationIdCreateSubscriptionApiResponse =
  /** status 200 OK */ CreateSubscriptionResponse;
export type PostV2AdminOrganizationsByOrganizationIdCreateSubscriptionApiArg = {
  organizationId: string;
  createSubscriptionRequest: CreateSubscriptionRequest;
};
export type PutV2AdminOrganizationsByOrganizationIdDataRetentionApiResponse =
  /** status 200 OK */ AdminUpdateStatusResponse;
export type PutV2AdminOrganizationsByOrganizationIdDataRetentionApiArg = {
  organizationId: string;
  adminUpdateStatusRequest: AdminUpdateStatusRequest;
};
export type GetV2AdminOrganizationsByOrganizationIdDataSecurityApiResponse =
  /** status 200 OK */ CombinedDataSecurityStatusResponse;
export type GetV2AdminOrganizationsByOrganizationIdDataSecurityApiArg = {
  organizationId: string;
};
export type GetV2AdminOrganizationsByOrganizationIdDocumentsApiResponse =
  /** status 200 OK */ DocumentListResponse;
export type GetV2AdminOrganizationsByOrganizationIdDocumentsApiArg = {
  pathOrganizationId: string;
  /** Page number (1-based) */
  page?: number;
  /** Items per page */
  perPage?: number;
  /** Filter by document type (e.g., 'lab_order', 'claim', 'form') */
  documentType?: string | null;
  /** Filter by organization ID */
  queryOrganizationId?: string | null;
  /** Filter by patient ID */
  patientId?: string | null;
  /** Whether to include soft-deleted documents */
  includeDeleted?: boolean;
  /** Start date for filtering (ISO 8601 format) */
  startDate?: string | null;
  /** End date for filtering (ISO 8601 format) */
  endDate?: string | null;
  /** Text search on filename and document title */
  search?: string | null;
  /** Field to sort by (created_at, updated_at, filename, size_bytes) */
  sortBy?: string;
  /** Sort order (asc or desc) */
  sortOrder?: string;
};
export type GetV2AdminOrganizationsByOrganizationIdEprescriptionsPatientsSearchApiResponse =
  /** status 200 OK */ DosespotPatientSearchResponse;
export type GetV2AdminOrganizationsByOrganizationIdEprescriptionsPatientsSearchApiArg =
  {
    organizationId: string;
    firstname?: string | null;
    lastname?: string | null;
    dob?: string | null;
    page?: number;
  };
export type GetV2AdminOrganizationsByOrganizationIdEprescriptionsPatientsAndDosespotPatientIdApiResponse =
  /** status 200 OK */ DosespotPatientResponse;
export type GetV2AdminOrganizationsByOrganizationIdEprescriptionsPatientsAndDosespotPatientIdApiArg =
  {
    organizationId: string;
    dosespotPatientId: string;
  };
export type PutV2AdminOrganizationsByOrganizationIdEprescriptionsPatientsAndDosespotPatientIdApiResponse =
  /** status 200 OK */ DosespotPatientUpdateResponse;
export type PutV2AdminOrganizationsByOrganizationIdEprescriptionsPatientsAndDosespotPatientIdApiArg =
  {
    organizationId: string;
    dosespotPatientId: string;
  };
export type PostV2AdminOrganizationsByOrganizationIdExtendTrialApiResponse =
  /** status 200 OK */ ExtendTrialResponse;
export type PostV2AdminOrganizationsByOrganizationIdExtendTrialApiArg = {
  organizationId: string;
  extendTrialRequest: ExtendTrialRequest;
};
export type GetV2AdminOrganizationsByOrganizationIdFormsApiResponse =
  /** status 200 OK */ AdminFormListResponse;
export type GetV2AdminOrganizationsByOrganizationIdFormsApiArg = {
  organizationId: string;
};
export type PostV2AdminOrganizationsByOrganizationIdFormsApiResponse =
  /** status 200 OK */ AdminFormResponse2;
export type PostV2AdminOrganizationsByOrganizationIdFormsApiArg = {
  organizationId: string;
  adminFormCreateRequest: AdminFormCreateRequest;
};
export type DeleteV2AdminOrganizationsByOrganizationIdFormsAndFormIdApiResponse =
  /** status 200 OK */ ResourceActionResponse;
export type DeleteV2AdminOrganizationsByOrganizationIdFormsAndFormIdApiArg = {
  organizationId: string;
  formId: string;
};
export type GetV2AdminOrganizationsByOrganizationIdInvitationsApiResponse =
  /** status 200 OK */ ListResponseAdminInvitationResponse;
export type GetV2AdminOrganizationsByOrganizationIdInvitationsApiArg = {
  organizationId: string;
  /** Page number (1-based) */
  page?: number;
  /** Items per page (max 1000) */
  perPage?: number;
  /** Filter by status (pending, accepted, expired, cancelled) */
  status?: string | null;
  /** Filter by invited email address */
  email?: string | null;
  /** Include expired pending invitations */
  includeExpired?: boolean;
};
export type PostV2AdminOrganizationsByOrganizationIdInvitationsApiResponse =
  /** status 200 OK */ AdminInvitationResponse2;
export type PostV2AdminOrganizationsByOrganizationIdInvitationsApiArg = {
  organizationId: string;
  adminSendInvitationRequest: AdminSendInvitationRequest;
};
export type DeleteV2AdminOrganizationsByOrganizationIdInvitationsAndInvitationIdApiResponse =
  /** status 200 OK */ MemberActionResponse;
export type DeleteV2AdminOrganizationsByOrganizationIdInvitationsAndInvitationIdApiArg =
  {
    organizationId: string;
    invitationId: string;
  };
export type GetV2AdminOrganizationsByOrganizationIdInvitationsAndInvitationIdApiResponse =
  /** status 200 OK */ AdminInvitationDetailResponse;
export type GetV2AdminOrganizationsByOrganizationIdInvitationsAndInvitationIdApiArg =
  {
    organizationId: string;
    invitationId: string;
  };
export type PostV2AdminOrganizationsByOrganizationIdInvitationsAndInvitationIdResendApiResponse =
  /** status 200 OK */ MemberActionResponse;
export type PostV2AdminOrganizationsByOrganizationIdInvitationsAndInvitationIdResendApiArg =
  {
    organizationId: string;
    invitationId: string;
  };
export type PostV2AdminOrganizationsByOrganizationIdMembersApiResponse =
  /** status 200 OK */ MemberActionResponse;
export type PostV2AdminOrganizationsByOrganizationIdMembersApiArg = {
  organizationId: string;
  addMemberRequest: AddMemberRequest;
};
export type DeleteV2AdminOrganizationsByOrganizationIdMembersAndUserIdApiResponse =
  /** status 200 OK */ MemberActionResponse;
export type DeleteV2AdminOrganizationsByOrganizationIdMembersAndUserIdApiArg = {
  organizationId: string;
  userId: string;
  /** Specific role to remove (e.g., 'member', 'admin', 'clinician'). If not provided, removes all roles. */
  role?: string | null;
};
export type GetV2AdminOrganizationsByOrganizationIdMembersAndUserIdMembershipInfoApiResponse =
  /** status 200 OK */ MembershipInfoResponse;
export type GetV2AdminOrganizationsByOrganizationIdMembersAndUserIdMembershipInfoApiArg =
  {
    organizationId: string;
    userId: string;
  };
export type PatchV2AdminOrganizationsByOrganizationIdMembersAndUserIdMembershipInfoApiResponse =
  /** status 200 OK */ MembershipInfoResponse;
export type PatchV2AdminOrganizationsByOrganizationIdMembersAndUserIdMembershipInfoApiArg =
  {
    organizationId: string;
    userId: string;
    updateMembershipInfoRequest: UpdateMembershipInfoRequest;
  };
export type PostV2AdminOrganizationsByOrganizationIdMembersAndUserIdReactivateApiResponse =
  /** status 200 OK */ MemberActionResponse;
export type PostV2AdminOrganizationsByOrganizationIdMembersAndUserIdReactivateApiArg =
  {
    organizationId: string;
    userId: string;
  };
export type PatchV2AdminOrganizationsByOrganizationIdMembersAndUserIdRolesApiResponse =
  /** status 200 OK */ RoleActionResponse;
export type PatchV2AdminOrganizationsByOrganizationIdMembersAndUserIdRolesApiArg =
  {
    organizationId: string;
    userId: string;
    updateUserRolesRequest: UpdateUserRolesRequest;
  };
export type PostV2AdminOrganizationsByOrganizationIdMembersAndUserIdRolesApiResponse =
  /** status 200 OK */ RoleActionResponse;
export type PostV2AdminOrganizationsByOrganizationIdMembersAndUserIdRolesApiArg =
  {
    organizationId: string;
    userId: string;
    addUserRoleRequest: AddUserRoleRequest;
  };
export type PostV2AdminOrganizationsByOrganizationIdMergeApiResponse =
  /** status 200 OK */ MergeOrganizationsResponse;
export type PostV2AdminOrganizationsByOrganizationIdMergeApiArg = {
  organizationId: string;
  mergeOrganizationsRequest: MergeOrganizationsRequest;
};
export type GetV2AdminOrganizationsByOrganizationIdPatientVisibilityApiResponse =
  /** status 200 OK */ PatientVisibilityResponse;
export type GetV2AdminOrganizationsByOrganizationIdPatientVisibilityApiArg = {
  organizationId: string;
};
export type PatchV2AdminOrganizationsByOrganizationIdPatientVisibilityApiResponse =
  /** status 200 OK */ PatientVisibilityResponse;
export type PatchV2AdminOrganizationsByOrganizationIdPatientVisibilityApiArg = {
  organizationId: string;
  updatePatientVisibilityRequest: UpdatePatientVisibilityRequest;
};
export type GetV2AdminOrganizationsByOrganizationIdProvidersApiResponse =
  /** status 200 OK */ ListResponseAdminProviderResponse;
export type GetV2AdminOrganizationsByOrganizationIdProvidersApiArg = {
  organizationId: string;
};
export type GetV2AdminOrganizationsByOrganizationIdSubscriptionDashboardUrlApiResponse =
  /** status 200 OK */ SubscriptionDashboardUrlResponse;
export type GetV2AdminOrganizationsByOrganizationIdSubscriptionDashboardUrlApiArg =
  {
    organizationId: string;
  };
export type PostV2AdminOrganizationsByOrganizationIdSyncSubscriptionApiResponse =
  /** status 200 OK */ SyncSubscriptionResponse;
export type PostV2AdminOrganizationsByOrganizationIdSyncSubscriptionApiArg = {
  organizationId: string;
};
export type GetV2AdminOrganizationsByOrganizationIdTemplatesApiResponse =
  /** status 200 OK */ AdminTemplateListResponse;
export type GetV2AdminOrganizationsByOrganizationIdTemplatesApiArg = {
  organizationId: string;
};
export type PostV2AdminOrganizationsByOrganizationIdTemplatesApiResponse =
  /** status 200 OK */ AdminTemplateResponse2;
export type PostV2AdminOrganizationsByOrganizationIdTemplatesApiArg = {
  organizationId: string;
  adminTemplateCreateRequest: AdminTemplateCreateRequest;
};
export type DeleteV2AdminOrganizationsByOrganizationIdTemplatesAndTemplateIdApiResponse =
  /** status 200 OK */ ResourceActionResponse;
export type DeleteV2AdminOrganizationsByOrganizationIdTemplatesAndTemplateIdApiArg =
  {
    organizationId: string;
    templateId: string;
  };
export type PutV2AdminOrganizationsByOrganizationIdTemplatesAndTemplateIdApiResponse =
  /** status 200 OK */ AdminTemplateResponse2;
export type PutV2AdminOrganizationsByOrganizationIdTemplatesAndTemplateIdApiArg =
  {
    organizationId: string;
    templateId: string;
    adminTemplateUpdateRequest: AdminTemplateUpdateRequest;
  };
export type GetV2AdminOrgsByOrganizationIdBillingEntitiesApiResponse =
  /** status 200 OK */ BillingEntityListResponse;
export type GetV2AdminOrgsByOrganizationIdBillingEntitiesApiArg = {
  organizationId: string;
};
export type PostV2AdminOrgsByOrganizationIdBillingEntitiesApiResponse =
  /** status 200 OK */ BillingEntityResponse2;
export type PostV2AdminOrgsByOrganizationIdBillingEntitiesApiArg = {
  organizationId: string;
  createBillingEntityRequest: CreateBillingEntityRequest;
};
export type DeleteV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiResponse =
  /** status 200 OK */ BillingEntityDeleteResponse;
export type DeleteV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiArg =
  {
    organizationId: string;
    billingEntityId: string;
  };
export type GetV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiResponse =
  /** status 200 OK */ BillingEntityResponse2;
export type GetV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiArg =
  {
    organizationId: string;
    billingEntityId: string;
  };
export type PutV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiResponse =
  /** status 200 OK */ BillingEntityResponse2;
export type PutV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiArg =
  {
    organizationId: string;
    billingEntityId: string;
    updateBillingEntityRequest: UpdateBillingEntityRequest;
  };
export type GetV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdPayersPayerIdReadinessApiResponse =
  /** status 200 OK */ PayerReadinessResponse;
export type GetV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdPayersPayerIdReadinessApiArg =
  {
    organizationId: string;
    billingEntityId: string;
    payerId: string;
  };
export type PostV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdSetDefaultApiResponse =
  /** status 200 OK */ BillingEntityResponse2;
export type PostV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdSetDefaultApiArg =
  {
    organizationId: string;
    billingEntityId: string;
  };
export type PostV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdSyncToStediApiResponse =
  /** status 200 OK */ SyncToStediResponse;
export type PostV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdSyncToStediApiArg =
  {
    organizationId: string;
    billingEntityId: string;
  };
export type GetV2AdminOrgsByOrganizationIdBillingReadinessApiResponse =
  /** status 200 OK */ OrgBillingReadinessResponse;
export type GetV2AdminOrgsByOrganizationIdBillingReadinessApiArg = {
  organizationId: string;
};
export type GetV2AdminOrgsByOrganizationIdBillingPayerDocsApiResponse =
  /** status 200 OK */ PayerDocListResponse;
export type GetV2AdminOrgsByOrganizationIdBillingPayerDocsApiArg = {
  organizationId: string;
};
export type GetV2AdminOrgsByOrganizationIdBillingPayerDocsAndPayerKeyApiResponse =
  /** status 200 OK */ PayerDocResponse2;
export type GetV2AdminOrgsByOrganizationIdBillingPayerDocsAndPayerKeyApiArg = {
  organizationId: string;
  payerKey: string;
};
export type PutV2AdminOrgsByOrganizationIdBillingPayerDocsAndPayerKeyApiResponse =
  /** status 200 OK */ PayerDocResponse2;
export type PutV2AdminOrgsByOrganizationIdBillingPayerDocsAndPayerKeyApiArg = {
  organizationId: string;
  payerKey: string;
  payerDocUpsertRequest: PayerDocUpsertRequest;
};
export type GetV2AdminOrgsByOrganizationIdEnrollmentsApiResponse =
  /** status 200 OK */ EnrollmentListResponse;
export type GetV2AdminOrgsByOrganizationIdEnrollmentsApiArg = {
  organizationId: string;
};
export type PostV2AdminOrgsByOrganizationIdEnrollmentsApiResponse =
  /** status 200 OK */ EnrollmentResponse2;
export type PostV2AdminOrgsByOrganizationIdEnrollmentsApiArg = {
  organizationId: string;
  initiateEnrollmentRequest: InitiateEnrollmentRequest;
};
export type PostV2AdminOrgsByOrganizationIdEnrollmentsSyncAllApiResponse =
  /** status 200 OK */ SyncAllResponse;
export type PostV2AdminOrgsByOrganizationIdEnrollmentsSyncAllApiArg = {
  organizationId: string;
};
export type GetV2AdminOrgsByOrganizationIdEnrollmentsAndEnrollmentIdApiResponse =
  /** status 200 OK */ EnrollmentResponse2;
export type GetV2AdminOrgsByOrganizationIdEnrollmentsAndEnrollmentIdApiArg = {
  organizationId: string;
  enrollmentId: string;
};
export type PostV2AdminOrgsByOrganizationIdEnrollmentsAndEnrollmentIdSyncApiResponse =
  /** status 200 OK */ EnrollmentResponse2;
export type PostV2AdminOrgsByOrganizationIdEnrollmentsAndEnrollmentIdSyncApiArg =
  {
    organizationId: string;
    enrollmentId: string;
  };
export type GetV2AdminOrgsByOrganizationIdRemittancesApiResponse =
  /** status 200 OK */ RemittanceListResponse;
export type GetV2AdminOrgsByOrganizationIdRemittancesApiArg = {
  organizationId: string;
  /** Page number (1-based) */
  page?: number;
  /** Number of items per page (max 100) */
  perPage?: number;
  /** Filter: earliest created_at date (YYYY-MM-DD) */
  dateFrom?: string | null;
  /** Filter: latest created_at date (YYYY-MM-DD) */
  dateTo?: string | null;
};
export type GetV2AdminOrgsByOrganizationIdRemittancesClaimsAndClaimIdSummaryApiResponse =
  /** status 200 OK */ ClaimRemittanceSummaryResponse;
export type GetV2AdminOrgsByOrganizationIdRemittancesClaimsAndClaimIdSummaryApiArg =
  {
    organizationId: string;
    claimId: string;
  };
export type GetV2AdminOrgsByOrganizationIdRemittancesAndRemittanceIdApiResponse =
  /** status 200 OK */ RemittanceDetailResponse;
export type GetV2AdminOrgsByOrganizationIdRemittancesAndRemittanceIdApiArg = {
  organizationId: string;
  remittanceId: string;
};
export type PostV2AdminOrgsByOrganizationIdStediConnectApiResponse =
  /** status 200 OK */ ConnectStediResponse;
export type PostV2AdminOrgsByOrganizationIdStediConnectApiArg = {
  organizationId: string;
  connectStediRequest: ConnectStediRequest;
};
export type DeleteV2AdminOrgsByOrganizationIdStediDisconnectApiResponse =
  /** status 200 OK */ DisconnectStediResponse;
export type DeleteV2AdminOrgsByOrganizationIdStediDisconnectApiArg = {
  organizationId: string;
};
export type GetV2AdminOrgsByOrganizationIdStediStatusApiResponse =
  /** status 200 OK */ StediConnectionStatusResponse;
export type GetV2AdminOrgsByOrganizationIdStediStatusApiArg = {
  organizationId: string;
};
export type GetV2AdminOrgsByOrganizationIdStediTransactionsApiResponse =
  /** status 200 OK */ StediTransactionListResponse;
export type GetV2AdminOrgsByOrganizationIdStediTransactionsApiArg = {
  organizationId: string;
  /** Results per page (1-500, default 100) */
  pageSize?: number | null;
  /** Cursor token from a previous response for pagination */
  pageToken?: string | null;
  /** ISO 8601 start of time range filter (e.g., 2026-02-01T00:00:00Z) */
  fromDate?: string | null;
  /** ISO 8601 end of time range filter */
  toDate?: string | null;
  /** Filter by direction: INBOUND, OUTBOUND, or UNKNOWN */
  direction?: string | null;
  /** Filter by mode: test, production, or other */
  mode?: string | null;
  /** Filter by status: failed or succeeded */
  status?: string | null;
  /** X12 transaction set code (e.g., 277, 835, 837) */
  transactionSetId?: string | null;
};
export type GetV2AdminOrgsByOrganizationIdStediTransactionsAndTransactionIdApiResponse =
  /** status 200 OK */ StediTransactionDetailResponse;
export type GetV2AdminOrgsByOrganizationIdStediTransactionsAndTransactionIdApiArg =
  {
    organizationId: string;
    transactionId: string;
  };
export type PostV2AdminOrgsByOrganizationIdStediVerifyApiResponse =
  /** status 200 OK */ VerifyStediResponse;
export type PostV2AdminOrgsByOrganizationIdStediVerifyApiArg = {
  organizationId: string;
};
export type PostV2AdminPatientIntelligenceRegenerateApiResponse =
  /** status 200 OK */ RegeneratePatientIntelligenceResponse;
export type PostV2AdminPatientIntelligenceRegenerateApiArg = {
  regeneratePatientIntelligenceRequest: RegeneratePatientIntelligenceRequest;
};
export type PostV2AdminPayersSyncApiResponse =
  /** status 202 Accepted */ PayerSyncResponse;
export type PostV2AdminPayersSyncApiArg = void;
export type GetV2AdminPayersSyncStatusApiResponse =
  /** status 200 OK */ PayerSyncStatusResponse;
export type GetV2AdminPayersSyncStatusApiArg = void;
export type GetV2AdminProspectsApiResponse =
  /** status 200 OK */ ProspectListResponse;
export type GetV2AdminProspectsApiArg = {
  /** Page number (1-indexed) */
  page?: number;
  /** Items per page (max 100) */
  pageSize?: number;
  /** Filter by organization name (partial match) */
  organization?: string | null;
  /** Filter by email (partial match) */
  email?: string | null;
  /** Filter by enrichment status (true=enriched, false=pending) */
  enriched?: boolean | null;
  /** Field to sort by: created_at, updated_at, organization, name, email */
  sortBy?: string;
  /** Sort order: asc or desc */
  sortOrder?: string;
};
export type GetV2AdminProspectsByProspectSegmentIdApiResponse =
  /** status 200 OK */ ProspectResponse2;
export type GetV2AdminProspectsByProspectSegmentIdApiArg = {
  prospectSegmentId: number;
};
export type GetV2AdminProvidersByProviderIdApiResponse =
  /** status 200 OK */ AdminProviderLookupResponse;
export type GetV2AdminProvidersByProviderIdApiArg = {
  providerId: string;
};
export type GetV2AdminProvidersByProviderIdAppointmentsApiResponse =
  /** status 200 OK */ ListResponseAdminAppointmentResponse;
export type GetV2AdminProvidersByProviderIdAppointmentsApiArg = {
  providerId: string;
};
export type GetV2AdminProvidersByProviderIdEncounterTypesApiResponse =
  /** status 200 OK */ ListResponseEncounterTypeResponse;
export type GetV2AdminProvidersByProviderIdEncounterTypesApiArg = {
  providerId: string;
};
export type PostV2AdminProvidersByProviderIdEncounterTypesApiResponse =
  /** status 201 Created */ EncounterTypeResponse2;
export type PostV2AdminProvidersByProviderIdEncounterTypesApiArg = {
  providerId: string;
  encounterTypeCreate: EncounterTypeCreate;
};
export type DeleteV2AdminProvidersByProviderIdEncounterTypesAndEncounterTypeIdApiResponse =
  unknown;
export type DeleteV2AdminProvidersByProviderIdEncounterTypesAndEncounterTypeIdApiArg =
  {
    providerId: string;
    encounterTypeId: string;
  };
export type GetV2AdminProvidersByProviderIdEncounterTypesAndEncounterTypeIdApiResponse =
  /** status 200 OK */ EncounterTypeResponse2;
export type GetV2AdminProvidersByProviderIdEncounterTypesAndEncounterTypeIdApiArg =
  {
    providerId: string;
    encounterTypeId: string;
  };
export type PatchV2AdminProvidersByProviderIdEncounterTypesAndEncounterTypeIdApiResponse =
  /** status 200 OK */ EncounterTypeResponse2;
export type PatchV2AdminProvidersByProviderIdEncounterTypesAndEncounterTypeIdApiArg =
  {
    providerId: string;
    encounterTypeId: string;
    encounterTypeUpdate: EncounterTypeUpdate;
  };
export type GetV2AdminProvidersByProviderIdEncountersApiResponse =
  /** status 200 OK */ ListResponseAdminEncounterResponse;
export type GetV2AdminProvidersByProviderIdEncountersApiArg = {
  providerId: string;
};
export type DeleteV2AdminProvidersByProviderIdGoogleSyncApiResponse =
  /** status 200 OK */ DeleteGoogleCalendarConfigResponse;
export type DeleteV2AdminProvidersByProviderIdGoogleSyncApiArg = {
  providerId: string;
};
export type PostV2AdminProvidersByProviderIdGoogleSyncApiResponse =
  /** status 200 OK */ InitiateSyncResponse;
export type PostV2AdminProvidersByProviderIdGoogleSyncApiArg = {
  providerId: string;
};
export type GetV2AdminProvidersByProviderIdGoogleSyncStatusApiResponse =
  /** status 200 OK */ GoogleSyncStatusResponse;
export type GetV2AdminProvidersByProviderIdGoogleSyncStatusApiArg = {
  providerId: string;
};
export type GetV2AdminProvidersByProviderIdNoteProcessingSessionsApiResponse =
  /** status 200 OK */ ListResponseAdminNoteProcessingSessionListItem;
export type GetV2AdminProvidersByProviderIdNoteProcessingSessionsApiArg = {
  providerId: string;
  /** Page number (1-based) */
  page?: number;
  /** Items per page */
  perPage?: number;
  /** Filter by encounter ID */
  encounterId?: string | null;
  /** Filter by transcription session ID */
  transcriptionSessionId?: string | null;
  /** Filter by note ID */
  noteId?: string | null;
  /** Filter by status */
  status?: string | null;
  /** Text search */
  search?: string | null;
};
export type GetV2AdminProvidersByProviderIdNotesApiResponse =
  /** status 200 OK */ ListResponseAdminNoteListItem;
export type GetV2AdminProvidersByProviderIdNotesApiArg = {
  providerId: string;
};
export type PatchV2AdminProvidersByProviderIdProfileApiResponse =
  /** status 200 OK */ AdminProviderProfileUpdateResponse;
export type PatchV2AdminProvidersByProviderIdProfileApiArg = {
  providerId: string;
  updateProviderProfileRequest: UpdateProviderProfileRequest;
};
export type GetV2AdminProvidersByProviderIdTranscriptionsApiResponse =
  /** status 200 OK */ ListResponseAdminTranscriptionSessionResponse;
export type GetV2AdminProvidersByProviderIdTranscriptionsApiArg = {
  providerId: string;
};
export type GetV2AdminRolesApiResponse =
  /** status 200 OK */ AvailableRolesResponse;
export type GetV2AdminRolesApiArg = void;
export type GetV2AdminRulesApiResponse =
  /** status 200 OK */ ProviderRuleListResponse;
export type GetV2AdminRulesApiArg = {
  /** Page number (1-based) */
  page?: number;
  /** Items per page (max 1000) */
  perPage?: number;
  /** Filter by organization ID */
  organizationId?: string | null;
  /** Filter by scope: 'global', 'org', or 'both' (default) */
  scope?: RuleScope;
  /** Filter by rule type: 'compliance' or 'learning' */
  ruleType?: string | null;
};
export type PostV2AdminRulesApiResponse = /** status 200 OK */ RuleResponse;
export type PostV2AdminRulesApiArg = {
  createRuleRequest: CreateRuleRequest;
};
export type GetV2AdminRulesSearchApiResponse =
  /** status 200 OK */ ProviderRuleSearchResponse;
export type GetV2AdminRulesSearchApiArg = {
  /** Search query text */
  q: string;
  /** Number of top results */
  topK?: number;
  /** Filter by organization ID */
  organizationId?: string | null;
  /** Filter by rule type: 'compliance' or 'learning' */
  ruleType?: string | null;
};
export type PostV2AdminRulesSearchApiResponse =
  /** status 200 OK */ RuleSearchResponse;
export type PostV2AdminRulesSearchApiArg = {
  ruleSearchRequest: RuleSearchRequest;
};
export type DeleteV2AdminRulesByRuleIdApiResponse = unknown;
export type DeleteV2AdminRulesByRuleIdApiArg = {
  ruleId: string;
};
export type GetV2AdminRulesByRuleIdApiResponse =
  /** status 200 OK */ ProviderRuleResponse2;
export type GetV2AdminRulesByRuleIdApiArg = {
  ruleId: string;
};
export type PutV2AdminRulesByRuleIdApiResponse =
  /** status 200 OK */ RuleResponse;
export type PutV2AdminRulesByRuleIdApiArg = {
  ruleId: string;
  updateRuleRequest: UpdateRuleRequest;
};
export type PostV2AdminRulesByRuleIdDisableApiResponse =
  /** status 200 OK */ ProviderRuleDisableResponse;
export type PostV2AdminRulesByRuleIdDisableApiArg = {
  ruleId: string;
  adminRuleDisableRequest: AdminRuleDisableRequest;
};
export type PostV2AdminRulesByRuleIdEnableApiResponse =
  /** status 200 OK */ ProviderRuleDisableResponse;
export type PostV2AdminRulesByRuleIdEnableApiArg = {
  ruleId: string;
  adminRuleDisableRequest: AdminRuleDisableRequest;
};
export type PostV2AdminRulesByRuleIdForkApiResponse =
  /** status 200 OK */ ProviderRuleForkResponse;
export type PostV2AdminRulesByRuleIdForkApiArg = {
  ruleId: string;
  adminRuleForkRequest: AdminRuleForkRequest;
};
export type PostV2AdminRulesByRuleIdRevertApiResponse =
  /** status 200 OK */ ProviderRuleUpdateResponse;
export type PostV2AdminRulesByRuleIdRevertApiArg = {
  ruleId: string;
  adminRuleRevertRequest: AdminRuleRevertRequest;
};
export type GetV2AdminRulesByRuleIdRevisionsApiResponse =
  /** status 200 OK */ ProviderRuleRevisionsResponse;
export type GetV2AdminRulesByRuleIdRevisionsApiArg = {
  ruleId: string;
};
export type GetV2AdminTemplatesAsyncTaskStatusApiResponse =
  /** status 200 OK */ AsyncTaskStatusResponse;
export type GetV2AdminTemplatesAsyncTaskStatusApiArg = {
  /** Async task ID to check status for */
  asyncTaskId: string;
};
export type PostV2AdminTemplatesConvertApiResponse =
  /** status 200 OK */ ConvertLegacyTemplateResponse;
export type PostV2AdminTemplatesConvertApiArg = {
  convertLegacyTemplateRequest: ConvertLegacyTemplateRequest;
};
export type PostV2AdminTemplatesCopyApiResponse =
  /** status 200 OK */ CopyTemplatesResponse;
export type PostV2AdminTemplatesCopyApiArg = {
  copyTemplatesRequest: CopyTemplatesRequest;
};
export type PostV2AdminTemplatesSingleModuleGenerationApiResponse =
  /** status 200 OK */ SingleModuleGenerationResponse;
export type PostV2AdminTemplatesSingleModuleGenerationApiArg = {
  singleModuleGenerationRequest: SingleModuleGenerationRequest;
};
export type GetV2AdminTemplatesUserTemplatesApiResponse =
  /** status 200 OK */ UserTemplateListResponse;
export type GetV2AdminTemplatesUserTemplatesApiArg = {
  /** Filter templates by specific user/provider ID */
  userId?: string | null;
  /** Search templates by name or content */
  searchQuery?: string | null;
};
export type GetV2AdminTranscriptionsByTranscriptionSessionIdApiResponse =
  /** status 200 OK */ AdminTranscriptionDetailResponse;
export type GetV2AdminTranscriptionsByTranscriptionSessionIdApiArg = {
  transcriptionSessionId: string;
};
export type PostV2AdminUploadCsvProspectsApiResponse =
  /** status 200 OK */ CustomerInsightsSyncResponse;
export type PostV2AdminUploadCsvProspectsApiArg = void;
export type PostV2AdminUploadCsvProvidersApiResponse =
  /** status 200 OK */ CustomerInsightsSyncResponse;
export type PostV2AdminUploadCsvProvidersApiArg = void;
export type DeleteV2AdminUsersByUserIdVoiceEnrollmentApiResponse =
  /** status 200 OK */ VoiceEnrollmentResetResponse;
export type DeleteV2AdminUsersByUserIdVoiceEnrollmentApiArg = {
  userId: string;
};
export type GetV2AdminUsersByUserIdVoiceEnrollmentApiResponse =
  /** status 200 OK */ VoiceEnrollmentStatusResponse;
export type GetV2AdminUsersByUserIdVoiceEnrollmentApiArg = {
  userId: string;
};
export type AgentChatRequest = {
  /** Model override (default: server-configured model) */
  model?: string | null;
  /** The user's message to send to the admin agent */
  prompt: string;
  /** Session ID to resume an existing conversation */
  session_id?: string | null;
  /** Skill name (e.g., 'general-admin', 'create-user-dossier') */
  skill?: string | null;
};
export type ExportPdfRequest = {
  /** Markdown content to render as PDF */
  markdown: string;
  /** Document title (used for filename) */
  title: string;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
export type CustomerInsightsRequestResponse = {
  /** Request status (accepted for async processing) */
  status: string;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type ExternalProviderAnalyzeRequest = {
  /** Provider email address */
  email: string;
  /** Provider name to analyze */
  provider_name: string;
};
export type CustomerInsightsAnalyzeRequest = {
  /** Provider ID if known */
  provider_id?: string | null;
  /** Provider name to analyze */
  provider_name?: string | null;
};
export type AvailableFeatureFlagsResponse = {
  /** List of all available feature flag names (sorted alphabetically) */
  feature_flags: string[];
};
export type OrganizationFeatureFlagStats = {
  /** Organization ID */
  organization_id: string;
  /** Organization name (enriched) */
  organization_name?: string | null;
  /** Number of users in this organization with the flag */
  user_count: number;
};
export type FeatureFlagByOrganizationResponse = {
  /** Name of the feature flag */
  feature_name: string;
  /** Breakdown by organization */
  organizations: OrganizationFeatureFlagStats[];
  /** Total users with the flag enabled */
  total_users: number;
  /** Users with flag enabled but no organization */
  users_without_organization: number;
};
export type FeatureFlagStatsResponse = {
  /** Number of users with flag disabled */
  disabled_count: number;
  /** Number of users with flag enabled */
  enabled_count: number;
  /** Name of the feature flag */
  feature_name: string;
};
export type GateSummaryResponse = {
  /** Gate description */
  description?: string | null;
  /** Unique gate identifier */
  id: string;
  /** Whether the gate is enabled */
  is_enabled: boolean;
  /** Name of last modifier */
  last_modifier_name?: string | null;
  /** Gate name */
  name: string;
};
export type ListGatesResponse = {
  /** List of feature gates */
  gates: GateSummaryResponse[];
};
export type GateOverridesResponse = {
  /** User IDs that will always fail the gate */
  failing_user_ids?: string[];
  /** Gate ID */
  gate_id: string;
  /** User IDs that will always pass the gate */
  passing_user_ids?: string[];
};
export type AddGateOverridesRequest = {
  /** User IDs to add to failing overrides */
  failing_user_ids?: string[] | null;
  /** User IDs to add to passing overrides */
  passing_user_ids?: string[] | null;
};
export type UpdateGateOverridesRequest = {
  /** User IDs that should always fail the gate. If provided, replaces all existing failing overrides. */
  failing_user_ids?: string[] | null;
  /** User IDs that should always pass the gate. If provided, replaces all existing passing overrides. */
  passing_user_ids?: string[] | null;
};
export type RemoveGateOverridesRequest = {
  /** User IDs to remove from failing overrides */
  failing_user_ids?: string[] | null;
  /** User IDs to remove from passing overrides */
  passing_user_ids?: string[] | null;
};
export type UserGateStatusResponse = {
  /** Gate description */
  description?: string | null;
  /** What the user would see (gate evaluation without logging exposure) */
  evaluated_result: boolean;
  /** Gate identifier */
  gate_id: string;
  /** Whether the gate is globally enabled */
  is_enabled: boolean;
  /** Gate name */
  name: string;
  /** User's override status: 'pass', 'fail', or null if no override */
  override_status?: string | null;
};
export type UserGatesResponse = {
  /** List of gate statuses for this user */
  gates: UserGateStatusResponse[];
  /** User ID */
  user_id: string;
};
export type MaterializationResultResponse = {
  dry_run: boolean;
  errors: string[];
  parameters?: {
    [key: string]: any;
  } | null;
  processing_time_seconds: number;
  task_id?: string | null;
  task_name?: string | null;
  total_appointments_created: number;
  total_series_processed: number;
};
export type MaterializationTaskResponse = {
  message: string;
  parameters: {
    [key: string]: any;
  };
  status: string;
  task_id: string;
};
export type MaterializationRequest = {
  /** If true, runs asynchronously via Celery */
  async_mode?: boolean;
  /** Number of series to process per batch */
  batch_size?: number;
  /** Number of days ahead to materialize appointments */
  days_ahead?: number;
  /** If true, simulates the materialization without creating appointments */
  dry_run?: boolean;
  /** List of provider IDs to process. If None, processes all providers. */
  provider_ids?: string[] | null;
};
export type MaterializationResultResponse2 = {
  dry_run: boolean;
  errors: string[];
  parameters?: {
    [key: string]: any;
  } | null;
  processing_time_seconds: number;
  task_id?: string | null;
  task_name?: string | null;
  total_appointments_created: number;
  total_series_processed: number;
};
export type TaskStatusResponse = {
  error?: string | null;
  message?: string | null;
  progress?: {
    [key: string]: any;
  } | null;
  ready: boolean;
  result?: MaterializationResultResponse2 | null;
  status: string;
  task_id: string;
  traceback?: string | null;
};
export type AdminAppointmentDetail = {
  appointment_id: string;
  created_at?: string | null;
  duration?: number | null;
  encounter_type?: string | null;
  encounter_type_id?: string | null;
  organization_id?: string | null;
  patient_id?: string | null;
  provider_id?: string | null;
  start_time?: string | null;
  status?: string | null;
  telehealth?: boolean | null;
  template_id?: string | null;
  title?: string | null;
  updated_at?: string | null;
};
export type AdminEncounterSummary = {
  appointment_id?: string | null;
  created_at?: string | null;
  encounter_id: string;
  encounter_type?: string | null;
  input_documents?: number | null;
  patient_id?: string | null;
  status?: string | null;
  updated_at?: string | null;
};
export type AdminNoteSummary = {
  created_at?: string | null;
  encounter_type?: string | null;
  has_feedback?: boolean | null;
  note_id: string;
  patient_id?: string | null;
  patient_name?: string | null;
  status?: string | null;
  template?: string | null;
};
export type AdminProviderSummary = {
  email?: string | null;
  last_login_time?: string | null;
  name?: string | null;
  organization_id?: string | null;
  organization_name?: string | null;
  provider_id: string;
  role?: string | null;
};
export type AdminTranscriptionSummary = {
  chunk_count?: number | null;
  created_at?: string | null;
  is_closed?: boolean | null;
  job_status?: string | null;
  notes_created?: number | null;
  start_time?: string | null;
  transcription_session_id: string;
};
export type AdminAppointmentDetailResponse = {
  appointment: AdminAppointmentDetail;
  encounter?: AdminEncounterSummary | null;
  notes: AdminNoteSummary[];
  provider: AdminProviderSummary;
  transcriptions: AdminTranscriptionSummary[];
};
export type OrganizationBillingSummary = {
  active_billing_providers?: number;
  claims_created_last_30d?: number;
  claims_draft?: number;
  claims_in_flight?: number;
  claims_needs_attention?: number;
  claims_paid?: number;
  claims_ready?: number;
  claims_submitted_last_30d?: number;
  collection_rate_pct?: number | null;
  denial_count?: number;
  denial_rate_pct?: number | null;
  last_claim_created_at?: string | null;
  last_remittance_at?: string | null;
  last_submission_at?: string | null;
  oldest_draft_age_days?: number | null;
  oldest_ready_age_days?: number | null;
  organization_id: string;
  organization_name?: string | null;
  rejection_count?: number;
  remittances_received?: number;
  reversal_count?: number;
  total_balance_cents?: number;
  total_charge_cents?: number;
  total_claims?: number;
  total_paid_cents?: number;
  total_remittance_payment_cents?: number;
  unmatched_remittance_claims?: number;
};
export type OrganizationBillingListResponse = {
  has_more?: boolean;
  organizations?: OrganizationBillingSummary[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type OrganizationBillingDetailResponse = {
  active_billing_providers?: number;
  claims_created_last_30d?: number;
  claims_draft?: number;
  claims_in_flight?: number;
  claims_needs_attention?: number;
  claims_paid?: number;
  claims_ready?: number;
  claims_submitted_last_30d?: number;
  collection_rate_pct?: number | null;
  denial_count?: number;
  denial_rate_pct?: number | null;
  encounters_ready_to_bill?: number | null;
  last_claim_created_at?: string | null;
  last_remittance_at?: string | null;
  last_submission_at?: string | null;
  oldest_draft_age_days?: number | null;
  oldest_ready_age_days?: number | null;
  organization_id: string;
  organization_name?: string | null;
  rejection_count?: number;
  remittances_received?: number;
  reversal_count?: number;
  total_balance_cents?: number;
  total_charge_cents?: number;
  total_claims?: number;
  total_paid_cents?: number;
  total_remittance_payment_cents?: number;
  unmatched_remittance_claims?: number;
};
export type CustomerInsightsSyncResponse = {
  /** Number of rows processed from CSV (for CSV uploads) */
  csv_rows_processed?: number | null;
  /** List of errors encountered during processing */
  errors: string[];
  /** Request status (completed for sync processing) */
  status: string;
  /** Number of providers requested for analysis */
  total_requested: number;
};
export type ExternalProviderData = {
  /** Provider email address */
  email: string;
  /** Provider name to analyze */
  provider_name: string;
};
export type CustomerInsightsBulkAnalyzeRequest = {
  /** True for provider IDs, False for external provider data */
  existing_users: boolean;
  /** List of external provider data (when existing_users=False) */
  external_providers?: ExternalProviderData[] | null;
  /** List of emails matching provider_names (when existing_users=False) */
  provider_emails?: string[] | null;
  /** List of provider IDs (when existing_users=True) */
  provider_ids?: string[] | null;
  /** Whether to sync providers to Customer.io after processing (default: False for admin endpoints) */
  sync_to_customerio?: boolean;
};
export type BundleAssignmentResponse = {
  /** Assignment UUID */
  assignment_id: string;
  /** Bundle UUID */
  bundle_id: string;
  /** Bundle name */
  bundle_name?: string | null;
  /** Bundle type: 'tier', 'add_on', or 'data_security' */
  bundle_type?: string | null;
  /** Created timestamp */
  created_at: string;
  /** Effective from timestamp */
  effective_from: string;
  /** Effective to timestamp */
  effective_to?: string | null;
  /** Organization UUID */
  organization_id?: string | null;
  /** Assignment source (stripe, manual, trial) */
  source: string;
  /** Status (pending, active, canceled, expired) */
  status: string;
  /** Stripe subscription item ID */
  stripe_subscription_item_id?: string | null;
  /** Last updated timestamp */
  updated_at: string;
  /** User ID */
  user_id?: string | null;
};
export type BundleAssignmentListResponse = {
  /** List of assignments */
  assignments?: BundleAssignmentResponse[];
};
export type BundleAssignmentResponse2 = {
  /** Assignment UUID */
  assignment_id: string;
  /** Bundle UUID */
  bundle_id: string;
  /** Bundle name */
  bundle_name?: string | null;
  /** Bundle type: 'tier', 'add_on', or 'data_security' */
  bundle_type?: string | null;
  /** Created timestamp */
  created_at: string;
  /** Effective from timestamp */
  effective_from: string;
  /** Effective to timestamp */
  effective_to?: string | null;
  /** Organization UUID */
  organization_id?: string | null;
  /** Assignment source (stripe, manual, trial) */
  source: string;
  /** Status (pending, active, canceled, expired) */
  status: string;
  /** Stripe subscription item ID */
  stripe_subscription_item_id?: string | null;
  /** Last updated timestamp */
  updated_at: string;
  /** User ID */
  user_id?: string | null;
};
export type CreateAssignmentRequest = {
  /** Bundle UUID */
  bundle_id: string;
  /** When assignment becomes effective (manual/trial only) */
  effective_from?: string | null;
  /** When assignment ends (manual/trial only) */
  effective_to?: string | null;
  /** Organization UUID (required for stripe source) */
  organization_id?: string | null;
  /** Assignment source: 'manual' (no billing), 'trial' (no billing), or 'stripe' (adds to Stripe subscription) */
  source?: string;
  /** User ID */
  user_id?: string | null;
};
export type SyncChangeResponse = {
  /** Action taken: 'created', 'updated', 'removed' */
  action: string;
  /** Bundle UUID */
  bundle_id: string;
  /** Bundle name */
  bundle_name?: string | null;
  /** Additional details */
  details?: string | null;
  /** New quantity */
  new_quantity?: number | null;
  /** Previous quantity */
  old_quantity?: number | null;
  /** Stripe subscription item ID */
  stripe_item_id?: string | null;
};
export type SyncBundlesResponse = {
  /** List of changes made */
  changes?: SyncChangeResponse[];
  /** Error message if sync failed */
  error?: string | null;
  /** Whether sync completed successfully */
  success: boolean;
};
export type ReplaceBundleRequest = {
  /** Bundle ID to replace with */
  new_bundle_id: string;
  /** Organization UUID */
  organization_id: string;
  /** User ID (None for org-level assignments) */
  user_id?: string | null;
};
export type UpdateAssignmentStatusRequest = {
  /** When status change takes effect */
  effective_to?: string | null;
  /** New status (pending, active, canceled, expired) */
  status: string;
  /** Stripe subscription item ID */
  stripe_subscription_item_id?: string | null;
};
export type GrantResponse = {
  /** Bundle UUID */
  bundle_id: string;
  /** Capability UUID */
  capability_id: string;
  /** Capability name */
  capability_name?: string | null;
  /** Created timestamp */
  created_at: string;
  /** Grant UUID */
  grant_id: string;
  /** Metering type (none, fully_metered) */
  metering_type: string;
  /** Usage quota (null = unlimited) */
  quota?: number | null;
  /** Last updated timestamp */
  updated_at: string;
  /** Usage period (daily, weekly, monthly) */
  usage_period?: string | null;
};
export type MarketingFeature = {
  /** Whether feature is included in bundle */
  included: boolean;
  /** Feature display text */
  name: string;
};
export type BundleResponse = {
  /** Bundle UUID */
  bundle_id: string;
  /** Bundle type: 'tier', 'add_on', or 'data_security' */
  bundle_type: string;
  /** Addon bundle IDs compatible with this tier (only for tier bundles) */
  compatible_addon_ids?: string[] | null;
  /** Created timestamp */
  created_at: string;
  /** Bundle description */
  description?: string | null;
  /** Grants in this bundle */
  grants?: GrantResponse[];
  /** Whether bundle is hidden from listings */
  hidden: boolean;
  /** Marketing features for pricing page display */
  marketing_features?: MarketingFeature[];
  /** Bundle name */
  name: string;
  /** Stripe product ID (None for virtual bundles) */
  stripe_product_id?: string | null;
  /** Last updated timestamp */
  updated_at: string;
};
export type BundleListResponse = {
  /** List of bundles */
  bundles?: BundleResponse[];
};
export type GrantResponse2 = {
  /** Bundle UUID */
  bundle_id: string;
  /** Capability UUID */
  capability_id: string;
  /** Capability name */
  capability_name?: string | null;
  /** Created timestamp */
  created_at: string;
  /** Grant UUID */
  grant_id: string;
  /** Metering type (none, fully_metered) */
  metering_type: string;
  /** Usage quota (null = unlimited) */
  quota?: number | null;
  /** Last updated timestamp */
  updated_at: string;
  /** Usage period (daily, weekly, monthly) */
  usage_period?: string | null;
};
export type MarketingFeature2 = {
  /** Whether feature is included in bundle */
  included: boolean;
  /** Feature display text */
  name: string;
};
export type BundleResponse2 = {
  /** Bundle UUID */
  bundle_id: string;
  /** Bundle type: 'tier', 'add_on', or 'data_security' */
  bundle_type: string;
  /** Addon bundle IDs compatible with this tier (only for tier bundles) */
  compatible_addon_ids?: string[] | null;
  /** Created timestamp */
  created_at: string;
  /** Bundle description */
  description?: string | null;
  /** Grants in this bundle */
  grants?: GrantResponse2[];
  /** Whether bundle is hidden from listings */
  hidden: boolean;
  /** Marketing features for pricing page display */
  marketing_features?: MarketingFeature2[];
  /** Bundle name */
  name: string;
  /** Stripe product ID (None for virtual bundles) */
  stripe_product_id?: string | null;
  /** Last updated timestamp */
  updated_at: string;
};
export type EnrichedBundleAssignmentResponse = {
  /** Assignment UUID */
  assignment_id: string;
  /** Bundle UUID */
  bundle_id: string;
  /** Bundle name */
  bundle_name?: string | null;
  /** Bundle type: 'tier', 'add_on', or 'data_security' */
  bundle_type?: string | null;
  /** Created timestamp */
  created_at: string;
  /** Effective from timestamp */
  effective_from: string;
  /** Effective to timestamp */
  effective_to?: string | null;
  /** Organization UUID */
  organization_id: string;
  /** Organization name */
  organization_name?: string | null;
  /** Assignment source (stripe, manual, trial) */
  source: string;
  /** Status (pending, active, canceled, expired) */
  status: string;
  /** Last updated timestamp */
  updated_at: string;
  /** User ID (null for org-level assignments) */
  user_id?: string | null;
  /** User name (null for org-level assignments) */
  user_name?: string | null;
};
export type ListResponseEnrichedBundleAssignmentResponse = {
  items: EnrichedBundleAssignmentResponse[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type CanonicalServiceTypeSeedResponse = {
  catalog_version?: string | null;
  created: number;
  errors?: string[];
  message: string;
  success: boolean;
  total_processed: number;
  updated: number;
};
export type CanonicalServiceTypeDeleteResponse = {
  message: string;
  organization_id?: string | null;
  slug: string;
  success: boolean;
};
export type CapabilityResponse = {
  /** Capability UUID */
  capability_id: string;
  /** Created timestamp */
  created_at: string;
  /** Capability description */
  description?: string | null;
  /** Unique capability name */
  name: string;
  /** Last updated timestamp */
  updated_at: string;
};
export type CapabilityListResponse = {
  /** List of capabilities */
  capabilities?: CapabilityResponse[];
};
export type CapabilityResponse2 = {
  /** Capability UUID */
  capability_id: string;
  /** Created timestamp */
  created_at: string;
  /** Capability description */
  description?: string | null;
  /** Unique capability name */
  name: string;
  /** Last updated timestamp */
  updated_at: string;
};
export type InitiateConversationResponse = {
  /** Status message describing the action taken */
  message: string;
  /** SMS/RCS message delivery task ID */
  message_task_id?: string | null;
  /** Masked phone number for privacy (e.g., *******7890) */
  phone_number_masked: string;
  /** Whether conversation was initiated successfully */
  success: boolean;
  /** Thread ID for conversation state tracking */
  thread_id: string;
};
export type InitiateConversationRequest = {
  /** Optional custom message to send. If not provided, uses default greeting. */
  message?: string | null;
  /** Phone number in E.164 format (e.g., +1234567890) */
  phone_number: string;
};
export type RuleSeedResponse = {
  errors?: string[];
  message: string;
  rules_created: number;
  rules_skipped: number;
  success: boolean;
};
export type SubmissionBlockerResponse = {
  /** Recommended action to resolve */
  action: string;
  /** Machine-readable blocker code */
  code: string;
  /** Additional context */
  details?: {
    [key: string]: any;
  } | null;
  /** Readiness level (1=org, 2=entity, 3=payer, 4=claim) */
  level: number;
  /** Human-readable description */
  message: string;
};
export type ClaimSubmissionReadinessResponse = {
  blockers: SubmissionBlockerResponse[];
  can_generate: boolean;
  can_submit: boolean;
  claim_id: string;
  enrollment_status: string | null;
  evaluated_at: string;
  payer_status: string | null;
  status: string;
};
export type ErrorMessage = {
  /** Additional context about the error */
  context?: {
    [key: string]: any;
  } | null;
  /** Category of error (e.g., 'validation', 'parsing', 'processing') */
  error_type?: string | null;
  /** Error message text */
  message: string;
  /** When the error occurred */
  timestamp: string;
};
export type ImportSessionStatusResponse = {
  completed_at: string | null;
  created_at: string;
  error_messages: ErrorMessage[];
  failed_patients: number;
  file_type: string;
  initializer_user_id: string | null;
  new_patients: number;
  organization_id: string;
  processed_patients: number;
  progress_percentage: number;
  session_id: string;
  status: string;
  total_patients: number;
  updated_at: string;
};
export type ImportSessionListResponse = {
  /** Organization ID these sessions belong to */
  organization_id: string;
  sessions: ImportSessionStatusResponse[];
  /** Total number of sessions returned */
  total: number;
};
export type ErrorMessage2 = {
  /** Additional context about the error */
  context?: {
    [key: string]: any;
  } | null;
  /** Category of error (e.g., 'validation', 'parsing', 'processing') */
  error_type?: string | null;
  /** Error message text */
  message: string;
  /** When the error occurred */
  timestamp: string;
};
export type MergeMultiplePatientsResponse = {
  /** Number of existing patients soft-deleted */
  deleted_count?: number;
  /** List of merge errors */
  errors?: ErrorMessage2[];
  /** Number of merge operations that failed */
  failed_count?: number;
  /** Number of patients successfully merged */
  merged_count?: number;
  /** UUID of the target patient */
  target_patient_id: string;
};
export type ImportErrorResponse = {
  /** Additional error details */
  details?: {
    [key: string]: any;
  } | null;
  /** Error message */
  error: string;
  /** Session ID if available */
  session_id?: string | null;
};
export type MergeMultiplePatientsRequest = {
  /** Organization UUID for scoping */
  organization_id: string;
  /** List of existing patient UUIDs to merge and soft-delete */
  source_existing_patient_ids?: string[];
  /** List of extracted patient UUIDs to merge */
  source_extracted_patient_ids?: string[];
  /** Existing patient UUID to merge into (target) */
  target_patient_id: string;
};
export type ErrorMessage3 = {
  /** Additional context about the error */
  context?: {
    [key: string]: any;
  } | null;
  /** Category of error (e.g., 'validation', 'parsing', 'processing') */
  error_type?: string | null;
  /** Error message text */
  message: string;
  /** When the error occurred */
  timestamp: string;
};
export type ImportSessionStatusResponse2 = {
  completed_at: string | null;
  created_at: string;
  error_messages: ErrorMessage3[];
  failed_patients: number;
  file_type: string;
  initializer_user_id: string | null;
  new_patients: number;
  organization_id: string;
  processed_patients: number;
  progress_percentage: number;
  session_id: string;
  status: string;
  total_patients: number;
  updated_at: string;
};
export type Allergy = {
  /** Name or description of the allergen */
  allergen: string;
  /** Whether the allergy is currently active */
  isActive?: boolean;
  /** Additional notes about the allergy */
  notes?: string | null;
  /** Date when allergy was first identified */
  onset_date?: string | null;
  /** Type of allergic reaction (hives, anaphylaxis, rash, etc.) */
  reaction?: string | null;
  /** Severity level (mild, moderate, severe, life-threatening) */
  severity?: string | null;
};
export type Diagnosis = {
  /** ICD-10 or other diagnostic code */
  code?: string | null;
  /** Date diagnosis was resolved */
  end_date?: string | null;
  /** Whether the diagnosis is currently active */
  isActive?: boolean;
  /** Name/description of the diagnosis */
  name: string;
  /** Date of diagnosis onset */
  start_date?: string | null;
};
export type Medication = {
  /** Dosage amount per administration */
  dosage_amount?: string | null;
  /** Date medication was discontinued */
  end_date?: string | null;
  /** Drug formulation (tablet, capsule, etc.) */
  formulation?: string | null;
  /** Frequency of administration (BID, qd, etc.) */
  frequency?: string | null;
  /** Generic drug name */
  generic_name?: string | null;
  /** Medical indication for the medication */
  indication?: string | null;
  /** Whether the medication is currently active */
  isActive?: boolean;
  /** Brand or common name of the medication */
  name: string;
  /** Route of administration (oral, IV, etc.) */
  route_of_administration?: string | null;
  /** Date medication was started */
  start_date?: string | null;
  /** Medication strength (e.g., '10 mg') */
  strength?: string | null;
  /** Specific timing instructions (HS, with meals, etc.) */
  timing?: string | null;
};
export type Procedure = {
  /** Procedure code (CPT, SNOMED, etc.) */
  code?: string | null;
  /** Date the procedure was performed */
  date_performed?: string | null;
  /** Whether this is a surgical procedure */
  isSurgical?: boolean;
  /** Location where procedure was performed */
  location?: string | null;
  /** Name of the procedure */
  name: string;
  /** Additional notes about the procedure */
  notes?: string | null;
  /** Outcome or result of the procedure */
  outcome?: string | null;
  /** Provider who performed the procedure */
  provider?: string | null;
};
export type SocialHistoryItem = {
  /** Category (smoking, alcohol, exercise, occupation, etc.) */
  category: string;
  /** Detailed description */
  description?: string | null;
  /** Date when this ended (if applicable) */
  end_date?: string | null;
  /** Quantity or frequency (e.g., '1 pack/day', '2 drinks/week') */
  quantity?: string | null;
  /** Date when this began */
  start_date?: string | null;
  /** Current status (current, former, never, etc.) */
  status: string;
};
export type PatientClinicalData = {
  /** List of patient allergies */
  allergies?: Allergy[];
  /** List of patient diagnoses */
  diagnoses?: Diagnosis[];
  /** List of patient medications */
  medications?: Medication[];
  /** List of medical procedures */
  procedures?: Procedure[];
  /** Social history items */
  social_history?: SocialHistoryItem[];
};
export type EmergencyContact = {
  /** Contact email address */
  email?: string | null;
  /** Contact full name */
  name?: string | null;
  /** Phone number in E.164 format (e.g., +12125551234) */
  phone?: string | null;
  /** Relationship to patient (spouse, parent, sibling, friend, etc.) */
  relationship?: string | null;
};
export type EncounterDocumentReference = {
  created_at?: string | null;
  encounter_document_id: string;
  status?: "pending" | "completed";
  title?: string | null;
  type: "text" | "recording" | "document" | "note";
};
export type JotDocReference = {
  created_at?: string | null;
  jotdoc_id?: string | null;
  status?: "pending" | "completed";
  task_id?: string | null;
  thread_id?: string | null;
  title?: string | null;
  type?: string | null;
};
export type Encounter = {
  admin_activity_log?: {
    [key: string]: any;
  }[];
  appointment_id?: string | null;
  attestations?: {
    [key: string]: any;
  } | null;
  cpt_codes?: string[];
  created_at?: string | null;
  date_of_service?: string | null;
  encounter_id: string;
  encounter_type?: string | null;
  end_time?: string | null;
  icd10_codes?: string[];
  inputs?: EncounterDocumentReference[];
  modality?: ("in_person" | "video" | "audio") | null;
  modified_at?: string | null;
  note_id?: string | null;
  note_title?: string | null;
  organization_id: string;
  outputs?: (EncounterDocumentReference | JotDocReference)[];
  patient_id?: string | null;
  place_of_service?: string | null;
  provider_id: string;
  scheduled_duration?: number | null;
  scheduled_for?: string | null;
  service_rendered_at?: string | null;
  start_time?: string | null;
  status?: "pending" | "processing" | "completed";
  template_id?: string | null;
  transcripts_deleted?: boolean;
  updated_at?: string | null;
  working_billing_claim?: {
    [key: string]: any;
  } | null;
};
export type PatientAddress = {
  /** City name */
  city?: string | null;
  /** Street address line 1 */
  line1?: string | null;
  /** Street address line 2 (apartment, suite, etc.) */
  line2?: string | null;
  /** Optional landline/location phone in E.164 format (e.g., +12125551234) */
  phone?: string | null;
  /** State abbreviation (2 characters) */
  state?: string | null;
  /** ZIP code (5 or 9 digit format, e.g., 12345 or 12345-6789) */
  zip?: string | null;
};
export type InsuranceInfo = {
  /** Whether authorization signature is on file */
  authorization_on_file?: boolean | null;
  /** S3 or storage location of authorization document for audit trail */
  authorization_resource_location?: string | null;
  /** Clearinghouse or EDI payer ID (e.g. 'UHC'). Import-time signal for payer resolution; not persisted to patient_insurance_coverages. */
  clearinghouse_payer_id?: string | null;
  /** Group number */
  group_number?: string | null;
  /** Address of insured if different from patient */
  insured_address?: PatientAddress | null;
  /** Date of birth of insured if different from patient */
  insured_dob?: string | null;
  /** Name of insured if different from patient */
  insured_name?: string | null;
  /** Sex of insured if different from patient (Male/Female) */
  insured_sex?: string | null;
  /** Patient's individual member/subscriber ID on their insurance card */
  member_id?: string | null;
  /** Insurance payer identifier code */
  payer_id?: string | null;
  /** Insurance company name */
  payer_name?: string | null;
  /** Specific plan or program name */
  plan_name?: string | null;
  /** Policy or plan contract number */
  policy_number?: string | null;
  /** Patient's relationship to insured (self, spouse, child, other) */
  relationship_to_insured?: string | null;
};
export type Patient = {
  /** [DEPRECATED - Use primary_address] Patient's street address */
  address?: string | null;
  /** [DEPRECATED - Use primary_address] City of residence */
  city?: string | null;
  deleted_at?: string | null;
  /** Date of birth in YYYY-MM-DD format (e.g., 1990-01-15) */
  dob?: string | null;
  /** Insurance eligibility status or coverage details */
  eligibility?: string | null;
  /** Email address for patient communication */
  email?: string | null;
  /** Emergency contact information */
  emergency_contact?: EmergencyContact | null;
  /** Employment status (employed, unemployed, retired, student, etc.) */
  employment_status?: string | null;
  /** Patient's legal first name */
  first_name?: string | null;
  /** Patient's gender identity (male, female, other, non-binary) */
  gender?: string | null;
  /** External patient identifier or medical record number */
  identifier?: string | null;
  /** [DEPRECATED - Use primary_insurance] Insurance policy or member ID number */
  insurance_policy_number?: string | null;
  /** Patient's family name or surname */
  last_name?: string | null;
  latest_encounter?: Encounter | null;
  /** Patient's middle name or initial */
  middle_name?: string | null;
  /** Primary mobile phone in E.164 format (e.g., +12125551234) for calls/texts */
  mobile_phone?: string | null;
  /** Patient's occupation or job title */
  occupation?: string | null;
  /** Whether patient authorization signature is on file */
  patient_consent_on_file?: boolean | null;
  /** S3 or storage location of consent document for audit trail */
  patient_consent_resource_location?: string | null;
  patient_id: string;
  /** [DEPRECATED - Use primary_insurance] Insurance payer identifier code */
  payer_id?: string | null;
  /** [DEPRECATED - Use primary_insurance] Insurance company or payer name */
  payer_name?: string | null;
  /** [DEPRECATED - Use primary_insurance] Patient's relationship to insurance subscriber */
  payer_relationship?: string | null;
  /** [DEPRECATED - Use mobile_phone] Phone number */
  phone?: string | null;
  /** Patient's preferred name or nickname */
  preferred_name?: string | null;
  /** Primary residential address */
  primary_address?: PatientAddress | null;
  /** DEPRECATED - use PatientCoverage table */
  primary_insurance?: InsuranceInfo | null;
  /** Patient's preferred pronouns (he/him, she/her, they/them, etc.) */
  pronouns?: string | null;
  /** Patient's race or ethnicity */
  race?: string | null;
  /** Secondary/mailing address if different from primary */
  secondary_address?: PatientAddress | null;
  /** DEPRECATED - use PatientCoverage table */
  secondary_insurance?: InsuranceInfo | null;
  /** Patient's sex for medical records and claims (Male/Female) */
  sex?: string | null;
  /** [DEPRECATED - Use primary_address] US state as 2-letter code */
  state?: string | null;
  stripe_customer_id?: string | null;
  /** DEPRECATED - use PatientCoverage table */
  tertiary_insurance?: InsuranceInfo | null;
  updated_at?: string | null;
  /** [DEPRECATED - Use primary_address] ZIP or postal code */
  zip?: string | null;
};
export type MatchedPatientResult = {
  /** Confidence score of the match (0-100) */
  confidence: number;
  /** Complete patient data from main database */
  patient: Patient;
  /** Patient ID for reference */
  patient_id: string;
};
export type PatientImportStatus =
  | "extracted"
  | "new"
  | "matched"
  | "imported"
  | "merged"
  | "skipped"
  | "failed";
export type MigrationMetadata = {
  /** Migration session identifier */
  import_session_id: string;
  /** Status of this patient's import */
  import_status: PatientImportStatus;
  /** When the data was imported */
  imported_at: string;
  /** Original ID from source system */
  original_import_id?: string | null;
  /** Original source filename */
  source_file?: string | null;
};
export type MigratedPatient = {
  /** Clinical data (medications, diagnoses, etc.) */
  clinical_data?: PatientClinicalData | null;
  /** List of matched patients with full data and confidence scores */
  matched_patients?: MatchedPatientResult[] | null;
  /** Information about how/when this was migrated */
  migration_metadata?: MigrationMetadata | null;
  /** Patient demographics and basic info */
  patient: Patient;
};
export type MigratedDataResponse = {
  /** Number of patients returned */
  patient_count: number;
  /** List of migrated patient records */
  patients: MigratedPatient[];
  /** When this data was retrieved */
  retrieved_at: string;
  /** Migration session UUID */
  session_id: string;
};
export type ErrorMessage4 = {
  /** Additional context about the error */
  context?: {
    [key: string]: any;
  } | null;
  /** Category of error (e.g., 'validation', 'parsing', 'processing') */
  error_type?: string | null;
  /** Error message text */
  message: string;
  /** When the error occurred */
  timestamp: string;
};
export type ExtractedPatientsResponse = {
  /** List of import errors */
  errors?: ErrorMessage4[];
  /** Estimated duration for async operations */
  estimated_duration_seconds?: number | null;
  /** Number of patients that failed to import */
  failed_count?: number;
  /** Number of patients successfully imported (includes both new and updated) */
  imported_count?: number;
  /** Whether the import is processed asynchronously */
  is_async: boolean;
  /** UUID of the import operation */
  operation_id: string;
  /** Status of operation: 'processing' | 'completed' | 'failed' */
  operation_status: string;
  /** Import session UUID */
  session_id: string;
  /** Number of patients skipped */
  skipped_count?: number;
  /** Deprecated: Always 0. Use imported_count for total successful imports */
  updated_count?: number;
};
export type ExtractedPatientsRequest = {
  /** List of extracted patient UUIDs to import */
  patient_ids: string[];
  /** Whether to skip patients marked as duplicates */
  skip_duplicates?: boolean;
  /** Whether to update existing patient records */
  update_existing?: boolean;
};
export type ErrorMessage5 = {
  /** Additional context about the error */
  context?: {
    [key: string]: any;
  } | null;
  /** Category of error (e.g., 'validation', 'parsing', 'processing') */
  error_type?: string | null;
  /** Error message text */
  message: string;
  /** When the error occurred */
  timestamp: string;
};
export type ImportOperationStatusResponse = {
  /** When processing completed */
  completed_at?: string | null;
  /** When the operation was created */
  created_at: string;
  /** Detailed error information */
  error_details?: ErrorMessage5[];
  /** Estimated duration in seconds */
  estimated_duration_seconds?: number | null;
  /** UUID of the operation */
  operation_id: string;
  /** Type of operation: 'import_selected' | 'import_unmatched' | 'merge_patients' */
  operation_type: string;
  /** Progress percentage */
  progress_percentage?: number;
  /** Number of patients processed */
  progress_processed_count?: number;
  /** Total number of patients to process */
  progress_total_count?: number;
  /** Number of patients that failed to import */
  results_failed_count?: number;
  /** Number of patients successfully imported */
  results_imported_count?: number;
  /** Number of patients skipped */
  results_skipped_count?: number;
  /** UUID of the import session */
  session_id: string;
  /** When processing started */
  started_at?: string | null;
  /** Current status: 'pending' | 'processing' | 'completed' | 'failed' */
  status: string;
  /** When the operation was last updated */
  updated_at: string;
};
export type ImportOperationListResponse = {
  /** List of operations */
  operations: ImportOperationStatusResponse[];
  /** UUID of the import session */
  session_id: string;
  /** Total number of operations */
  total: number;
};
export type ErrorMessage6 = {
  /** Additional context about the error */
  context?: {
    [key: string]: any;
  } | null;
  /** Category of error (e.g., 'validation', 'parsing', 'processing') */
  error_type?: string | null;
  /** Error message text */
  message: string;
  /** When the error occurred */
  timestamp: string;
};
export type ImportOperationStatusResponse2 = {
  /** When processing completed */
  completed_at?: string | null;
  /** When the operation was created */
  created_at: string;
  /** Detailed error information */
  error_details?: ErrorMessage6[];
  /** Estimated duration in seconds */
  estimated_duration_seconds?: number | null;
  /** UUID of the operation */
  operation_id: string;
  /** Type of operation: 'import_selected' | 'import_unmatched' | 'merge_patients' */
  operation_type: string;
  /** Progress percentage */
  progress_percentage?: number;
  /** Number of patients processed */
  progress_processed_count?: number;
  /** Total number of patients to process */
  progress_total_count?: number;
  /** Number of patients that failed to import */
  results_failed_count?: number;
  /** Number of patients successfully imported */
  results_imported_count?: number;
  /** Number of patients skipped */
  results_skipped_count?: number;
  /** UUID of the import session */
  session_id: string;
  /** When processing started */
  started_at?: string | null;
  /** Current status: 'pending' | 'processing' | 'completed' | 'failed' */
  status: string;
  /** When the operation was last updated */
  updated_at: string;
};
export type ErrorMessage7 = {
  /** Additional context about the error */
  context?: {
    [key: string]: any;
  } | null;
  /** Category of error (e.g., 'validation', 'parsing', 'processing') */
  error_type?: string | null;
  /** Error message text */
  message: string;
  /** When the error occurred */
  timestamp: string;
};
export type ImportUnmatchedResponse = {
  /** List of import errors */
  errors?: ErrorMessage7[];
  /** Estimated duration for async operations */
  estimated_duration_seconds?: number | null;
  /** Number of patients that failed to import */
  failed_count?: number;
  /** Number of patients successfully imported */
  imported_count?: number;
  /** Whether the import is processed asynchronously */
  is_async: boolean;
  /** UUID of the import operation */
  operation_id: string;
  /** Status of operation: 'processing' | 'completed' | 'failed' */
  operation_status: string;
  /** Import session UUID */
  session_id: string;
};
export type ImportUnmatchedRequest = {};
export type MatchedPatientInfo = {
  /** Confidence score (0-100) */
  confidence: number;
  /** Patient demographic data */
  patient_data?: {
    [key: string]: any;
  } | null;
  /** ID of the matched patient */
  patient_id: string;
};
export type MatchedPatientData = {
  /** Extracted patient UUID */
  extracted_patient_id: string;
  /** Import status */
  import_status: string;
  /** Decrypted extracted patient data */
  imported_patient_data?: {
    [key: string]: any;
  } | null;
  /** Fetched and decrypted best matched patient data from main database */
  matched_patient_data?: {
    [key: string]: any;
  } | null;
  /** ID of best matched patient in main database */
  matched_patient_id?: string | null;
  /** When matching was performed */
  matching_completed_at?: string | null;
  /** Confidence score of best match (0-100) */
  matching_confidence?: number | null;
  /** Original ID from source system */
  original_import_id?: string | null;
  /** All potential patient matches with confidence scores */
  potential_matches?: MatchedPatientInfo[] | null;
};
export type MatchedPatientsResponse = {
  /** Whether more patients exist beyond current page */
  has_more: boolean;
  /** Limit used for this request */
  limit: number;
  /** Number of patients with matches */
  matched_count: number;
  /** Number of patients not yet processed for matching */
  not_processed_count: number;
  /** Offset used for this request */
  offset: number;
  /** List of extracted patients with matching data */
  patients: MatchedPatientData[];
  /** Import session UUID */
  session_id: string;
  /** Total number of extracted patients */
  total_imported: number;
  /** Number of patients without matches */
  unmatched_count: number;
};
export type ErrorMessage8 = {
  /** Additional context about the error */
  context?: {
    [key: string]: any;
  } | null;
  /** Category of error (e.g., 'validation', 'parsing', 'processing') */
  error_type?: string | null;
  /** Error message text */
  message: string;
  /** When the error occurred */
  timestamp: string;
};
export type BulkUpdateStatusResponse = {
  /** List of update errors */
  errors?: ErrorMessage8[];
  /** Number that failed to update */
  failed_count: number;
  /** Import session UUID */
  session_id: string;
  /** Number of patients updated */
  updated_count: number;
};
export type BulkUpdateStatusRequest = {
  /** Action to take */
  action: string;
  /** List of extracted patient UUIDs */
  patient_ids: string[];
  /** Reason for status change */
  reason?: string | null;
};
export type RejectPatientsResponse = {
  /** Number that failed to reject */
  failed_count: number;
  /** Number of patients rejected */
  rejected_count: number;
  /** Import session UUID */
  session_id: string;
};
export type RejectPatientsRequest = {
  /** List of extracted patient UUIDs to reject */
  patient_ids: string[];
  /** Reason for rejection */
  reason?: string | null;
};
export type ImportSessionCreateResponse = {
  /** When the session was created */
  created_at: string;
  /** S3 location of uploaded file */
  file_location?: string | null;
  /** Success message */
  message: string;
  /** UUID of the import session */
  session_id: string;
  /** Current status of the import */
  status: string;
};
export type ImportUploadFormData = {
  /** UUID of the organization */
  organization_id: string;
};
export type CommunicationChannelStatus = {
  /** Communication channel: 'sms' or 'email' */
  channel: string;
  /** When message was delivered */
  delivered_at?: string | null;
  /** Error details if delivery failed */
  error_message?: string | null;
  /** When delivery failed */
  failed_at?: string | null;
  /** When message was sent */
  sent_at?: string | null;
  /** Delivery status: queued, sent, delivered, failed, bounced, dropped, opened, clicked */
  status: string;
};
export type FormStatusInfo = {
  /** ID of the form session */
  form_session_id: string;
  /** Form status: pending, in_progress, or completed */
  status: string;
  /** When the form was submitted */
  submitted_at?: string | null;
};
export type InsuranceSummary = {
  /** Coverage priority: 1=primary, 2=secondary, 3=tertiary */
  coverage_order?: number;
  /** Group/employer number */
  group_number?: string | null;
  /** Member/policy ID on insurance card */
  member_id?: string | null;
  /** Payer logo image URL */
  payer_logo_url?: string | null;
  /** Insurance payer display name */
  payer_name?: string | null;
  /** True when payer was resolved with low confidence or unresolved; requires manual verification */
  payer_resolution_needs_review?: boolean | null;
  /** Plan name (e.g. Gold PPO) */
  plan_name?: string | null;
  /** Coverage status: active, pending, cancelled, expired */
  status?: string;
};
export type PatientInfo = {
  dob?: string | null;
  first_name?: string | null;
  identifier?: string | null;
  /** Active insurance coverages with payer info */
  insurance_coverages?: InsuranceSummary[] | null;
  last_name?: string | null;
  middle_name?: string | null;
  name?: string | null;
  patient_id: string;
  preferred_name?: string | null;
  telephone?: string | null;
};
export type DocumentSummaryResponse = {
  /** Per-channel delivery status if document was sent to patient */
  communication_status?: CommunicationChannelStatus[] | null;
  /** MIME type (e.g., 'application/pdf') */
  content_type: string;
  /** When document was created (ISO 8601 UTC) */
  created_at: string;
  /** Unique identifier for the document */
  document_id: string;
  /** User-friendly title for the document */
  document_title?: string | null;
  /** Type of document (e.g., 'lab_order', 'claim', 'form') */
  document_type?: string | null;
  /** Original filename */
  filename: string;
  /** Form lifecycle status if document originated from a form submission */
  form_status?: FormStatusInfo | null;
  /** Patient information if patient_id is set */
  patient?: PatientInfo | null;
  /** Patient associated with the document */
  patient_id?: string | null;
  /** File size in bytes */
  size_bytes: number;
};
export type DocumentListResponse = {
  items: DocumentSummaryResponse[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type InsuranceSummary2 = {
  /** Coverage priority: 1=primary, 2=secondary, 3=tertiary */
  coverage_order?: number;
  /** Group/employer number */
  group_number?: string | null;
  /** Member/policy ID on insurance card */
  member_id?: string | null;
  /** Payer logo image URL */
  payer_logo_url?: string | null;
  /** Insurance payer display name */
  payer_name?: string | null;
  /** True when payer was resolved with low confidence or unresolved; requires manual verification */
  payer_resolution_needs_review?: boolean | null;
  /** Plan name (e.g. Gold PPO) */
  plan_name?: string | null;
  /** Coverage status: active, pending, cancelled, expired */
  status?: string;
};
export type PatientInfo2 = {
  dob?: string | null;
  first_name?: string | null;
  identifier?: string | null;
  /** Active insurance coverages with payer info */
  insurance_coverages?: InsuranceSummary2[] | null;
  last_name?: string | null;
  middle_name?: string | null;
  name?: string | null;
  patient_id: string;
  preferred_name?: string | null;
  telephone?: string | null;
};
export type DocumentDetailResponse = {
  /** MIME type (e.g., 'application/pdf') */
  content_type: string;
  /** When document was created (ISO 8601 UTC) */
  created_at: string;
  /** When document was deleted (ISO 8601 UTC) */
  deleted_at?: string | null;
  /** Unique identifier for the document */
  document_id: string;
  /** User-friendly title for the document */
  document_title?: string | null;
  /** Type of document (e.g., 'lab_order', 'claim', 'form') */
  document_type?: string | null;
  /** Presigned S3 URL for downloading the document */
  download_url?: string | null;
  /** Unix timestamp when download URL expires */
  download_url_expires_at?: number | null;
  /** Original filename */
  filename: string;
  /** MD5 checksum for integrity */
  md5_hash: string;
  /** Organization the document belongs to */
  organization_id?: string | null;
  /** Patient information if patient_id is set */
  patient?: PatientInfo2 | null;
  /** Patient associated with the document */
  patient_id?: string | null;
  /** Provider who owns the document */
  provider_id: string;
  /** File size in bytes */
  size_bytes: number;
  /** When document was last updated (ISO 8601 UTC) */
  updated_at?: string | null;
};
export type AdminEligibilityItemResponse = {
  alerts?: string[];
  benefit_structure?: string | null;
  coverage_status: string;
  created_at?: string | null;
  eligibility_snapshot_id?: string | null;
  encounter_date?: string | null;
  encounter_id?: string | null;
  expires_at?: string | null;
  financials?: {
    [key: string]: any;
  };
  next_action?: string;
  next_action_owner?: string;
  organization_id: string;
  organization_name?: string;
  patient_id: string;
  patient_name?: string;
  payer_name?: string;
  payer_obligation?: number | null;
  plan_status?: string | null;
  post_deductible_member_obligation?: number | null;
  post_deductible_payer_obligation?: number | null;
  post_oop_max_member_obligation?: number | null;
  post_oop_max_payer_obligation?: number | null;
  pre_deductible_member_obligation?: number | null;
  pre_deductible_payer_obligation?: number | null;
  remaining_sessions_before_deductible?: number | null;
  remaining_sessions_before_oop_max?: number | null;
  service_tier?: string;
  source?: string;
  status: string;
  summary: string;
  telehealth?: {
    [key: string]: any;
  } | null;
  user_id: string;
};
export type AdminEligibilitySummary = {
  blocked_count?: number;
  eligible_count?: number;
  expiring_soon_count?: number;
  needs_review_count?: number;
};
export type AdminEligibilityListResponse = {
  items: AdminEligibilityItemResponse[];
  page?: number;
  per_page?: number;
  summary: AdminEligibilitySummary;
  total?: number;
};
export type EligibilityCheckResponse = {
  alerts?: string[];
  corrected_member_id?: string | null;
  coverage_status: string;
  eligibility_snapshot_id?: string | null;
  encounter_id?: string | null;
  expires_at?: string | null;
  financials?: {
    [key: string]: any;
  };
  last_checked_at?: string | null;
  next_action?: string;
  next_action_owner?: string;
  patient_id: string;
  patient_insurance_coverage_id?: string | null;
  plan_status?: string | null;
  service_tier?: string;
  source?: string;
  status: string;
  submitted_member_id?: string | null;
  summary: string;
};
export type ManualUpdateRequest = {
  /** New coverage status */
  coverage_status?: string | null;
  /** Financial field overrides (e.g. copayment_cents, deductible_cents) */
  financials?: {
    [key: string]: any;
  } | null;
  /** Verification method (portal or phone) */
  method?: string | null;
  /** Next action (none/portal_review/phone_verify/block) */
  next_action?: string | null;
  /** Next action owner (provider/biller/system) */
  next_action_owner?: string | null;
  /** Additional notes */
  notes?: string | null;
  /** Reason for the manual override */
  reason?: string | null;
  /** New status (eligible/needs_review/blocked) */
  status?: string | null;
  /** Updated summary text */
  summary?: string | null;
};
export type StartProcessingResponse = {
  encounter_id?: string | null;
  message: string;
  note_id?: string | null;
  status: number;
};
export type DistributionStats = {
  /** Number of data points */
  count: number;
  /** Maximum value */
  max: number;
  /** Mean (average) value */
  mean: number;
  /** Median (p50) value */
  median: number;
  /** Minimum value */
  min: number;
  /** 50th percentile */
  p50: number;
  /** 75th percentile */
  p75: number;
  /** 90th percentile */
  p90: number;
  /** 95th percentile */
  p95: number;
  /** 99th percentile */
  p99: number;
};
export type CopyAnalytics = {
  /** Copies per selection (copy_count / select_count) */
  copy_rate?: number;
  /** Copy count by modality (keyboard, mouse, copy_button, etc.) */
  modality_breakdown?: {
    [key: string]: number;
  };
  /** Top sections by copy count (section_id, section_title, copy_count) */
  most_copied_sections?: {
    [key: string]: any;
  }[];
  /** Statistics for selection as percent of total */
  selection_percent_stats?: DistributionStats | null;
  /** Statistics for selection sizes (in characters) */
  selection_size_stats?: DistributionStats | null;
  /** Statistics for time from settle to copy */
  time_to_copy_stats?: DistributionStats | null;
  /** Total copy events */
  total_copies?: number;
};
export type DocumentAnalytics = {
  /** Total character delta across all edits */
  char_delta_total?: number;
  /** Total clicks in document */
  click_count?: number;
  /** Total copies from document */
  copy_count?: number;
  /** Document identifier (e.g., note:xyz or jotdoc:abc) */
  doc_id: string;
  /** Document type (note or jotdoc) */
  doc_type: string;
  /** Number of edits to document */
  edit_count?: number;
  /** Weighted engagement score (views*1 + interactions*5 + edits*10) */
  engagement_score?: number;
  /** Statistics for hover durations */
  hover_duration_stats?: DistributionStats | null;
  /** Number of interactions with document */
  interaction_count?: number;
  /** Total selections in document */
  select_count?: number;
  /** Number of times document was viewed */
  view_count?: number;
};
export type EditAnalytics = {
  /** Average characters changed per edit */
  avg_chars_per_edit?: number | null;
  /** Distribution of character deltas */
  char_delta_distribution?: DistributionStats | null;
  /** Edit count by source (manual, ai_edit, regeneration) */
  edits_by_source?: {
    [key: string]: number;
  };
  /** Number of unique sections that were edited */
  sections_edited?: number;
  /** Total number of edits */
  total_edits?: number;
};
export type NoteUsageSummary = {
  /** Avg copy percent over all sections, treating unknown as 0 (0-1) */
  char_weighted_copy_percent_all?: number | null;
  /** Avg copy percent over sections with known copy data (0-1) */
  char_weighted_copy_percent_known?: number | null;
  /** Avg edit percent over all sections, treating unknown as 0 (0-1) */
  char_weighted_edit_percent_all?: number | null;
  /** Avg edit percent over sections with known edit data (0-1) */
  char_weighted_edit_percent_known?: number | null;
  /** Avg selection percent over all sections, treating unknown as 0 (0-1) */
  char_weighted_selection_percent_all?: number | null;
  /** Avg selection percent over sections with known selection data (0-1) */
  char_weighted_selection_percent_known?: number | null;
  /** Percent of sections with text copied (0-1) */
  percent_copied?: number;
  /** Percent of sections edited (0-1) */
  percent_edited?: number;
  /** Percent of sections interacted with (0-1) */
  percent_interacted?: number;
  /** Percent of sections rendered (0-1) */
  percent_rendered?: number;
  /** Number of sections with text copied */
  sections_copied?: number;
  /** Number of sections edited */
  sections_edited?: number;
  /** Number of sections interacted with */
  sections_interacted?: number;
  /** Number of sections rendered */
  sections_rendered?: number;
  /** Total character count of note */
  total_note_chars?: number;
  /** Total number of sections in note */
  total_sections?: number;
};
export type NoteUsageSection = {
  /** Whether section had text copied */
  copied?: boolean;
  /** Max percent of section text copied (0-1) */
  copy_percent_max?: number | null;
  /** Whether section was edited */
  edited?: boolean;
  /** Percent of section edited based on char delta (0-1) */
  edited_percent?: number | null;
  /** Whether section was interacted with */
  interacted?: boolean;
  /** Whether section was rendered */
  rendered?: boolean;
  /** Character count of section text */
  section_chars?: number;
  /** Section identifier */
  section_id: string;
  /** Section title from note */
  section_title?: string | null;
  /** Max percent of section text selected (0-1) */
  selection_percent_max?: number | null;
};
export type SectionAnalytics = {
  /** Statistics for character deltas per edit */
  char_delta_stats?: DistributionStats | null;
  /** Total character delta across all edits */
  char_delta_total?: number;
  /** Total clicks in section */
  click_count?: number;
  /** Total copies from section */
  copy_count?: number;
  /** Number of edits to section */
  edit_count?: number;
  /** Weighted engagement score (views*1 + interactions*5 + edits*10) */
  engagement_score?: number;
  /** Statistics for hover durations */
  hover_duration_stats?: DistributionStats | null;
  /** Number of section_interacted events */
  interaction_count?: number;
  /** Section identifier */
  section_id: string;
  /** Section title (for readability) */
  section_title?: string | null;
  /** Total selections in section */
  select_count?: number;
  /** Number of times section was viewed */
  view_count?: number;
};
export type CopyDetailStats = {
  /** Event IDs of all copy events */
  copy_event_ids?: string[];
  /** Copy rate (copies / selections) for this section */
  copy_rate?: number;
  /** Copy count by modality */
  modality_breakdown?: {
    [key: string]: number;
  };
  /** Distribution of copied character counts */
  selected_chars_stats?: DistributionStats | null;
  /** Distribution of copied percent of total */
  selection_percent_stats?: DistributionStats | null;
  /** Distribution of time from settle to copy (ms) */
  time_to_copy_stats?: DistributionStats | null;
  /** Total copy events */
  total_copies?: number;
};
export type EditDetailStats = {
  /** Distribution of character deltas */
  char_delta_distribution?: DistributionStats | null;
  /** Event IDs of all edit events */
  edit_event_ids?: string[];
  /** Edit count by source (manual, ai_edit, regeneration) */
  edits_by_source?: {
    [key: string]: number;
  };
  /** Total character delta across all edits */
  total_char_delta?: number;
  /** Total edits */
  total_edits?: number;
};
export type InteractionDetailStats = {
  /** Distribution of hover durations (ms) */
  hover_duration_stats?: DistributionStats | null;
  /** Event IDs of all interaction events */
  interaction_event_ids?: string[];
  /** Total clicks */
  total_clicks?: number;
  /** Total copies from interactions */
  total_copies?: number;
  /** Total hover duration in milliseconds */
  total_hover_ms?: number;
  /** Total section_interacted events */
  total_interactions?: number;
  /** Total selects */
  total_selects?: number;
};
export type SelectionDetailStats = {
  /** Selection count by modality */
  modality_breakdown?: {
    [key: string]: number;
  };
  /** Distribution of selected character counts */
  selected_chars_stats?: DistributionStats | null;
  /** Event IDs of all selection events */
  selection_event_ids?: string[];
  /** Distribution of selection as percent of total */
  selection_percent_stats?: DistributionStats | null;
  /** Distribution of time to settle (ms) */
  settle_time_stats?: DistributionStats | null;
  /** Total selection events */
  total_selections?: number;
};
export type SectionDetailAnalytics = {
  /** Copy statistics */
  copy: CopyDetailStats;
  /** Base document ID (note:xyz or jotdoc:abc) */
  doc_id: string;
  /** Document type (note or jotdoc) */
  doc_type: string;
  /** Edit statistics */
  edit: EditDetailStats;
  /** Weighted engagement score (edits*20 + copies*10 + hover_seconds*0.1 + renders*1) */
  engagement_score?: number;
  /** ISO timestamp of first event for this section */
  first_seen_at?: string | null;
  /** Interaction statistics */
  interaction: InteractionDetailStats;
  /** ISO timestamp of last event for this section */
  last_seen_at?: string | null;
  /** Number of times section was rendered */
  render_count?: number;
  /** Section identifier */
  section_id: string;
  /** Section title */
  section_title?: string | null;
  /** Selection statistics */
  selection: SelectionDetailStats;
  /** Total touches (rendered + interacted + selected + copied + edited) */
  touch_count?: number;
};
export type SessionSummary = {
  /** Copy rate (copies / selections), or None if no selections */
  copy_rate?: number | null;
  /** ISO timestamp of last event */
  date_range_end?: string | null;
  /** ISO timestamp of first event */
  date_range_start?: string | null;
  /** Edit count by source (manual, ai_edit, regeneration) */
  edits_by_source?: {
    [key: string]: number;
  };
  /** Average events per minute */
  event_frequency_per_minute?: number | null;
  /** Event count by event type */
  events_by_type: {
    [key: string]: number;
  };
  /** Duration from first to last event (seconds) */
  session_duration_seconds?: number | null;
  /** Total character delta across all edits (positive = additions, negative = deletions) */
  total_char_delta?: number;
  /** Total number of copy events */
  total_copies?: number;
  /** Total number of edit events */
  total_edits?: number;
  /** Total number of events */
  total_events: number;
  /** Total number of text selection events */
  total_selections?: number;
  /** Number of unique sections that were interacted with */
  unique_sections_interacted?: number;
};
export type TimingAnalytics = {
  /** Edit session durations (ms) */
  edit_duration?: DistributionStats | null;
  /** Section hover durations (ms) */
  hover_duration?: DistributionStats | null;
  /** Time from selection start to settle (ms) */
  selection_settle_time?: DistributionStats | null;
  /** Time from selection settle to copy (ms) */
  time_to_copy?: DistributionStats | null;
};
export type EncounterTelemetryAnalytics = {
  /** Copy/selection analytics */
  copy_analytics: CopyAnalytics;
  /** Analytics per document (note vs jotdocs) */
  document_analytics?: DocumentAnalytics[];
  /** Edit event analytics */
  edit_analytics: EditAnalytics;
  /** Encounter identifier */
  encounter_id: string;
  /** Note identifier (if available) */
  note_id?: string | null;
  /** Main note usage coverage summary */
  note_usage?: NoteUsageSummary | null;
  /** Per-section usage breakdown for main note */
  note_usage_sections?: NoteUsageSection[];
  /** Raw telemetry events */
  raw_events?: {
    [key: string]: any;
  }[];
  /** Analytics per section */
  section_analytics?: SectionAnalytics[];
  /** Detailed analytics per section with comprehensive metrics */
  section_details?: SectionDetailAnalytics[];
  /** Session-level summary */
  session_summary: SessionSummary;
  /** Timing-related distributions */
  timing_analytics: TimingAnalytics;
};
export type AdminTelemetryAnalyticsResponse = {
  /** Comprehensive telemetry analytics */
  analytics: EncounterTelemetryAnalytics;
};
export type SessionSummary2 = {
  /** Copy rate (copies / selections), or None if no selections */
  copy_rate?: number | null;
  /** ISO timestamp of last event */
  date_range_end?: string | null;
  /** ISO timestamp of first event */
  date_range_start?: string | null;
  /** Edit count by source (manual, ai_edit, regeneration) */
  edits_by_source?: {
    [key: string]: number;
  };
  /** Average events per minute */
  event_frequency_per_minute?: number | null;
  /** Event count by event type */
  events_by_type: {
    [key: string]: number;
  };
  /** Duration from first to last event (seconds) */
  session_duration_seconds?: number | null;
  /** Total character delta across all edits (positive = additions, negative = deletions) */
  total_char_delta?: number;
  /** Total number of copy events */
  total_copies?: number;
  /** Total number of edit events */
  total_edits?: number;
  /** Total number of events */
  total_events: number;
  /** Total number of text selection events */
  total_selections?: number;
  /** Number of unique sections that were interacted with */
  unique_sections_interacted?: number;
};
export type AdminTelemetrySessionListItem = {
  /** Session creation timestamp */
  created_at: string;
  /** Encounter identifier */
  encounter_id: string;
  /** Associated note ID if available */
  note_id?: string | null;
  /** Organization ID for the session */
  organization_id?: string | null;
  /** Organization name (enriched) */
  organization_name?: string | null;
  /** Session summary statistics */
  summary: SessionSummary2;
  /** Last update timestamp */
  updated_at: string;
  /** User email (enriched) */
  user_email?: string | null;
  /** User ID (provider) */
  user_id: string;
  /** User name (enriched) */
  user_name?: string | null;
};
export type ListResponseAdminTelemetrySessionListItem = {
  items: AdminTelemetrySessionListItem[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type AdminAppointmentSummary = {
  appointment_id: string;
  duration?: number | null;
  encounter_type?: string | null;
  encounter_type_id?: string | null;
  start_time?: string | null;
  status?: string | null;
  telehealth?: boolean | null;
  title?: string | null;
};
export type WorkingBillingClaimLineItemResponse = {
  /** Charge amount in cents for the line item */
  charge_cents?: number | null;
  /** Billing code identifier */
  code_id?: string | null;
  /** Subset of claim-level diagnosis codes this line links to. Empty = all apply. */
  diagnosis_codes?: string[];
  /** Provenance for each modifier, keyed by modifier code */
  modifier_sources?: {
    [key: string]: "provider_selected" | "ai_recommended";
  };
  modifiers?: string[];
  /** Whether this line item came from provider edits or AI */
  source?: ("provider_selected" | "ai_recommended") | null;
  /** Units billed */
  units?: number | null;
};
export type WorkingBillingClaimResponse = {
  created_at?: string | null;
  /** Provenance for each diagnosis code, keyed by normalized ICD-10 code */
  diagnosis_code_sources?: {
    [key: string]: "provider_selected" | "ai_recommended";
  };
  diagnosis_codes?: string[];
  encounter_id?: string | null;
  line_items?: WorkingBillingClaimLineItemResponse[];
  organization_id?: string | null;
  place_of_service?: string | null;
  updated_at?: string | null;
};
export type AdminEncounterDetail = {
  appointment_id?: string | null;
  created_at?: string | null;
  encounter_analysis?: {
    [key: string]: any;
  } | null;
  encounter_id: string;
  encounter_type?: string | null;
  end_time?: string | null;
  input_documents?: number | null;
  organization_id?: string | null;
  patient_id?: string | null;
  provider_id?: string | null;
  start_time?: string | null;
  status?: string | null;
  updated_at?: string | null;
  working_billing_claim?: WorkingBillingClaimResponse | null;
};
export type AdminNoteProcessingSessionSummary = {
  created_at?: string | null;
  note_id?: string | null;
  note_processing_session_id: string;
  status?: string | null;
  transcription_session_ids?: string[] | null;
};
export type AdminNoteSummary2 = {
  created_at?: string | null;
  encounter_type?: string | null;
  has_feedback?: boolean | null;
  note_id: string;
  patient_id?: string | null;
  patient_name?: string | null;
  status?: string | null;
  template?: string | null;
};
export type AdminProviderSummary2 = {
  email?: string | null;
  last_login_time?: string | null;
  name?: string | null;
  organization_id?: string | null;
  organization_name?: string | null;
  provider_id: string;
  role?: string | null;
};
export type AdminTranscriptionSummary2 = {
  chunk_count?: number | null;
  created_at?: string | null;
  is_closed?: boolean | null;
  job_status?: string | null;
  notes_created?: number | null;
  start_time?: string | null;
  transcription_session_id: string;
};
export type AdminEncounterDetailResponse = {
  appointment?: AdminAppointmentSummary | null;
  encounter: AdminEncounterDetail;
  note_processing_sessions: AdminNoteProcessingSessionSummary[];
  notes: AdminNoteSummary2[];
  provider: AdminProviderSummary2;
  transcriptions: AdminTranscriptionSummary2[];
};
export type EntitlementResponse = {
  /** Source of the assignment (stripe, manual, trial) */
  assignment_source: string;
  /** Bundle UUID that granted this entitlement */
  bundle_id: string;
  /** Name of the bundle */
  bundle_name: string;
  /** Description of the capability */
  capability_description?: string | null;
  /** Human-friendly display name for the capability */
  capability_display_name?: string | null;
  /** Capability UUID */
  capability_id: string;
  /** Name of the capability */
  capability_name: string;
  /** End of current usage period */
  current_period_end?: string | null;
  /** Start of current usage period */
  current_period_start?: string | null;
  /** Usage count in current period (null if not tracked) */
  current_usage?: number | null;
  /** Metering type (none, fully_metered, hybrid) */
  metering_type: string;
  /** Usage quota (null = unlimited) */
  quota?: number | null;
  /** Remaining quota (null if unlimited) */
  quota_remaining?: number | null;
  /** Period for quota reset (daily, weekly, monthly) */
  usage_period?: string | null;
};
export type EntitlementListResponse = {
  /** List of entitlements */
  entitlements?: EntitlementResponse[];
};
export type DeleteTestUsageResponse = {
  /** Number of events deleted */
  events_deleted: number;
};
export type UsageEventResponse = {
  /** Capability UUID */
  capability_id: string;
  /** When the usage occurred */
  created_at: string;
  /** Usage event UUID */
  event_id: string;
  /** Additional context */
  metadata?: {
    [key: string]: any;
  } | null;
  /** Original event ID that triggered this usage */
  source_event_id?: string | null;
  /** Event type that triggered this usage */
  source_event_type?: string | null;
};
export type UsageEventListResponse = {
  /** List of usage events */
  items?: UsageEventResponse[];
  /** Current page number */
  page: number;
  /** Items per page */
  per_page: number;
  /** Total number of events */
  total: number;
  /** Total number of pages */
  total_pages: number;
};
export type EmitTestUsageResponse = {
  /** Capability UUID */
  capability_id: string;
  /** Capability name */
  capability_name: string;
  /** Number of events created */
  events_created: number;
};
export type EmitTestUsageRequest = {
  /** Name of the capability (e.g., 'note_creation') */
  capability_name: string;
  /** Number of usage events to emit */
  count?: number;
  /** Organization UUID */
  organization_id: string;
  /** Provider/user ID */
  user_id: string;
};
export type EventInfo = {
  /** The event type identifier (e.g., 'NOTE_FEEDBACK') */
  event_type: string;
  /** Schema fields with their types and constraints */
  fields: {
    [key: string]: any;
  };
  /** The name of the Pydantic model class */
  model_name: string;
};
export type EventRegistryResponse = {
  /** List of registered event types */
  events: EventInfo[];
  /** Total number of registered events */
  total_count: number;
};
export type FeedbackSessionListItemResponse = {
  /** Number of events with comments */
  comment_count?: number;
  /** Number of feedback events in this session */
  feedback_event_count: number;
  /** Session identifier */
  feedback_session_id: string;
  /** Whether note has a comment */
  has_note_comment?: boolean;
  /** Whether session has note-level feedback */
  has_note_feedback?: boolean;
  /** Whether session has section-level feedback */
  has_section_feedback?: boolean;
  /** Last modification timestamp (Unix) */
  last_modified: number;
  /** Last modification as datetime */
  last_modified_date: string;
  /** Number of negative ratings (note_rating=1 or section_rating=0) */
  negative_rating_count?: number;
  /** Number of neutral ratings (note_rating=2) */
  neutral_rating_count?: number;
  /** Number of note-level feedback events */
  note_event_count?: number;
  /** Associated note ID */
  note_id: string;
  /** The note rating if present (0=Satisfied, 1=Dissatisfied, 2=Somewhat) */
  note_rating?: number | null;
  /** Organization ID */
  organization_id?: string | null;
  /** Organization name (enriched) */
  organization_name?: string | null;
  /** Overall sentiment: positive (all good), negative (all bad), mixed (both), neutral (only note_rating=2), comment_only (no ratings) */
  overall_sentiment?:
    | "positive"
    | "negative"
    | "mixed"
    | "neutral"
    | "comment_only";
  /** Number of positive ratings (note_rating=0 or section_rating=1) */
  positive_rating_count?: number;
  /** Number of section-level feedback events */
  section_event_count?: number;
  /** User email (enriched) */
  user_email?: string | null;
  /** Provider/user ID */
  user_id: string;
  /** User name (enriched) */
  user_name?: string | null;
};
export type ListResponseFeedbackSessionListItemResponse = {
  items: FeedbackSessionListItemResponse[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type NoteFeedbackEvent = {
  feedback_event_id: string;
  feedback_type: "note" | "section";
  note_comment?: string | null;
  note_content: any;
  note_rating?: number | null;
  timestamp: number;
  user_id: string;
};
export type NoteSectionFeedbackEvent = {
  ai_instruction_session_id?: string | null;
  feedback_event_id: string;
  feedback_type: "note" | "section";
  module_id?: string | null;
  section_comment?: string | null;
  section_content: any;
  section_id: string;
  section_rating?: number | null;
  timestamp: number;
  user_id: string;
};
export type FeedbackSessionResponse = {
  /** List of feedback events */
  feedback_events: (NoteFeedbackEvent | NoteSectionFeedbackEvent)[];
  /** Session identifier */
  feedback_session_id: string;
  /** Last modification timestamp (Unix) */
  last_modified: number;
  /** Associated note ID */
  note_id: string;
  /** Provider/user ID */
  user_id: string;
};
export type FeedbackSessionDeleteResponse = {
  /** Human-readable message */
  message: string;
  /** Session ID that was deleted */
  session_id: string;
  /** Whether deletion was successful */
  success: boolean;
};
export type NoteFeedbackEvent2 = {
  feedback_event_id: string;
  feedback_type: "note" | "section";
  note_comment?: string | null;
  note_content: any;
  note_rating?: number | null;
  timestamp: number;
  user_id: string;
};
export type NoteSectionFeedbackEvent2 = {
  ai_instruction_session_id?: string | null;
  feedback_event_id: string;
  feedback_type: "note" | "section";
  module_id?: string | null;
  section_comment?: string | null;
  section_content: any;
  section_id: string;
  section_rating?: number | null;
  timestamp: number;
  user_id: string;
};
export type AdminFeedbackSessionResponse = {
  /** List of feedback events */
  feedback_events: (NoteFeedbackEvent2 | NoteSectionFeedbackEvent2)[];
  /** Session identifier */
  feedback_session_id: string;
  /** Last modification timestamp (Unix) */
  last_modified: number;
  /** Associated note ID */
  note_id: string;
  /** Organization ID */
  organization_id?: string | null;
  /** Organization name (enriched) */
  organization_name?: string | null;
  /** User email (enriched) */
  user_email?: string | null;
  /** Provider/user ID */
  user_id: string;
  /** User name (enriched) */
  user_name?: string | null;
};
export type FormRevision = {
  /** Form schema/body */
  body: {
    [key: string]: any;
  };
  /** Creation timestamp */
  created_at?: string | null;
  /** Provider ID who created this revision */
  created_by: string;
  /** Form description */
  description?: string | null;
  /** Whether this is a draft */
  draft?: boolean;
  /** Parent form UUID */
  form_id: string;
  /** Publication timestamp */
  published_at?: string | null;
  /** Form tags */
  tags?: string[];
  /** Form title */
  title: string;
  /** Last update timestamp */
  updated_at?: string | null;
  /** Version number */
  version: number;
};
export type FormOwnerScope = "public" | "org" | "provider";
export type Form = {
  /** Total number of completions */
  completions_total?: number;
  /** Creation timestamp */
  created_at?: string | null;
  /** Current published version */
  current_version?: number;
  /** Deletion timestamp for soft delete */
  deleted_at?: string | null;
  /** Type of form */
  form_type: string;
  /** Form UUID */
  id?: string | null;
  /** Last sent timestamp */
  last_sent_at?: string | null;
  /** Organization ID if org-scoped */
  organization_id?: string | null;
  /** Ownership scope */
  owner_scope: FormOwnerScope;
  /** Parent form ID for cloned forms */
  parent_form_id?: string | null;
  /** Provider ID who owns the form */
  provider_id: string;
  /** Total number of times sent */
  sends_total?: number;
  /** Last update timestamp */
  updated_at?: string | null;
  /** User ID who owns the form (dual-write with provider_id) */
  user_id?: string | null;
};
export type ProviderFormCounter = {
  /** Number of completions by this provider */
  completions_total?: number;
  /** Form UUID */
  form_id: string;
  /** Last sent timestamp by this provider */
  last_sent?: string | null;
  /** Provider ID */
  provider_id: string;
  /** Number of times sent by this provider */
  sends_total?: number;
};
export type FormWithRevision = {
  current_revision?: FormRevision | null;
  form: Form;
  /** Provider-specific usage stats */
  provider_usage?: ProviderFormCounter | null;
};
export type FormResponse = {
  form: FormWithRevision;
};
export type GradingMatrixSchema = {
  /** Fields that are graded */
  graded_fields: string[];
  /** Score ranges and interpretations */
  ranges: {
    [key: string]: any;
  }[];
};
export type FormFieldOptionSchema = {
  /** Optional help text for the option */
  help_text?: string | null;
  /** Display label for the option */
  label: string;
  /** Value of the option */
  value: string | number;
};
export type FormFieldSchema = {
  /** Conditional display rules */
  conditional?: {
    [key: string]: any;
  } | null;
  /** Help text to display with the field */
  help_text?: string | null;
  /** Unique identifier for the field */
  id: string;
  /** Display label for the field */
  label: string;
  /** Number of points in likert scale (e.g., 5 for 1-5 scale) */
  likert_scale?: number | null;
  /** Maximum value for number fields */
  max_value?: number | number | null;
  /** Minimum value for number fields */
  min_value?: number | number | null;
  /** Options for select, radio, checkbox, or likert fields */
  options?: (string | FormFieldOptionSchema)[] | null;
  /** Placeholder text for input fields */
  placeholder?: string | null;
  /** Whether this field is required */
  required?: boolean;
  /** Number of rows for long_text fields */
  rows?: number | null;
  /** Field type (must be a valid FieldType) */
  type: string;
  /** Validation rules for the field */
  validation?: {
    [key: string]: any;
  } | null;
};
export type FormSectionSchema = {
  /** Whether section can be collapsed */
  collapsible?: boolean | null;
  /** Section description or instructions */
  description?: string | null;
  /** Fields in this section */
  fields: FormFieldSchema[];
  /** Optional section ID */
  id?: string | null;
  /** Whether section starts collapsed */
  initially_collapsed?: boolean | null;
  /** Section title (optional) */
  title?: string | null;
};
export type FormGroupSchema = {
  /** Group description or instructions */
  description?: string | null;
  /** Optional group ID */
  id?: string | null;
  /** Page number if form is paginated */
  page_number?: number | null;
  /** Sections in this group */
  sections: FormSectionSchema[];
  /** Group title (optional) */
  title?: string | null;
};
export type FormBodySchema = {
  /** Form description (if included in body) */
  description?: string | null;
  /** Type of form (e.g., 'standard', 'test') */
  form_type: string;
  /** Scoring matrix for test-type forms */
  grading_matrix?: GradingMatrixSchema | null;
  /** Groups of form sections */
  groups: FormGroupSchema[];
  /** ID of associated patient module for test forms */
  patient_module_id?: string | null;
  /** Form title (if included in body) */
  title?: string | null;
  [key: string]: any;
};
export type AdminCreateFormRequest = {
  /** Form body structure with groups, sections, and fields */
  body: FormBodySchema;
  /** Form description */
  description?: string | null;
  /** Type of form (standard/test) */
  form_type: string;
  /** Form tags */
  tags?: string[];
  /** Form title */
  title: string;
};
export type AppointmentInfoResponse = {
  /** Appointment identifier */
  appointment_id: string;
  /** Appointment display color */
  color?: string | null;
  /** Appointment duration in minutes */
  duration?: number | null;
  /** Encounter type name */
  encounter_type?: string | null;
  /** Appointment start time */
  start_time?: string | null;
  /** Appointment status */
  status?: string | null;
  /** Whether appointment is telehealth */
  telehealth?: boolean;
  /** Appointment title */
  title?: string | null;
};
export type CanonicalServiceTypeBillingCodeResponse = {
  /** Billing code identifier */
  code_id: string;
  /** Billing code description */
  description?: string | null;
  /** True when this code is an add-on */
  is_add_on?: boolean;
};
export type CanonicalServiceTypeResponse = {
  /** Canonical service type identifier */
  canonical_service_type_id: string;
  /** Display description */
  description?: string | null;
  /** Display name */
  name: string;
  /** Owning organization for org-scoped types */
  organization_id?: string | null;
  /** Ownership scope (public or org) */
  owner_scope: string;
  /** Parent canonical service type for org overrides */
  parent_service_type_id?: string | null;
  /** Associated rule pack identifiers */
  rule_pack_ids?: string[];
  /** Selection guidance */
  select_when: string;
  /** Canonical service type slug */
  slug: string;
  /** Lifecycle state */
  state: string;
  /** Typical default billing codes */
  typical_billing_codes?: CanonicalServiceTypeBillingCodeResponse[];
};
export type CptAnalysisInfo = {
  /** Whether CPT analysis was actually performed */
  cpt_analysis_performed?: boolean;
  /** Whether target codes match recommended codes */
  cpt_match?: boolean;
  /** CPT codes originally selected by the provider */
  provider_cpt_codes?: string[] | null;
  /** AI-recommended CPT codes based on documentation */
  recommended_cpt_codes?: string[] | null;
  /** CPT codes used for rule selection and evaluation */
  target_cpt_codes?: string[];
  /** Source of target codes: 'user' (from encounter) or 'ai' (recommended) */
  target_cpt_source?: string | null;
};
export type PatientInfoResponse = {
  /** Date of birth (YYYY-MM-DD) */
  dob?: string | null;
  /** Patient email address */
  email?: string | null;
  /** Patient first name */
  first_name?: string | null;
  /** Patient gender */
  gender?: string | null;
  /** Patient last name */
  last_name?: string | null;
  /** Patient mobile phone */
  mobile_phone?: string | null;
  /** Patient identifier */
  patient_id: string;
  /** Patient preferred name */
  preferred_name?: string | null;
  /** Patient pronouns */
  pronouns?: string | null;
};
export type EncounterAuditSummaryResponse = {
  /** Full appointment information */
  appointment?: AppointmentInfoResponse | null;
  /** Associated appointment ID */
  appointment_id?: string | null;
  /** Resolved canonical service type details */
  canonical_service_type?: CanonicalServiceTypeResponse | null;
  /** Canonical service type slug from encounter analysis */
  canonical_service_type_slug?: string | null;
  /** Detailed CPT analysis from the most recent audit revision */
  cpt_analysis?: CptAnalysisInfo | null;
  /** Encounter identifier */
  encounter_id: string;
  /** Whether audit exists */
  has_audit?: boolean;
  /** Whether the main note has been signed */
  is_signed?: boolean;
  /** When most recent audit was performed */
  last_audit_at?: string | null;
  /** Most recent compliance percentage (0-100) */
  latest_compliance_pct?: number | null;
  /** Most recent CPT match status */
  latest_cpt_match?: boolean | null;
  /** Most recent quality score (1-5) */
  latest_quality_score?: number | null;
  /** Encounter modality: in_person, video, audio */
  modality?: string | null;
  /** Main note ID from encounter */
  note_id?: string | null;
  /** Full patient information */
  patient?: PatientInfoResponse | null;
  /** Patient ID if available */
  patient_id?: string | null;
  /** Patient display name */
  patient_name?: string | null;
  /** Provider display name */
  provider_name?: string | null;
  /** When encounter was scheduled */
  scheduled_for?: string | null;
  /** Session type information from analysis */
  session_type?: {
    [key: string]: any;
  } | null;
  /** Encounter status: pending, processing, completed */
  status: string;
  /** Brief summary from encounter analysis */
  summary?: string | null;
  /** Provider ID */
  user_id: string;
};
export type EncounterAuditListResponse = {
  encounters?: EncounterAuditSummaryResponse[];
  /** Whether more pages exist */
  has_more?: boolean;
  /** Current page number */
  page?: number;
  /** Items per page */
  per_page?: number;
  /** Total number of encounters */
  total?: number;
};
export type AppointmentInfoResponse2 = {
  /** Appointment identifier */
  appointment_id: string;
  /** Appointment display color */
  color?: string | null;
  /** Appointment duration in minutes */
  duration?: number | null;
  /** Encounter type name */
  encounter_type?: string | null;
  /** Appointment start time */
  start_time?: string | null;
  /** Appointment status */
  status?: string | null;
  /** Whether appointment is telehealth */
  telehealth?: boolean;
  /** Appointment title */
  title?: string | null;
};
export type CanonicalServiceTypeBillingCodeResponse2 = {
  /** Billing code identifier */
  code_id: string;
  /** Billing code description */
  description?: string | null;
  /** True when this code is an add-on */
  is_add_on?: boolean;
};
export type CanonicalServiceTypeResponse2 = {
  /** Canonical service type identifier */
  canonical_service_type_id: string;
  /** Display description */
  description?: string | null;
  /** Display name */
  name: string;
  /** Owning organization for org-scoped types */
  organization_id?: string | null;
  /** Ownership scope (public or org) */
  owner_scope: string;
  /** Parent canonical service type for org overrides */
  parent_service_type_id?: string | null;
  /** Associated rule pack identifiers */
  rule_pack_ids?: string[];
  /** Selection guidance */
  select_when: string;
  /** Canonical service type slug */
  slug: string;
  /** Lifecycle state */
  state: string;
  /** Typical default billing codes */
  typical_billing_codes?: CanonicalServiceTypeBillingCodeResponse2[];
};
export type NoteAuditSummaryResponse = {
  /** When note was first completed */
  completed_at?: string | null;
  compliance_improvement?: number | null;
  current_revision?: number;
  encounter_id?: string | null;
  first_audit_at: string;
  /** Whether note was completed when audited */
  is_completed?: boolean;
  last_audit_at: string;
  latest_compliance_pct?: number | null;
  latest_cpt_match?: boolean;
  latest_quality_score?: number | null;
  /** Status of the current revision for incremental saves */
  latest_status?: string;
  note_audit_id: string;
  note_id: string;
  /** Note title if available */
  note_title?: string | null;
  /** Patient ID if available */
  patient_id?: string | null;
  /** Patient display name */
  patient_name?: string | null;
  /** Provider display name */
  provider_name?: string | null;
  quality_improvement?: number | null;
  total_revisions?: number;
  user_id: string;
  /** Whether audit was generated while user was within addon quota */
  within_quota?: boolean;
};
export type AuditRevisionDetailResponse = {
  /** Full audit data including rule_compliance_assessments, flags, questions, etc. */
  audit_data?: {
    [key: string]: any;
  };
  compliance_delta?: number | null;
  compliance_percentage?: number | null;
  cpt_analysis_performed?: boolean;
  cpt_match?: boolean;
  created_at: string;
  overall_quality_score?: number | null;
  provider_cpt_codes?: string[] | null;
  quality_delta?: number | null;
  recommended_cpt_codes?: string[] | null;
  revision: number;
  rules_compliant?: number;
  rules_non_compliant?: number;
  rules_warning?: number;
  /** Revision status (in_progress, compliance_complete, completed) */
  status?: string;
  /** CPT codes used for rule selection and evaluation */
  target_cpt_codes?: string[] | null;
  /** Source of target codes: 'user' (from encounter) or 'ai' (recommended) */
  target_cpt_source?: string | null;
  trigger: string;
};
export type TemplateInfoResponse = {
  /** Current published version */
  current_version: number;
  /** Template description */
  description?: string | null;
  /** Processing version: 1 for v1 flow, 2 for v2 flow */
  note_processing_version?: number;
  /** Template organization ID */
  organization_id?: string | null;
  /** Owner scope (public, org, user) */
  owner_scope: string;
  /** Template UUID */
  template_id: string;
  /** Template title */
  title: string;
  /** User ID who owns the template */
  user_id: string;
};
export type NoteAuditDetailResponse = {
  audit: NoteAuditSummaryResponse;
  current_revision?: AuditRevisionDetailResponse | null;
  /** Patient display name */
  patient_name?: string | null;
  /** Provider display name */
  provider_name?: string | null;
  /** Template used to generate the note */
  template?: TemplateInfoResponse | null;
};
export type PatientInfoResponse2 = {
  /** Date of birth (YYYY-MM-DD) */
  dob?: string | null;
  /** Patient email address */
  email?: string | null;
  /** Patient first name */
  first_name?: string | null;
  /** Patient gender */
  gender?: string | null;
  /** Patient last name */
  last_name?: string | null;
  /** Patient mobile phone */
  mobile_phone?: string | null;
  /** Patient identifier */
  patient_id: string;
  /** Patient preferred name */
  preferred_name?: string | null;
  /** Patient pronouns */
  pronouns?: string | null;
};
export type EncounterAuditDetailResponse = {
  /** When analysis was performed */
  analyzed_at?: string | null;
  /** Full appointment information */
  appointment?: AppointmentInfoResponse2 | null;
  /** Associated appointment ID */
  appointment_id?: string | null;
  /** Resolved canonical service type details */
  canonical_service_type?: CanonicalServiceTypeResponse2 | null;
  /** Canonical service type slug from encounter analysis */
  canonical_service_type_slug?: string | null;
  /** CPT codes on encounter */
  cpt_codes?: string[];
  /** Full encounter analysis data (summary, modality, participants, etc.) */
  encounter_analysis?: {
    [key: string]: any;
  } | null;
  /** Encounter identifier */
  encounter_id: string;
  /** ICD-10 codes on encounter */
  icd10_codes?: string[];
  /** Encounter modality: in_person, video, audio */
  modality?: string | null;
  /** All audits for notes in this encounter */
  note_audits?: NoteAuditDetailResponse[];
  /** Full patient information */
  patient?: PatientInfoResponse2 | null;
  /** Patient ID if available */
  patient_id?: string | null;
  /** Patient display name */
  patient_name?: string | null;
  /** Provider display name */
  provider_name?: string | null;
  /** When encounter was scheduled */
  scheduled_for?: string | null;
  /** Encounter status: pending, processing, completed */
  status: string;
  /** Provider ID */
  user_id: string;
};
export type NoteAuditSummaryResponse2 = {
  /** When note was first completed */
  completed_at?: string | null;
  compliance_improvement?: number | null;
  current_revision?: number;
  encounter_id?: string | null;
  first_audit_at: string;
  /** Whether note was completed when audited */
  is_completed?: boolean;
  last_audit_at: string;
  latest_compliance_pct?: number | null;
  latest_cpt_match?: boolean;
  latest_quality_score?: number | null;
  /** Status of the current revision for incremental saves */
  latest_status?: string;
  note_audit_id: string;
  note_id: string;
  /** Note title if available */
  note_title?: string | null;
  /** Patient ID if available */
  patient_id?: string | null;
  /** Patient display name */
  patient_name?: string | null;
  /** Provider display name */
  provider_name?: string | null;
  quality_improvement?: number | null;
  total_revisions?: number;
  user_id: string;
  /** Whether audit was generated while user was within addon quota */
  within_quota?: boolean;
};
export type AuditRevisionDetailResponse2 = {
  /** Full audit data including rule_compliance_assessments, flags, questions, etc. */
  audit_data?: {
    [key: string]: any;
  };
  compliance_delta?: number | null;
  compliance_percentage?: number | null;
  cpt_analysis_performed?: boolean;
  cpt_match?: boolean;
  created_at: string;
  overall_quality_score?: number | null;
  provider_cpt_codes?: string[] | null;
  quality_delta?: number | null;
  recommended_cpt_codes?: string[] | null;
  revision: number;
  rules_compliant?: number;
  rules_non_compliant?: number;
  rules_warning?: number;
  /** Revision status (in_progress, compliance_complete, completed) */
  status?: string;
  /** CPT codes used for rule selection and evaluation */
  target_cpt_codes?: string[] | null;
  /** Source of target codes: 'user' (from encounter) or 'ai' (recommended) */
  target_cpt_source?: string | null;
  trigger: string;
};
export type TemplateInfoResponse2 = {
  /** Current published version */
  current_version: number;
  /** Template description */
  description?: string | null;
  /** Processing version: 1 for v1 flow, 2 for v2 flow */
  note_processing_version?: number;
  /** Template organization ID */
  organization_id?: string | null;
  /** Owner scope (public, org, user) */
  owner_scope: string;
  /** Template UUID */
  template_id: string;
  /** Template title */
  title: string;
  /** User ID who owns the template */
  user_id: string;
};
export type NoteAuditDetailResponse2 = {
  audit: NoteAuditSummaryResponse2;
  current_revision?: AuditRevisionDetailResponse2 | null;
  /** Patient display name */
  patient_name?: string | null;
  /** Provider display name */
  provider_name?: string | null;
  /** Template used to generate the note */
  template?: TemplateInfoResponse2 | null;
};
export type NoteAuditListResponse = {
  audits?: NoteAuditDetailResponse2[];
  has_more?: boolean;
  page?: number;
  per_page?: number;
  total?: number;
};
export type NoteAuditSummaryResponse3 = {
  /** When note was first completed */
  completed_at?: string | null;
  compliance_improvement?: number | null;
  current_revision?: number;
  encounter_id?: string | null;
  first_audit_at: string;
  /** Whether note was completed when audited */
  is_completed?: boolean;
  last_audit_at: string;
  latest_compliance_pct?: number | null;
  latest_cpt_match?: boolean;
  latest_quality_score?: number | null;
  /** Status of the current revision for incremental saves */
  latest_status?: string;
  note_audit_id: string;
  note_id: string;
  /** Note title if available */
  note_title?: string | null;
  /** Patient ID if available */
  patient_id?: string | null;
  /** Patient display name */
  patient_name?: string | null;
  /** Provider display name */
  provider_name?: string | null;
  quality_improvement?: number | null;
  total_revisions?: number;
  user_id: string;
  /** Whether audit was generated while user was within addon quota */
  within_quota?: boolean;
};
export type AuditRevisionDetailResponse3 = {
  /** Full audit data including rule_compliance_assessments, flags, questions, etc. */
  audit_data?: {
    [key: string]: any;
  };
  compliance_delta?: number | null;
  compliance_percentage?: number | null;
  cpt_analysis_performed?: boolean;
  cpt_match?: boolean;
  created_at: string;
  overall_quality_score?: number | null;
  provider_cpt_codes?: string[] | null;
  quality_delta?: number | null;
  recommended_cpt_codes?: string[] | null;
  revision: number;
  rules_compliant?: number;
  rules_non_compliant?: number;
  rules_warning?: number;
  /** Revision status (in_progress, compliance_complete, completed) */
  status?: string;
  /** CPT codes used for rule selection and evaluation */
  target_cpt_codes?: string[] | null;
  /** Source of target codes: 'user' (from encounter) or 'ai' (recommended) */
  target_cpt_source?: string | null;
  trigger: string;
};
export type TemplateInfoResponse3 = {
  /** Current published version */
  current_version: number;
  /** Template description */
  description?: string | null;
  /** Processing version: 1 for v1 flow, 2 for v2 flow */
  note_processing_version?: number;
  /** Template organization ID */
  organization_id?: string | null;
  /** Owner scope (public, org, user) */
  owner_scope: string;
  /** Template UUID */
  template_id: string;
  /** Template title */
  title: string;
  /** User ID who owns the template */
  user_id: string;
};
export type NoteAuditDetailResponse3 = {
  audit: NoteAuditSummaryResponse3;
  current_revision?: AuditRevisionDetailResponse3 | null;
  /** Patient display name */
  patient_name?: string | null;
  /** Provider display name */
  provider_name?: string | null;
  /** Template used to generate the note */
  template?: TemplateInfoResponse3 | null;
};
export type AuditRevisionSummaryResponse = {
  compliance_percentage?: number | null;
  cpt_analysis_performed?: boolean;
  cpt_match?: boolean;
  created_at: string;
  overall_quality_score?: number | null;
  /** Change from previous revision */
  quality_delta?: number | null;
  recommended_cpt_codes?: string[] | null;
  /** Revision number */
  revision: number;
  /** Revision status (in_progress, compliance_complete, completed) */
  status?: string;
  /** CPT codes used for rule selection and evaluation */
  target_cpt_codes?: string[] | null;
  /** Source of target codes: 'user' (from encounter) or 'ai' (recommended) */
  target_cpt_source?: string | null;
  /** What triggered this audit */
  trigger: string;
};
export type RevisionHistoryResponse = {
  note_id: string;
  revisions?: AuditRevisionSummaryResponse[];
};
export type AuditRevisionDetailResponse4 = {
  /** Full audit data including rule_compliance_assessments, flags, questions, etc. */
  audit_data?: {
    [key: string]: any;
  };
  compliance_delta?: number | null;
  compliance_percentage?: number | null;
  cpt_analysis_performed?: boolean;
  cpt_match?: boolean;
  created_at: string;
  overall_quality_score?: number | null;
  provider_cpt_codes?: string[] | null;
  quality_delta?: number | null;
  recommended_cpt_codes?: string[] | null;
  revision: number;
  rules_compliant?: number;
  rules_non_compliant?: number;
  rules_warning?: number;
  /** Revision status (in_progress, compliance_complete, completed) */
  status?: string;
  /** CPT codes used for rule selection and evaluation */
  target_cpt_codes?: string[] | null;
  /** Source of target codes: 'user' (from encounter) or 'ai' (recommended) */
  target_cpt_source?: string | null;
  trigger: string;
};
export type OrganizationSummaryResponse = {
  avg_compliance_pct?: number | null;
  avg_quality_score?: number | null;
  cpt_match_rate?: number | null;
  notes_clean?: number;
  organization_id: string;
  /** Organization display name */
  organization_name?: string | null;
  total_notes_audited?: number;
  total_providers?: number;
};
export type OrganizationListResponse = {
  has_more?: boolean;
  organizations?: OrganizationSummaryResponse[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type ProviderSummaryResponse = {
  avg_quality_score?: number | null;
  /** Avg seconds between first audit and completion */
  avg_time_to_submit_seconds?: number | null;
  compliance_percentage?: number | null;
  compliance_trend?: string | null;
  cpt_accuracy_pct?: number | null;
  notes_clean?: number;
  notes_this_period?: number;
  provider_name?: string | null;
  quality_trend?: string | null;
  /** Notes that have been completed/signed */
  signed_count?: number;
  total_notes_audited?: number;
  /** Notes not yet completed/signed */
  unsigned_count?: number;
  user_id: string;
};
export type ProviderListResponse = {
  providers?: ProviderSummaryResponse[];
  total?: number;
};
export type ProviderSummaryResponse2 = {
  avg_quality_score?: number | null;
  /** Avg seconds between first audit and completion */
  avg_time_to_submit_seconds?: number | null;
  compliance_percentage?: number | null;
  compliance_trend?: string | null;
  cpt_accuracy_pct?: number | null;
  notes_clean?: number;
  notes_this_period?: number;
  provider_name?: string | null;
  quality_trend?: string | null;
  /** Notes that have been completed/signed */
  signed_count?: number;
  total_notes_audited?: number;
  /** Notes not yet completed/signed */
  unsigned_count?: number;
  user_id: string;
};
export type RuleComplianceStatsResponse = {
  /** % compliant (0-100) */
  compliance_rate?: number;
  /** Audits where compliant */
  compliant_count?: number;
  /** True if the rule has been soft-deleted (historical data only) */
  is_deleted?: boolean;
  /** True if the rule is disabled for the organization (not active) */
  is_disabled?: boolean;
  /** Audits that violated */
  non_compliant_count?: number;
  /** Rule identifier */
  rule_id: string;
  /** Rule display name */
  rule_name?: string | null;
  /** Audits that evaluated this rule */
  total_audits?: number;
  /** % violated (0-100) */
  violation_rate?: number;
  /** Audits with warnings */
  warning_count?: number;
};
export type ProviderRuleComplianceResponse = {
  /** Provider display name */
  provider_name?: string | null;
  rules?: RuleComplianceStatsResponse[];
  /** Provider ID */
  user_id: string;
};
export type RuleComplianceStatsListResponse = {
  /** Per-provider breakdown (only in comparison_mode) */
  by_provider?: ProviderRuleComplianceResponse[] | null;
  /** Rule with highest compliance rate */
  most_compliant_rule?: RuleComplianceStatsResponse | null;
  /** Rule with highest violation rate */
  most_violated_rule?: RuleComplianceStatsResponse | null;
  /** Filter period in days */
  period_days?: number | null;
  rules?: RuleComplianceStatsResponse[];
  /** Total rules with stats */
  total_rules?: number;
};
export type RuleAuditItemResponse = {
  /** When audit was performed */
  audited_at: string;
  /** Compliance status for this rule: 'yes', 'warning', 'no' */
  compliance_status: string;
  /** Audit ID */
  note_audit_id: string;
  /** Note ID */
  note_id: string;
  /** Note title */
  note_title?: string | null;
  /** Patient display name */
  patient_name?: string | null;
  /** Provider display name */
  provider_name?: string | null;
  /** LLM reasoning for the assessment */
  reasoning?: string | null;
  /** Revision number */
  revision: number;
  /** Provider ID */
  user_id: string;
};
export type RuleAuditsListResponse = {
  audits?: RuleAuditItemResponse[];
  has_more?: boolean;
  page?: number;
  per_page?: number;
  /** Rule identifier */
  rule_id: string;
  /** Rule display name */
  rule_name?: string | null;
  total?: number;
};
export type AuditRevisionDetailResponse5 = {
  /** Full audit data including rule_compliance_assessments, flags, questions, etc. */
  audit_data?: {
    [key: string]: any;
  };
  compliance_delta?: number | null;
  compliance_percentage?: number | null;
  cpt_analysis_performed?: boolean;
  cpt_match?: boolean;
  created_at: string;
  overall_quality_score?: number | null;
  provider_cpt_codes?: string[] | null;
  quality_delta?: number | null;
  recommended_cpt_codes?: string[] | null;
  revision: number;
  rules_compliant?: number;
  rules_non_compliant?: number;
  rules_warning?: number;
  /** Revision status (in_progress, compliance_complete, completed) */
  status?: string;
  /** CPT codes used for rule selection and evaluation */
  target_cpt_codes?: string[] | null;
  /** Source of target codes: 'user' (from encounter) or 'ai' (recommended) */
  target_cpt_source?: string | null;
  trigger: string;
};
export type AuditsByRuleResponse = {
  has_more?: boolean;
  page?: number;
  per_page?: number;
  revisions?: AuditRevisionDetailResponse5[];
  rule_id: string;
  total?: number;
};
export type ProviderRuleBreakdown = {
  /** % compliant (0-100) */
  compliance_rate?: number;
  compliant_count?: number;
  non_compliant_count?: number;
  /** Provider display name */
  provider_name?: string | null;
  total_audits?: number;
  /** Provider ID */
  user_id: string;
  warning_count?: number;
};
export type RuleComplianceStatsResponse2 = {
  /** % compliant (0-100) */
  compliance_rate?: number;
  /** Audits where compliant */
  compliant_count?: number;
  /** True if the rule has been soft-deleted (historical data only) */
  is_deleted?: boolean;
  /** True if the rule is disabled for the organization (not active) */
  is_disabled?: boolean;
  /** Audits that violated */
  non_compliant_count?: number;
  /** Rule identifier */
  rule_id: string;
  /** Rule display name */
  rule_name?: string | null;
  /** Audits that evaluated this rule */
  total_audits?: number;
  /** % violated (0-100) */
  violation_rate?: number;
  /** Audits with warnings */
  warning_count?: number;
};
export type RuleTrendDataPoint = {
  /** % compliant (0-100) */
  compliance_rate?: number;
  compliant_count?: number;
  non_compliant_count?: number;
  /** Period label (e.g., '2025-01-01' or '2025-W01') */
  period: string;
  total_audits?: number;
  warning_count?: number;
};
export type RuleDetailStatsResponse = {
  /** Stats per provider */
  by_provider?: ProviderRuleBreakdown[];
  /** Aggregated stats for this rule */
  overall: RuleComplianceStatsResponse2;
  /** Full rule content (markdown) */
  rule_body_md?: string | null;
  /** Rule identifier */
  rule_id: string;
  /** Rule display name */
  rule_name?: string | null;
  /** Compliance over time */
  trend?: RuleTrendDataPoint[];
  /** 'daily', 'weekly', or 'monthly' */
  trend_granularity?: string;
};
export type QualityDistributionResponse = {
  /** Count with score 1 */
  score_1?: number;
  /** Count with score 2 */
  score_2?: number;
  /** Count with score 3 */
  score_3?: number;
  /** Count with score 4 */
  score_4?: number;
  /** Count with score 5 */
  score_5?: number;
};
export type GlobalDashboardStatsResponse = {
  avg_compliance_pct?: number | null;
  avg_quality_improvement?: number | null;
  avg_quality_score?: number | null;
  cpt_match_rate?: number | null;
  notes_clean?: number;
  period_days?: number;
  quality_distribution?: QualityDistributionResponse;
  total_notes_audited?: number;
  total_organizations?: number;
  total_revenue_delta_cents?: number;
  total_revisions?: number;
};
export type QualityDistributionResponse2 = {
  /** Count with score 1 */
  score_1?: number;
  /** Count with score 2 */
  score_2?: number;
  /** Count with score 3 */
  score_3?: number;
  /** Count with score 4 */
  score_4?: number;
  /** Count with score 5 */
  score_5?: number;
};
export type OrgDashboardStatsResponse = {
  avg_compliance_pct?: number | null;
  avg_quality_improvement?: number | null;
  avg_quality_score?: number | null;
  cpt_match_rate?: number | null;
  notes_clean?: number;
  organization_id: string;
  period_days?: number;
  quality_distribution?: QualityDistributionResponse2;
  total_notes_audited?: number;
  total_revenue_delta_cents?: number;
  total_revisions?: number;
};
export type RunAuditResponse = {
  /** Task status (queued) */
  status: string;
  /** Celery task ID */
  task_id: string;
  /** Thread ID for state tracking */
  thread_id: string;
  /** Workflow name */
  workflow_name: string;
};
export type RunAuditRequest = {
  /** Note ID to audit */
  note_id: string;
  /** Organization ID (defaults to note's organization if not provided) */
  organization_id?: string | null;
};
export type RuleComplianceItem = {
  /** Compliance status: yes, warning, no */
  compliant: string;
  /** Reason for the compliance status */
  reason: string;
  /** Section IDs if applicable */
  relevant_sections?: string[] | null;
  /** Rule identifier */
  rule_id: string;
  /** Title of the rule for display purposes */
  rule_title?: string | null;
  /** Actionable suggestion (3-8 words) for fixing the issue. Only present for 'warning' or 'no' compliance. */
  suggestion?: string | null;
};
export type AuditStatusResponse = {
  /** Compliance percentage (available when completed) */
  compliance_percentage?: number | null;
  /** Note being audited */
  note_id?: string | null;
  /** Quality score 1-5 (available when completed) */
  overall_quality_score?: number | null;
  /** Per-rule compliance assessments */
  rule_compliance_assessments?: RuleComplianceItem[];
  /** Rule IDs used for audit */
  selected_rule_ids?: string[];
  /** Workflow status: pending, validated, compliance_evaluated, completed, error */
  status: string;
  /** Thread ID */
  thread_id: string;
  /** Whether audit was generated while user was within addon quota */
  within_quota?: boolean;
};
export type AdminBasicResponse = {
  ok?: boolean;
};
export type AdminActionItem = {
  /** Category: blocked or soon */
  category: string;
  /** What the provider needs to do */
  what: string;
  /** Why this action is needed */
  why: string;
};
export type SetActionItemsRequest = {
  /** List of action items for the provider */
  action_items: AdminActionItem[];
};
export type UpdatePayerApplicationRequest = {
  blockers?: string | null;
  confirmation_number?: string | null;
  effective_date?: string | null;
  eft_setup?: boolean | null;
  era_setup?: boolean | null;
  last_follow_up?: string | null;
  next_follow_up?: string | null;
  notes?: string | null;
  provider_payer_id?: string | null;
  status?: string | null;
  submitted_date?: string | null;
};
export type ListResponse = {
  items: any[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type LearningRuleDocument = {
  /** Succinct explanation of why this matters clinically */
  clinical_rationale: string;
  /** Organization ID that owns this rule (can be 'global') */
  organization_id: string;
  /** Specific clinician-facing actions, reflections, or options to consider when this guidance applies */
  recommended_actions: string;
  /** Concise paragraph describing populations, diagnoses, modalities, symptoms, settings, and key phrases that signal when this learning rule matters */
  relevant_context: string;
  /** Unique stable identifier for the rule */
  rule_id: string;
  /** Formatted citation string if available */
  source_citation?: string | null;
  /** Publication year or full date as YYYY or YYYY-MM-DD if known */
  source_date?: string | null;
  /** Primary source title or identifier */
  source_document?: string | null;
  /** Clickable URL to the source (e.g., DOI link) or null */
  source_link?: string | null;
  /** 2-4 sentence, high-yield summary of the key takeaway for clinicians */
  teaching_summary: string;
  /** Human-readable title of the learning rule */
  title: string;
  /** Type of rule (always 'learning') */
  type?: string;
  /** ISO timestamp of last update */
  updated_at?: string | null;
  /** User ID who last updated this rule */
  updated_by?: string | null;
  /** Clinician-facing guidance for when this learning should be applied */
  when_to_follow: string;
};
export type LearningRuleResponse = {
  /** Learning rule document */
  rule: LearningRuleDocument;
  /** Rule ID */
  rule_id: string;
  /** Last update timestamp */
  updated_at?: string | null;
};
export type LearningRuleDocument2 = {
  /** Succinct explanation of why this matters clinically */
  clinical_rationale: string;
  /** Organization ID that owns this rule (can be 'global') */
  organization_id: string;
  /** Specific clinician-facing actions, reflections, or options to consider when this guidance applies */
  recommended_actions: string;
  /** Concise paragraph describing populations, diagnoses, modalities, symptoms, settings, and key phrases that signal when this learning rule matters */
  relevant_context: string;
  /** Unique stable identifier for the rule */
  rule_id: string;
  /** Formatted citation string if available */
  source_citation?: string | null;
  /** Publication year or full date as YYYY or YYYY-MM-DD if known */
  source_date?: string | null;
  /** Primary source title or identifier */
  source_document?: string | null;
  /** Clickable URL to the source (e.g., DOI link) or null */
  source_link?: string | null;
  /** 2-4 sentence, high-yield summary of the key takeaway for clinicians */
  teaching_summary: string;
  /** Human-readable title of the learning rule */
  title: string;
  /** Type of rule (always 'learning') */
  type?: string;
  /** ISO timestamp of last update */
  updated_at?: string | null;
  /** User ID who last updated this rule */
  updated_by?: string | null;
  /** Clinician-facing guidance for when this learning should be applied */
  when_to_follow: string;
};
export type CreateLearningRuleRequest = {
  /** Learning rule document to create */
  rule: LearningRuleDocument2;
  /** User ID making this update */
  updated_by?: string | null;
};
export type LearningRuleSearchResponse = {
  /** The original search query */
  query: string;
  /** Search results */
  results?: {
    [key: string]: any;
  }[];
  /** Total number of results returned */
  total_results: number;
};
export type LearningRuleSearchRequest = {
  /** Search query text */
  query: string;
  /** Number of top results to return */
  top_k?: number;
};
export type LearningRuleNotFoundResponse = {
  /** Error message */
  error: string;
  /** Organization ID */
  org_id?: string | null;
  /** Rule ID */
  rule_id: string;
};
export type LearningRuleDocument3 = {
  /** Succinct explanation of why this matters clinically */
  clinical_rationale: string;
  /** Organization ID that owns this rule (can be 'global') */
  organization_id: string;
  /** Specific clinician-facing actions, reflections, or options to consider when this guidance applies */
  recommended_actions: string;
  /** Concise paragraph describing populations, diagnoses, modalities, symptoms, settings, and key phrases that signal when this learning rule matters */
  relevant_context: string;
  /** Unique stable identifier for the rule */
  rule_id: string;
  /** Formatted citation string if available */
  source_citation?: string | null;
  /** Publication year or full date as YYYY or YYYY-MM-DD if known */
  source_date?: string | null;
  /** Primary source title or identifier */
  source_document?: string | null;
  /** Clickable URL to the source (e.g., DOI link) or null */
  source_link?: string | null;
  /** 2-4 sentence, high-yield summary of the key takeaway for clinicians */
  teaching_summary: string;
  /** Human-readable title of the learning rule */
  title: string;
  /** Type of rule (always 'learning') */
  type?: string;
  /** ISO timestamp of last update */
  updated_at?: string | null;
  /** User ID who last updated this rule */
  updated_by?: string | null;
  /** Clinician-facing guidance for when this learning should be applied */
  when_to_follow: string;
};
export type UpdateLearningRuleRequest = {
  /** Updated learning rule document */
  rule: LearningRuleDocument3;
  /** User ID making this update */
  updated_by?: string | null;
};
export type RecoveryTaskResponse = {
  /** Sessions that failed to retry */
  failed_sessions: number;
  /** Sessions that were retried */
  retried_sessions: number;
  /** Sessions skipped (already processed) */
  skipped_sessions?: number;
  /** Sessions successfully retried */
  successful_sessions: number;
  /** Type of recovery task */
  task_type: string;
  /** Total sessions found */
  total_sessions: number;
};
export type RecoveryTaskRequest = {
  /** Maximum sessions to process (default: 250 for stuck, 200 for errored) */
  limit?: number | null;
  /** Maximum age in hours (default: 72 for stuck, 3 for errored) */
  max_age_hours?: number | null;
  /** Minimum age in hours for stuck sessions (default: 2) */
  min_age_hours?: number | null;
};
export type AdminAppointmentSummary2 = {
  appointment_id: string;
  duration?: number | null;
  encounter_type?: string | null;
  encounter_type_id?: string | null;
  start_time?: string | null;
  status?: string | null;
  telehealth?: boolean | null;
  title?: string | null;
};
export type AdminEncounterSummary2 = {
  appointment_id?: string | null;
  created_at?: string | null;
  encounter_id: string;
  encounter_type?: string | null;
  input_documents?: number | null;
  patient_id?: string | null;
  status?: string | null;
  updated_at?: string | null;
};
export type AdminNoteSummary3 = {
  created_at?: string | null;
  encounter_type?: string | null;
  has_feedback?: boolean | null;
  note_id: string;
  patient_id?: string | null;
  patient_name?: string | null;
  status?: string | null;
  template?: string | null;
};
export type AdminNoteProcessingSessionDetail = {
  created_at?: string | null;
  encounter_id?: string | null;
  note_id?: string | null;
  note_processing_session_id: string;
  provider_id?: string | null;
  status?: string | null;
  transcription_session_id?: string | null;
  transcription_session_ids?: string[] | null;
  updated_at?: string | null;
};
export type AdminProviderSummary3 = {
  email?: string | null;
  last_login_time?: string | null;
  name?: string | null;
  organization_id?: string | null;
  organization_name?: string | null;
  provider_id: string;
  role?: string | null;
};
export type AdminTranscriptionSummary3 = {
  chunk_count?: number | null;
  created_at?: string | null;
  is_closed?: boolean | null;
  job_status?: string | null;
  notes_created?: number | null;
  start_time?: string | null;
  transcription_session_id: string;
};
export type AdminNoteProcessingSessionDetailResponse = {
  appointment?: AdminAppointmentSummary2 | null;
  encounter?: AdminEncounterSummary2 | null;
  note?: AdminNoteSummary3 | null;
  note_processing_session: AdminNoteProcessingSessionDetail;
  provider: AdminProviderSummary3;
  transcriptions: AdminTranscriptionSummary3[];
};
export type EncounterNoteGenerationResponse = {
  /** Current status */
  status: string;
  /** Celery task ID for tracking */
  task_id: string;
  /** Thread ID for state management */
  thread_id: string;
  /** Name of the workflow */
  workflow_name: string;
};
export type EncounterNoteGenerationRequest = {
  /** ID of the encounter to generate note for */
  encounter_id: string;
  /** Optional provider ID (for admin routes) */
  provider_id?: string | null;
  /** ID of the v2 template to use for generation */
  template_id: string;
};
export type WorkflowStatusResponse = {
  /** Error message if failed */
  error?: string | null;
  /** Whether the task is complete */
  ready: boolean;
  /** Task result if successful */
  result?: any | null;
  /** Task status (PENDING, SUCCESS, FAILURE, etc) */
  status: string;
  /** Whether the task succeeded */
  successful?: boolean | null;
  /** Task ID */
  task_id: string;
};
export type WorkflowResponse = {
  /** Current status */
  status: string;
  /** Task ID for tracking */
  task_id: string;
  /** Thread ID for state management */
  thread_id: string;
  /** Name of the workflow */
  workflow_name: string;
};
export type EditNoteRequest = {
  /** Note ID to edit */
  note_id: string;
  /** Organization ID */
  organization_id?: string | null;
  /** Provider ID for context gathering */
  provider_id: string;
  /** Text input for editing */
  text: string;
};
export type AdminAppointmentSummary3 = {
  appointment_id: string;
  duration?: number | null;
  encounter_type?: string | null;
  encounter_type_id?: string | null;
  start_time?: string | null;
  status?: string | null;
  telehealth?: boolean | null;
  title?: string | null;
};
export type AdminEncounterSummary3 = {
  appointment_id?: string | null;
  created_at?: string | null;
  encounter_id: string;
  encounter_type?: string | null;
  input_documents?: number | null;
  patient_id?: string | null;
  status?: string | null;
  updated_at?: string | null;
};
export type AdminNoteDetail = {
  created_at?: string | null;
  encounter_id?: string | null;
  encounter_type?: string | null;
  has_feedback?: boolean | null;
  note_id: string;
  patient_id?: string | null;
  patient_name?: string | null;
  provider_id?: string | null;
  status?: string | null;
  template?: string | null;
  updated_at?: string | null;
};
export type AdminNoteProcessingSessionSummary2 = {
  created_at?: string | null;
  note_id?: string | null;
  note_processing_session_id: string;
  status?: string | null;
  transcription_session_ids?: string[] | null;
};
export type AdminProviderSummary4 = {
  email?: string | null;
  last_login_time?: string | null;
  name?: string | null;
  organization_id?: string | null;
  organization_name?: string | null;
  provider_id: string;
  role?: string | null;
};
export type AdminTranscriptionSummary4 = {
  chunk_count?: number | null;
  created_at?: string | null;
  is_closed?: boolean | null;
  job_status?: string | null;
  notes_created?: number | null;
  start_time?: string | null;
  transcription_session_id: string;
};
export type AdminNoteDetailResponse = {
  appointment?: AdminAppointmentSummary3 | null;
  encounter?: AdminEncounterSummary3 | null;
  note: AdminNoteDetail;
  note_processing_sessions: AdminNoteProcessingSessionSummary2[];
  provider: AdminProviderSummary4;
  transcriptions: AdminTranscriptionSummary4[];
};
export type GenerateNotePdfResponse = {
  /** Path where the PDF was saved */
  file_path: string;
  /** Size of the generated PDF file in bytes */
  file_size_bytes: number;
  /** The note ID */
  note_id: string;
  /** Whether PDF generation succeeded */
  success: boolean;
};
export type AdminNoteTemplateInfo = {
  /** Whether users can fork this */
  allow_user_forks: boolean;
  /** Creation timestamp */
  created_at?: string | null;
  /** Current published version */
  current_version: number;
  /** Template description */
  description?: string | null;
  /** Template UUID */
  id: string;
  /** Processing version: 1 for v1 flow, 2 for v2 flow */
  note_processing_version?: number;
  /** Organization ID */
  organization_id?: string | null;
  /** Owner scope (public, org, user) */
  owner_scope: string;
  /** Template title */
  title: string;
  /** Last update timestamp */
  updated_at?: string | null;
  /** User ID who owns the template */
  user_id: string;
};
export type AdminNoteTemplateListResponse = {
  /** List of templates */
  templates?: AdminNoteTemplateInfo[];
  /** Total number of templates */
  total_count?: number;
};
export type ApplyFeedbackToTemplateResponse = {
  /** Status of the workflow task */
  status: string;
  /** Task ID for the async workflow */
  task_id: string;
  /** Thread ID for workflow state management */
  thread_id: string;
  /** Name of the workflow */
  workflow_name: string;
};
export type ApplyFeedbackToTemplateRequest = {
  /** Organization ID of the user */
  organization_id?: string | null;
  /** ID of the template to modify */
  template_id: string;
  /** User feedback text describing desired changes */
  text: string;
  /** User ID making the request */
  user_id: string;
  /** Version number to use (defaults to latest) */
  version?: number | null;
};
export type AdminTemplateBuildUploadResponse = {
  /** Draft template data (included for from-template) */
  draft_template?: {
    [key: string]: any;
  } | null;
  /** Source template ID when editing existing */
  source_template_id?: string | null;
  /** Status: pending, generating_examples, ready_for_review */
  status: string;
  /** User who owns this task */
  target_user_id: string;
  /** Unique task ID */
  task_id: string;
  /** Workflow thread ID */
  thread_id: string;
};
export type AdminTemplateBuildFromTemplateRequest = {
  /** Organization ID for the target user */
  target_organization_id: string;
  /** User ID who will own the task and resulting template */
  target_user_id: string;
  /** ID of the existing template to load for editing */
  template_id: string;
};
export type AdminTemplateBuildSaveResponse = {
  /** Completion status */
  status?: string;
  /** User who owns the template */
  target_user_id: string;
  /** Task ID */
  task_id: string;
  /** Created/updated template ID */
  template_id: string;
};
export type AdminTemplateBuildStatusResponse = {
  /** Created template ID when completed */
  created_template_id?: string | null;
  /** Document summary (for PDFs) */
  document_summary?: string | null;
  /** Document title (for PDFs) */
  document_title?: string | null;
  /** Draft template data */
  draft_template?: {
    [key: string]: any;
  } | null;
  /** Error message if failed */
  error?: string | null;
  /** Progress message */
  progress_message?: string | null;
  /** Source template ID when editing existing */
  source_template_id?: string | null;
  /** Status: pending, processing, structure_ready, generating_examples, ready_for_review, completed, failed */
  status: string;
  /** User who owns this task */
  target_user_id: string;
  /** Unique task ID */
  task_id: string;
};
export type ExtractionPrompts = {
  keyword_prompt: string;
  semantic_prompt: string;
};
export type NoteTemplateSection = {
  content: string;
  example_output?: string | null;
  extraction_prompts?: ExtractionPrompts | null;
  id: string;
  legacy_module_id?: string | null;
  order?: number;
  title: string;
};
export type NoteTemplateRevision = {
  content: string;
  created_at: string;
  created_by: string;
  description?: string | null;
  draft?: boolean;
  metadata?: {
    [key: string]: any;
  };
  models?: string[] | null;
  prompt?: string | null;
  published_at?: string | null;
  sections?: NoteTemplateSection[];
  template_id: string;
  title: string;
  updated_at: string;
  version: number;
};
export type NoteTemplateOwnerScope = "public" | "org" | "user";
export type NoteTemplate = {
  allow_user_forks?: boolean;
  created_at: string;
  current_version: number;
  deleted_at?: string | null;
  id: string;
  note_processing_version?: number;
  organization_id?: string | null;
  owner_scope: NoteTemplateOwnerScope;
  parent_template_id?: string | null;
  sharable?: boolean;
  updated_at: string;
  user_id: string;
};
export type AdminCopyNoteTemplateResponse = {
  message?: string;
  revision: NoteTemplateRevision;
  template: NoteTemplate;
};
export type AdminConvertToOrgRequest = {
  /** Organization ID to convert the template to */
  organization_id: string;
  /** Template UUID to convert */
  template_id: string;
};
export type AdminCopyNoteTemplateRequest = {
  /** Organization ID for the new template */
  target_organization_id?: string | null;
  /** User ID to copy the template to */
  target_user_id: string;
  /** Template UUID to copy */
  template_id: string;
};
export type ExtractionPrompts2 = {
  keyword_prompt: string;
  semantic_prompt: string;
};
export type NoteTemplateSection2 = {
  content: string;
  example_output?: string | null;
  extraction_prompts?: ExtractionPrompts2 | null;
  id: string;
  legacy_module_id?: string | null;
  order?: number;
  title: string;
};
export type NoteTemplateRevision2 = {
  content: string;
  created_at: string;
  created_by: string;
  description?: string | null;
  draft?: boolean;
  metadata?: {
    [key: string]: any;
  };
  models?: string[] | null;
  prompt?: string | null;
  published_at?: string | null;
  sections?: NoteTemplateSection2[];
  template_id: string;
  title: string;
  updated_at: string;
  version: number;
};
export type NoteTemplateOwnerScope2 = "public" | "org" | "user";
export type NoteTemplate2 = {
  allow_user_forks?: boolean;
  created_at: string;
  current_version: number;
  deleted_at?: string | null;
  id: string;
  note_processing_version?: number;
  organization_id?: string | null;
  owner_scope: NoteTemplateOwnerScope2;
  parent_template_id?: string | null;
  sharable?: boolean;
  updated_at: string;
  user_id: string;
};
export type AdminForkTemplateForUserResponse = {
  /** True if user already had a fork (returned existing) */
  already_existed?: boolean;
  message?: string;
  revision: NoteTemplateRevision2;
  template: NoteTemplate2;
};
export type AdminForkTemplateForUserRequest = {
  /** If true, bypass allow_user_forks check (admin override) */
  bypass_fork_restriction?: boolean;
  /** Template UUID to fork from */
  source_template_id: string;
  /** Organization ID for the user's fork */
  target_organization_id: string;
  /** User ID to create the fork for */
  target_user_id: string;
};
export type CopyToNewTemplateResponse = {
  /** Human-readable result message */
  message: string;
  /** UUID of the newly created template */
  new_template_id: string;
  /** Owner scope of new template */
  owner_scope: string;
  /** UUID of the source template */
  source_template_id: string;
  /** Whether the copy was successful */
  success: boolean;
};
export type CopyToNewTemplateRequest = {
  /** Template content */
  content?: string;
  /** Description for the new template */
  description?: string | null;
  /** Template metadata */
  metadata?: {
    [key: string]: any;
  };
  /** List of model IDs */
  models?: any[];
  /** Owner scope: 'user' or 'organization' */
  owner_scope?: string;
  /** List of section objects with converted prompts */
  sections: any[];
  /** Source template UUID being converted */
  source_template_id: string;
  /** Organization ID for the new template. If not provided, looked up from target_user_id */
  target_organization_id?: string | null;
  /** User ID to own the new template (can differ from conversion user) */
  target_user_id: string;
  /** Title for the new template */
  title: string;
};
export type SaveConvertedRevisionResponse = {
  /** Human-readable result message */
  message: string;
  /** Version number of the new revision */
  new_version: number;
  /** Whether the save was successful */
  success: boolean;
  /** Template UUID */
  template_id: string;
};
export type SaveConvertedRevisionRequest = {
  /** Template content */
  content?: string;
  /** Revision description */
  description?: string | null;
  /** Revision metadata */
  metadata?: {
    [key: string]: any;
  };
  /** List of model IDs */
  models?: any[];
  /** Template UUID to create revision on */
  note_template_id: string;
  /** List of section objects with converted prompts */
  sections: any[];
  /** User ID who will own/create the revision (can differ from conversion user) */
  target_user_id: string;
  /** Revision title */
  title: string;
};
export type StartModelConversionResponse = {
  /** Initial status */
  status: string;
  /** Celery task ID */
  task_id: string;
  /** Thread ID for polling status */
  thread_id: string;
};
export type StartModelConversionRequest = {
  /** Max examples to validate per section */
  max_validation_examples?: number;
  /** Note template UUID (new format) */
  note_template_id: string;
  /** Number of validation runs per example */
  runs_per_example?: number;
  /** Skip validation phase (faster) */
  skip_validation?: boolean;
  /** Target model to optimize for */
  target_model?: string;
  /** User ID to find example notes for */
  user_id: string;
};
export type ModelConversionStatusResponse = {
  conversion_results?:
    | {
        [key: string]: any;
      }[]
    | null;
  /** Current phase */
  current_phase?: string;
  /** Current step */
  current_step?: string;
  error?: string | null;
  /** Legacy template ID (if available) */
  legacy_template_id?: string | null;
  /** Note template UUID */
  note_template_id?: string | null;
  /** Human-readable progress */
  progress_message?: string;
  /** Progress percentage (0-100) */
  progress_percent?: number;
  proposed_revision?: {
    [key: string]: any;
  } | null;
  /** Sections converted */
  sections_converted?: number | null;
  /** Total sections */
  sections_total?: number | null;
  /** Workflow status */
  status: string;
  validation_results?:
    | {
        [key: string]: any;
      }[]
    | null;
};
export type AdminCreateOrgTemplateRequest = {
  /** Template content */
  content: string;
  /** Template description */
  description?: string | null;
  /** Template metadata */
  metadata?: {
    [key: string]: any;
  };
  /** Template prompt */
  prompt?: string | null;
  /** Template title */
  title: string;
};
export type TemplatePermissions = {
  can_delete?: boolean;
  can_edit?: boolean;
  can_fork?: boolean;
  can_view?: boolean;
};
export type NoteTemplateRevisionSummary = {
  created_at: string;
  created_by: string;
  description?: string | null;
  draft?: boolean;
  published_at?: string | null;
  template_id: string;
  title: string;
  updated_at: string;
  version: number;
};
export type NoteTemplateOwnerScope3 = "public" | "org" | "user";
export type NoteTemplate3 = {
  allow_user_forks?: boolean;
  created_at: string;
  current_version: number;
  deleted_at?: string | null;
  id: string;
  note_processing_version?: number;
  organization_id?: string | null;
  owner_scope: NoteTemplateOwnerScope3;
  parent_template_id?: string | null;
  sharable?: boolean;
  updated_at: string;
  user_id: string;
};
export type EffectiveNoteTemplateSummary = {
  display_order?: number | null;
  permissions?: TemplatePermissions | null;
  revision: NoteTemplateRevisionSummary;
  template: NoteTemplate3;
};
export type AdminProviderTemplateListResponse = {
  /** Templates visible to the provider in their picker */
  templates?: EffectiveNoteTemplateSummary[];
};
export type AdminDeleteTemplateResponse = {
  /** Status message */
  message: string;
  /** Whether deletion was successful */
  success: boolean;
};
export type ExtractionPrompts3 = {
  keyword_prompt: string;
  semantic_prompt: string;
};
export type NoteTemplateSection3 = {
  content: string;
  example_output?: string | null;
  extraction_prompts?: ExtractionPrompts3 | null;
  id: string;
  legacy_module_id?: string | null;
  order?: number;
  title: string;
};
export type NoteTemplateRevision3 = {
  content: string;
  created_at: string;
  created_by: string;
  description?: string | null;
  draft?: boolean;
  metadata?: {
    [key: string]: any;
  };
  models?: string[] | null;
  prompt?: string | null;
  published_at?: string | null;
  sections?: NoteTemplateSection3[];
  template_id: string;
  title: string;
  updated_at: string;
  version: number;
};
export type NoteTemplateOwnerScope4 = "public" | "org" | "user";
export type NoteTemplate4 = {
  allow_user_forks?: boolean;
  created_at: string;
  current_version: number;
  deleted_at?: string | null;
  id: string;
  note_processing_version?: number;
  organization_id?: string | null;
  owner_scope: NoteTemplateOwnerScope4;
  parent_template_id?: string | null;
  sharable?: boolean;
  updated_at: string;
  user_id: string;
};
export type AdminGetNoteTemplateResponse = {
  revision: NoteTemplateRevision3;
  template: NoteTemplate4;
};
export type ExtractionPrompts4 = {
  keyword_prompt: string;
  semantic_prompt: string;
};
export type NoteTemplateSection4 = {
  content: string;
  example_output?: string | null;
  extraction_prompts?: ExtractionPrompts4 | null;
  id: string;
  legacy_module_id?: string | null;
  order?: number;
  title: string;
};
export type NoteTemplateRevision4 = {
  content: string;
  created_at: string;
  created_by: string;
  description?: string | null;
  draft?: boolean;
  metadata?: {
    [key: string]: any;
  };
  models?: string[] | null;
  prompt?: string | null;
  published_at?: string | null;
  sections?: NoteTemplateSection4[];
  template_id: string;
  title: string;
  updated_at: string;
  version: number;
};
export type NoteTemplateOwnerScope5 = "public" | "org" | "user";
export type NoteTemplate5 = {
  allow_user_forks?: boolean;
  created_at: string;
  current_version: number;
  deleted_at?: string | null;
  id: string;
  note_processing_version?: number;
  organization_id?: string | null;
  owner_scope: NoteTemplateOwnerScope5;
  parent_template_id?: string | null;
  sharable?: boolean;
  updated_at: string;
  user_id: string;
};
export type AdminUpdateNoteTemplateResponse = {
  message?: string;
  revision: NoteTemplateRevision4;
  template: NoteTemplate5;
};
export type AdminNoteTemplateSectionRequest = {
  /** Generation prompt content */
  content: string;
  /** Example generated output */
  example_output?: string | null;
  /** Section ID (stable, hyphenated) */
  id: string;
  /** Legacy module ID for migration */
  legacy_module_id?: string | null;
  /** Display order */
  order?: number;
  /** Section display title */
  title: string;
};
export type AdminUpdateNoteTemplateRequest = {
  /** Whether users can fork this template */
  allow_user_forks?: boolean | null;
  /** Template description */
  description?: string | null;
  /** List of LLM models for note generation. When null/omitted, defaults to ['gpt-5-mini', 'claude-4-5-sonnet'] */
  models?: string[] | null;
  /** Processing version: 1 for v1 flow, 2 for v2 flow */
  note_processing_version?: number | null;
  /** Organization ID (required for org/user scope) */
  organization_id?: string | null;
  /** Owner scope: public, org, or user */
  owner_scope?: string | null;
  /** Global prompt/instructions */
  prompt?: string | null;
  /** Template sections */
  sections?: AdminNoteTemplateSectionRequest[] | null;
  /** Whether template is sharable via link */
  sharable?: boolean | null;
  /** Template title */
  title?: string | null;
  /** User ID who owns the template */
  user_id?: string | null;
};
export type AdminRevisionSummary = {
  /** When this revision was created */
  created_at: string;
  /** User ID who created this revision */
  created_by: string;
  /** Whether this is a draft revision */
  draft?: boolean;
  /** Number of sections in this revision */
  section_count: number;
  /** Revision title */
  title: string;
  /** Revision version number */
  version: number;
};
export type AdminListRevisionsResponse = {
  /** List of revision summaries */
  revisions?: AdminRevisionSummary[];
};
export type ExtractionPrompts5 = {
  keyword_prompt: string;
  semantic_prompt: string;
};
export type NoteTemplateSection5 = {
  content: string;
  example_output?: string | null;
  extraction_prompts?: ExtractionPrompts5 | null;
  id: string;
  legacy_module_id?: string | null;
  order?: number;
  title: string;
};
export type AdminGetRevisionResponse = {
  /** When this revision was created */
  created_at: string;
  /** User ID who created this revision */
  created_by: string;
  /** Revision description */
  description?: string | null;
  /** LLM models for generation */
  models?: string[] | null;
  /** Global prompt/instructions */
  prompt?: string | null;
  /** Template sections */
  sections?: NoteTemplateSection5[];
  /** Revision title */
  title: string;
  /** Revision version number */
  version: number;
};
export type HoneycombUrlResponse = {
  /** The URL-encoded Honeycomb query URL for debugging */
  url: string;
};
export type AdminOrganizationResponse = {
  /** Total number of admins */
  admin_count?: number;
  /** Billing admin user ID */
  billing_admin_id?: string | null;
  /** ISO timestamp of creation */
  created_at?: string | null;
  /** Total number of members */
  member_count?: number;
  /** Organization name */
  name: string;
  /** Unique organization identifier */
  organization_id: string;
};
export type ListResponseAdminOrganizationResponse = {
  items: AdminOrganizationResponse[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type AdminOrganizationMemberResponse = {
  /** User email */
  email?: string | null;
  /** User name */
  name?: string | null;
  /** User's payment status */
  payment_status?: string | null;
  /** Role in organization */
  role: string;
  /** User ID */
  user_id: string;
  /** Full user info object */
  user_info?: {
    [key: string]: any;
  } | null;
  /** User's metrics data */
  user_metrics?: {
    [key: string]: any;
  } | null;
};
export type AdminOrganizationUserResponse = {
  /** ISO timestamp when user was deactivated (null if active) */
  deactivated_at?: string | null;
  /** User email */
  email?: string | null;
  /** User name */
  name?: string | null;
  /** User's payment status */
  payment_status?: string | null;
  /** List of roles in organization */
  roles?: string[];
  /** Membership status: 'active' or 'inactive' */
  status?: string;
  /** User ID */
  user_id: string;
  /** Full user info object */
  user_info?: {
    [key: string]: any;
  } | null;
  /** User's metrics data */
  user_metrics?: {
    [key: string]: any;
  } | null;
};
export type AdminOrganizationDetailResponse = {
  /** Billing admin details */
  billing_admin?: AdminOrganizationMemberResponse | null;
  /** ISO timestamp of creation */
  created_at?: string | null;
  /** Full organization metadata */
  group_info?: {
    [key: string]: any;
  };
  /** Organization name */
  name: string;
  /** Unique organization identifier */
  organization_id: string;
  /** Stripe subscription status from webhook (stored in stripe_info) */
  stripe_status_from_webhook?: string | null;
  /** Full Stripe subscription details including status, billing period, and payment info */
  stripe_subscription_details?: {
    [key: string]: any;
  } | null;
  /** Stripe subscription ID */
  stripe_subscription_id?: string | null;
  /** Number of seats/users in the subscription */
  stripe_subscription_quantity?: number | null;
  /** All organization users with their roles and status (including inactive) */
  users?: AdminOrganizationUserResponse[];
};
export type UpdateOrganizationResponse = {
  /** Human-readable message about the operation */
  message: string;
  /** Organization ID that was updated */
  organization_id: string;
  /** Whether the update was successful */
  success: boolean;
  /** Fields that were updated with their new values */
  updated_fields?: {
    [key: string]: any;
  };
};
export type UpdateOrganizationRequest = {
  /** New organization name */
  name?: string | null;
};
export type AdminUpdateStatusResponse = {
  /** User-friendly message */
  message: string;
  /** Status after update */
  new_status: string;
  /** Organization ID */
  organization_id: string;
  /** Status before update */
  previous_status: string;
  /** Service updated: 'baa', 'coi', or 'retention' */
  service: string;
  /** Whether the update succeeded */
  success: boolean;
  /** ISO 8601 timestamp */
  updated_at: string;
};
export type AdminUpdateStatusRequest = {
  /** Admin notes for audit trail */
  notes?: string | null;
  /** New status: 'not_configured', 'processing', or 'active' */
  status: string;
};
export type ClinicDocumentCardResponse = {
  answerable_questions?: string[];
  clinic_document_id: string;
  content_type: string;
  created_at: string;
  description?: string | null;
  doc_kind?: string | null;
  filename: string;
  page_count?: number | null;
  processing_status: string;
  scope_id?: string | null;
  scope_type: string;
  size_bytes: number;
  tags?: string[];
  title?: string | null;
  toc_sections?: {
    [key: string]: any;
  }[];
  updated_at: string;
};
export type ClinicDocumentListResponse = {
  documents: ClinicDocumentCardResponse[];
  limit: number;
  offset: number;
  total: number;
};
export type SectionSummaryResponse = {
  answerable_questions?: string[];
  clinic_document_section_id: string;
  depth: number;
  has_children?: boolean;
  node_type: string;
  retrieval_hint?: string | null;
  summary?: string | null;
  title: string;
  token_estimate?: number | null;
};
export type SectionDetailResponse = {
  children?: SectionSummaryResponse[];
  clinic_document_section_id: string;
  depth: number;
  node_type: string;
  retrieval_hint?: string | null;
  summary?: string | null;
  title: string;
};
export type SectionContentResponse = {
  clinic_document_section_id: string;
  content_md?: string | null;
  page_end?: number | null;
  page_start?: number | null;
  title: string;
};
export type ClinicDocumentDetailResponse = {
  answerable_questions?: string[];
  batch_id?: string | null;
  clinic_document_id: string;
  content_type: string;
  created_at: string;
  description?: string | null;
  doc_kind?: string | null;
  filename: string;
  outline_md?: string | null;
  page_count?: number | null;
  processing_status: string;
  scope_id?: string | null;
  scope_type: string;
  size_bytes: number;
  supersedes_document_id?: string | null;
  tags?: string[];
  title?: string | null;
  updated_at: string;
};
export type ExtractionResultResponse = {
  clinic_document_id: string;
  created_at: string;
  error_text?: string | null;
  extracted_data?: {
    [key: string]: any;
  } | null;
  extraction_result_id: string;
  status: string;
  task_name: string;
  updated_at: string;
};
export type SectionSummaryResponse2 = {
  answerable_questions?: string[];
  clinic_document_section_id: string;
  depth: number;
  has_children?: boolean;
  node_type: string;
  retrieval_hint?: string | null;
  summary?: string | null;
  title: string;
  token_estimate?: number | null;
};
export type ClinicDocumentSectionsResponse = {
  clinic_document_id: string;
  outline_md?: string | null;
  sections: SectionSummaryResponse2[];
  title?: string | null;
};
export type ClinicDocumentStatusResponse = {
  clinic_document_id: string;
  processing_status: string;
  title?: string | null;
};
export type CreateSubscriptionResponse = {
  /** Stripe customer ID */
  customer_id?: string | null;
  /** Error details if the operation failed */
  error?: string | null;
  /** Human-readable message about the operation */
  message: string;
  /** Organization ID */
  organization_id: string;
  /** Number of seats on the subscription */
  quantity?: number | null;
  /** Stripe subscription ID */
  subscription_id?: string | null;
  /** Whether the subscription was created */
  success: boolean;
  /** Number of trial days */
  trial_days?: number | null;
};
export type CreateSubscriptionRequest = {
  /** Number of trial days (0-365). Defaults to STRIPE_NUM_FREE_TRIAL_DAYS env var if not provided. */
  trial_days?: number | null;
};
export type BaaStatusResponse = {
  /** ISO 8601 timestamp (if active) */
  activated_at?: string | null;
  /** Entity name from request */
  entity_name?: string | null;
  /** UUID if requested */
  request_id?: string | null;
  /** ISO 8601 timestamp */
  requested_at?: string | null;
  /** BAA status: 'not_entitled', 'not_configured', 'processing', 'active' */
  status: string;
};
export type CoiStatusResponse = {
  /** ISO 8601 timestamp (if active) */
  activated_at?: string | null;
  /** Business name from request */
  business_name?: string | null;
  /** UUID if requested */
  request_id?: string | null;
  /** ISO 8601 timestamp */
  requested_at?: string | null;
  /** COI status: 'not_entitled', 'not_configured', 'processing', 'active' */
  status: string;
};
export type DataRetentionStatusResponse = {
  /** ISO 8601 timestamp (if active) */
  activated_at?: string | null;
  /** ISO 8601 timestamp */
  configured_at?: string | null;
  /** UUID if configured */
  request_id?: string | null;
  /** Status: 'not_entitled', 'not_configured', 'processing', 'active' */
  status: string;
  /** Current setting */
  unsigned_notes_retention_days?: number | null;
};
export type CombinedDataSecurityStatusResponse = {
  /** BAA status */
  baa: BaaStatusResponse;
  /** Certificate of Insurance status */
  coi: CoiStatusResponse;
  /** Data retention policy status */
  data_retention: DataRetentionStatusResponse;
  /** Whether user has any data security capability */
  has_bundle: boolean;
};
export type DosespotPatientSearchResponse = {
  Items?: {
    [key: string]: any;
  }[];
  Result?: {
    [key: string]: string;
  };
};
export type DosespotPatientResponse = {
  Item?: {
    [key: string]: any;
  };
  Result?: {
    [key: string]: string;
  };
};
export type DosespotPatientUpdateResponse = {
  Id?: number;
  Result?: {
    [key: string]: string;
  };
};
export type ExtendTrialResponse = {
  /** Error details if the operation failed */
  error?: string | null;
  /** Human-readable message about the operation */
  message: string;
  /** Organization ID */
  organization_id: string;
  /** Stripe subscription ID */
  stripe_subscription_id?: string | null;
  /** Current subscription status */
  subscription_status?: string | null;
  /** Whether the trial extension was successful */
  success: boolean;
  /** New trial end date in ISO format */
  trial_end?: string | null;
};
export type ExtendTrialRequest = {
  /** Number of days to extend the trial (1-365) */
  days: number;
};
export type AdminFormResponse = {
  /** Creation timestamp */
  created_at?: string | null;
  /** Deletion timestamp (for soft deletes) */
  deleted_at?: string | null;
  /** Form ID */
  form_id: string;
  /** Whether the form is active (not deleted) */
  is_active?: boolean;
  /** Organization ID */
  organization_id: string;
};
export type AdminFormListResponse = {
  /** List of forms */
  forms?: AdminFormResponse[];
  /** Total number of forms */
  total_count?: number;
};
export type AdminFormResponse2 = {
  /** Creation timestamp */
  created_at?: string | null;
  /** Deletion timestamp (for soft deletes) */
  deleted_at?: string | null;
  /** Form ID */
  form_id: string;
  /** Whether the form is active (not deleted) */
  is_active?: boolean;
  /** Organization ID */
  organization_id: string;
};
export type AdminFormCreateRequest = {
  /** Form ID to add */
  form_id: string;
};
export type ResourceActionResponse = {
  /** Error message if operation failed */
  error?: string | null;
  /** Response message */
  message?: string | null;
  /** ID of the affected resource */
  resource_id?: string | null;
  /** Whether the operation was successful */
  success: boolean;
};
export type AdminInvitationResponse = {
  /** When the invitation was accepted */
  accepted_at?: string | null;
  /** UUID of user who accepted */
  accepted_by_user_id?: string | null;
  /** When the invitation was created */
  created_at: string;
  /** When the invitation expires */
  expires_at: string;
  /** Invitation UUID */
  invitation_id: string;
  /** UUID of the user who sent the invitation */
  invited_by_user_id?: string | null;
  /** Invited email address */
  invited_email: string;
  /** Organization UUID */
  organization_id: string;
  /** Bundle IDs to assign when accepted */
  preset_bundles?: string[];
  /** Roles to assign when accepted */
  preset_roles?: string[] | null;
  /** Invitation status */
  status: string;
};
export type ListResponseAdminInvitationResponse = {
  items: AdminInvitationResponse[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type AdminInvitationResponse2 = {
  /** When the invitation was accepted */
  accepted_at?: string | null;
  /** UUID of user who accepted */
  accepted_by_user_id?: string | null;
  /** When the invitation was created */
  created_at: string;
  /** When the invitation expires */
  expires_at: string;
  /** Invitation UUID */
  invitation_id: string;
  /** UUID of the user who sent the invitation */
  invited_by_user_id?: string | null;
  /** Invited email address */
  invited_email: string;
  /** Organization UUID */
  organization_id: string;
  /** Bundle IDs to assign when accepted */
  preset_bundles?: string[];
  /** Roles to assign when accepted */
  preset_roles?: string[] | null;
  /** Invitation status */
  status: string;
};
export type AdminSendInvitationRequest = {
  /** Bundle IDs to assign on acceptance */
  bundle_ids?: string[] | null;
  /** Email address to invite */
  email: string;
  /** Roles to assign to the invited user */
  roles: string[];
};
export type MemberActionResponse = {
  /** Human-readable message about the operation */
  message: string;
  /** Organization ID that was modified */
  organization_id?: string | null;
  /** Whether the operation was successful */
  success: boolean;
  /** User ID that was affected */
  user_id?: string | null;
};
export type AdminInvitationDetailResponse = {
  /** When the invitation was accepted */
  accepted_at?: string | null;
  /** UUID of user who accepted */
  accepted_by_user_id?: string | null;
  /** When the invitation was created */
  created_at: string;
  /** When the invitation expires */
  expires_at: string;
  /** Invitation UUID */
  invitation_id: string;
  /** UUID of the user who sent the invitation */
  invited_by_user_id?: string | null;
  /** Invited email address */
  invited_email: string;
  /** Additional metadata */
  metadata?: {
    [key: string]: any;
  };
  /** Organization UUID */
  organization_id: string;
  /** Bundle IDs to assign when accepted */
  preset_bundles?: string[];
  /** Pre-assigned profile settings */
  preset_profile?: {
    [key: string]: any;
  };
  /** Roles to assign when accepted */
  preset_roles?: string[] | null;
  /** Invitation status */
  status: string;
};
export type AddMemberRequest = {
  /** Optional list of bundle IDs to assign to the user */
  bundle_ids?: string[] | null;
  /** Role to assign to the user (e.g., 'member', 'admin', 'clinician', 'operations_support', 'practice_administrator', 'supervisor') */
  role: string;
  /** User ID to add to the organization */
  user_id: string;
};
export type MembershipInfoResponse = {
  /** Human-readable message */
  message: string;
  /** Current co-sign requirement status */
  needs_cosign: boolean;
  /** Organization ID */
  organization_id: string;
  /** Whether the operation was successful */
  success: boolean;
  /** User ID */
  user_id: string;
};
export type UpdateMembershipInfoRequest = {
  /** Whether this member's notes require co-signature from a supervisor */
  needs_cosign: boolean;
};
export type RoleActionResponse = {
  /** Human-readable message about the operation */
  message: string;
  /** Organization ID */
  organization_id: string;
  /** Current roles after the operation */
  roles?: string[];
  /** Whether the operation was successful */
  success: boolean;
  /** User ID that was affected */
  user_id: string;
};
export type UpdateUserRolesRequest = {
  /** Complete list of roles to assign to the user */
  roles: string[];
};
export type AddUserRoleRequest = {
  /** Role to add to the user (e.g., 'clinician', 'supervisor') */
  role: string;
};
export type MergeOrganizationsResponse = {
  /** Number of appointment series transferred */
  appointment_series_moved?: number;
  /** Number of appointments transferred */
  appointments_moved?: number;
  /** Number of encounter types transferred */
  encounter_types_moved?: number;
  /** Number of encounters transferred */
  encounters_moved?: number;
  /** Error details if the operation failed */
  error?: string | null;
  /** Number of memberships transferred */
  memberships_moved?: number;
  /** Human-readable message about the operation */
  message: string;
  /** Number of notes transferred */
  notes_moved?: number;
  /** Number of patients transferred */
  patients_moved?: number;
  /** Whether the source organization was successfully deleted */
  source_deleted?: boolean;
  /** Organization that was merged and deleted */
  source_organization_id: string;
  /** User ID whose organization was merged (if provided in request) */
  source_user_id?: string | null;
  /** Whether the merge was successful */
  success: boolean;
  /** Organization that received the members */
  target_organization_id: string;
};
export type MergeOrganizationsRequest = {
  /** Roles to assign to the merged user in the target organization (e.g., ['admin', 'member']) */
  roles?: string[] | null;
  /** Organization ID to merge FROM (will be deleted) */
  source_organization_id?: string | null;
  /** User ID whose organization should be merged FROM */
  source_user_id?: string | null;
};
export type PatientVisibilityResponse = {
  /** Human-readable message about the operation */
  message: string;
  /** Current patient visibility mode: 'organization_wide' or 'provider_only' */
  mode: string;
  /** Organization ID */
  organization_id: string;
  /** Whether the operation was successful */
  success: boolean;
};
export type UpdatePatientVisibilityRequest = {
  /** Patient visibility mode: 'organization_wide' or 'provider_only' */
  mode: string;
};
export type AdminProviderUserInfo = {
  email?: string | null;
  name?: string | null;
  phone?: string | null;
  profile_picture?: string | null;
};
export type AdminProviderUserMetrics = {
  notes_created?: number | null;
};
export type AdminProviderResponse = {
  created_at?: string | null;
  email?: string | null;
  email_verified?: boolean | null;
  last_login_time?: string | null;
  name?: string | null;
  note_count?: number | null;
  organization_id?: string | null;
  payment_status?: string | null;
  provider_id: string;
  role: string;
  user_info?: AdminProviderUserInfo | null;
  user_metrics?: AdminProviderUserMetrics | null;
};
export type ListResponseAdminProviderResponse = {
  items: AdminProviderResponse[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type SubscriptionDashboardUrlResponse = {
  /** Stripe dashboard URL for viewing the subscription */
  dashboard_url: string;
  /** Organization ID */
  organization_id: string;
  /** Stripe subscription ID */
  subscription_id: string;
};
export type SyncSubscriptionResponse = {
  /** Billing admin user ID */
  billing_admin_id?: string | null;
  /** Number of billable members */
  member_count?: number | null;
  /** Human-readable message about the sync */
  message: string;
  /** Organization ID */
  organization_id: string;
  /** Stripe subscription ID */
  stripe_subscription_id?: string | null;
  /** Updated subscription quantity */
  subscription_quantity?: number | null;
  /** Whether the sync was successful */
  success: boolean;
  /** Whether a webhook was triggered */
  webhook_triggered?: boolean;
};
export type AdminTemplateResponse = {
  /** Creation timestamp */
  created_at?: string | null;
  /** Deletion timestamp (for soft deletes) */
  deleted_at?: string | null;
  /** Display name for the template */
  display_name?: string | null;
  /** Whether the template is active (not deleted) */
  is_active?: boolean;
  /** Organization ID */
  organization_id: string;
  /** Template ID */
  template_id: string;
};
export type AdminTemplateListResponse = {
  /** List of templates */
  templates?: AdminTemplateResponse[];
  /** Total number of templates */
  total_count?: number;
};
export type AdminTemplateResponse2 = {
  /** Creation timestamp */
  created_at?: string | null;
  /** Deletion timestamp (for soft deletes) */
  deleted_at?: string | null;
  /** Display name for the template */
  display_name?: string | null;
  /** Whether the template is active (not deleted) */
  is_active?: boolean;
  /** Organization ID */
  organization_id: string;
  /** Template ID */
  template_id: string;
};
export type AdminTemplateCreateRequest = {
  /** Display name for the template */
  display_name?: string | null;
  /** Template ID to add */
  template_id: string;
};
export type AdminTemplateUpdateRequest = {
  /** New display name for the template */
  display_name: string;
};
export type BillingAddressResponse = {
  city?: string | null;
  line1?: string | null;
  line2?: string | null;
  state?: string | null;
  zip?: string | null;
};
export type SyncStatus =
  | "NOT_SYNCED"
  | "SYNCED"
  | "SYNC_FAILED"
  | "NEEDS_RESYNC";
export type BillingEntityResponse = {
  billing_address: BillingAddressResponse;
  billing_entity_id: string;
  billing_npi: string;
  contact_email: string | null;
  contact_name: string | null;
  contact_phone: string | null;
  created_at: string;
  doing_business_as: string | null;
  is_default: boolean;
  legal_name: string;
  organization_id: string;
  stedi_provider_id: string | null;
  stedi_synced: boolean;
  stedi_synced_at: string | null;
  sync_status: SyncStatus;
  tax_id_masked: string;
  tax_id_type: string;
  taxonomy_code: string | null;
  updated_at: string;
};
export type BillingEntityListResponse = {
  billing_entities: BillingEntityResponse[];
};
export type BillingAddressResponse2 = {
  city?: string | null;
  line1?: string | null;
  line2?: string | null;
  state?: string | null;
  zip?: string | null;
};
export type SyncStatus2 =
  | "NOT_SYNCED"
  | "SYNCED"
  | "SYNC_FAILED"
  | "NEEDS_RESYNC";
export type BillingEntityResponse2 = {
  billing_address: BillingAddressResponse2;
  billing_entity_id: string;
  billing_npi: string;
  contact_email: string | null;
  contact_name: string | null;
  contact_phone: string | null;
  created_at: string;
  doing_business_as: string | null;
  is_default: boolean;
  legal_name: string;
  organization_id: string;
  stedi_provider_id: string | null;
  stedi_synced: boolean;
  stedi_synced_at: string | null;
  sync_status: SyncStatus2;
  tax_id_masked: string;
  tax_id_type: string;
  taxonomy_code: string | null;
  updated_at: string;
};
export type BillingAddressSchema = {
  city: string;
  line1: string;
  line2?: string | null;
  state: string;
  zip: string;
};
export type CreateBillingEntityRequest = {
  billing_address: BillingAddressSchema;
  billing_npi: string;
  contact_email?: string | null;
  contact_name?: string | null;
  contact_phone?: string | null;
  doing_business_as?: string | null;
  is_default?: boolean;
  legal_name: string;
  tax_id: string;
  tax_id_type: string;
  taxonomy_code?: string | null;
};
export type BillingEntityDeleteResponse = {
  /** Whether deletion was successful */
  deleted: boolean;
};
export type BillingAddressUpdateSchema = {
  city?: string | null;
  line1?: string | null;
  line2?: string | null;
  state?: string | null;
  zip?: string | null;
};
export type UpdateBillingEntityRequest = {
  billing_address?: BillingAddressUpdateSchema | null;
  billing_npi?: string | null;
  contact_email?: string | null;
  contact_name?: string | null;
  contact_phone?: string | null;
  doing_business_as?: string | null;
  is_default?: boolean | null;
  legal_name?: string | null;
  tax_id?: string | null;
  tax_id_type?: ("EIN" | "SSN") | null;
  taxonomy_code?: string | null;
};
export type PayerReadinessResponse = {
  action_required: string | null;
  blockers: string[];
  can_submit: boolean;
  enrollment_status: string | null;
  payer_name: string;
  payer_support: string;
  payer_uuid: string;
};
export type SyncToStediResponse = {
  error?: string | null;
  error_code?: string | null;
  stedi_provider_id?: string | null;
  success: boolean;
  synced_at?: string | null;
};
export type BillingEntityStatusResponse = {
  billing_entity_id: string;
  billing_npi: string | null;
  is_complete: boolean;
  is_default: boolean;
  is_synced: boolean;
  issues: string[];
  legal_name: string;
};
export type PayerEnrollmentStatusResponse = {
  action_required: string | null;
  can_submit: boolean;
  enrollment_status: string | null;
  payer_name: string;
  payer_support: string;
  payer_uuid: string;
  transaction_type: string;
};
export type OrgBillingReadinessResponse = {
  billing_entities: BillingEntityStatusResponse[];
  enrollment_summary: {
    [key: string]: PayerEnrollmentStatusResponse[];
  };
  evaluated_at: string;
  organization_id: string;
  overall_status: string;
  stedi_config_issues: string[];
  stedi_connected: boolean;
};
export type PayerDocResponse = {
  created_at?: string | null;
  organization_id: string;
  payer_doc_id: string;
  payer_key: string;
  payer_name?: string | null;
  payer_uuid?: string | null;
  payload?: {
    [key: string]: any;
  };
  updated_at?: string | null;
};
export type PayerDocListResponse = {
  items?: PayerDocResponse[];
  total: number;
};
export type PayerDocResponse2 = {
  created_at?: string | null;
  organization_id: string;
  payer_doc_id: string;
  payer_key: string;
  payer_name?: string | null;
  payer_uuid?: string | null;
  payload?: {
    [key: string]: any;
  };
  updated_at?: string | null;
};
export type PayerDocUpsertRequest = {
  /** Optional display name for this payer doc */
  payer_name?: string | null;
  /** Optional canonical payer reference (payers.id) */
  payer_uuid?: string | null;
  /** Raw payer JSON payload (jotbill-payer-contract-v2) */
  payload?: {
    [key: string]: any;
  };
};
export type EnrollmentResponse = {
  billing_entity_id: string;
  created_at: string;
  last_synced_at: string | null;
  live_at: string | null;
  organization_id: string;
  /** Payer logo URL */
  payer_avatar_url?: string | null;
  /** Payer display name */
  payer_name?: string | null;
  payer_uuid: string | null;
  /** Payer website URL */
  payer_website_url?: string | null;
  rejection_reason: string | null;
  requested_at: string | null;
  status: string;
  status_message: string | null;
  stedi_enrollment_id: string | null;
  stedi_payer_id: string;
  stedi_transaction_enrollment_id: string;
  submitted_at: string | null;
  transaction_type: string;
  updated_at: string;
};
export type EnrollmentListResponse = {
  enrollments: EnrollmentResponse[];
};
export type EnrollmentResponse2 = {
  billing_entity_id: string;
  created_at: string;
  last_synced_at: string | null;
  live_at: string | null;
  organization_id: string;
  /** Payer logo URL */
  payer_avatar_url?: string | null;
  /** Payer display name */
  payer_name?: string | null;
  payer_uuid: string | null;
  /** Payer website URL */
  payer_website_url?: string | null;
  rejection_reason: string | null;
  requested_at: string | null;
  status: string;
  status_message: string | null;
  stedi_enrollment_id: string | null;
  stedi_payer_id: string;
  stedi_transaction_enrollment_id: string;
  submitted_at: string | null;
  transaction_type: string;
  updated_at: string;
};
export type InitiateEnrollmentRequest = {
  /** Billing entity to enroll */
  billing_entity_id: string;
  /** Internal payer UUID (from local database) */
  payer_uuid?: string | null;
  /** Stedi payer ID (from payer search results) */
  stedi_id?: string | null;
  /** Transaction type: 837P (claims) or 835 (ERA) */
  transaction_type?: string;
};
export type EnrollmentResponse3 = {
  billing_entity_id: string;
  created_at: string;
  last_synced_at: string | null;
  live_at: string | null;
  organization_id: string;
  /** Payer logo URL */
  payer_avatar_url?: string | null;
  /** Payer display name */
  payer_name?: string | null;
  payer_uuid: string | null;
  /** Payer website URL */
  payer_website_url?: string | null;
  rejection_reason: string | null;
  requested_at: string | null;
  status: string;
  status_message: string | null;
  stedi_enrollment_id: string | null;
  stedi_payer_id: string;
  stedi_transaction_enrollment_id: string;
  submitted_at: string | null;
  transaction_type: string;
  updated_at: string;
};
export type SyncAllResponse = {
  enrollments: EnrollmentResponse3[];
  synced_count: number;
};
export type RemittanceHeaderResponse = {
  /** 'test' or 'production' */
  application_mode?: string | null;
  /** Check number or EFT trace number */
  check_or_eft_trace_number: string;
  /** Number of claims in this remittance */
  claim_count?: number;
  created_at?: string | null;
  organization_id: string;
  /** Name of the entity that received payment */
  payee_name?: string | null;
  /** NPI of the entity that received payment */
  payee_npi?: string | null;
  /** Payer's identifier code */
  payer_identifier?: string | null;
  /** Name of the paying entity */
  payer_name?: string | null;
  /** Date the payer issued payment (from 835 DTM*405). Use this instead of created_at for display. */
  payment_date?: string | null;
  /** CHK (check) or ACH (electronic) */
  payment_method_code?: string | null;
  remittance_id: string;
  /** Origin of this ERA: 'stedi' (live) or source system slug for imports */
  source_system?: string | null;
  stedi_transaction_id?: string | null;
  /** Total payment in cents across all claims in this 835 */
  total_payment_amount_cents?: number | null;
  transaction_task_id?: string | null;
};
export type RemittanceListResponse = {
  /** List of remittance payment events for the current page */
  items?: RemittanceHeaderResponse[];
  /** Current page number (1-based) */
  page: number;
  /** Number of items per page */
  per_page: number;
  /** Total number of remittances matching filters */
  total: number;
  /** Total number of pages available */
  total_pages: number;
};
export type RemittanceLineResponse = {
  /** CPT/HCPCS code the payer adjudicated */
  adjudicated_procedure_code?: string | null;
  /** Modifier codes on the adjudicated procedure */
  adjudicated_procedure_modifier_codes?: string[] | null;
  claim_line_id?: string | null;
  /** Billed amount for this line in cents */
  line_item_charge_amount_cents?: number | null;
  /** Our submitted line control number */
  line_item_control_number?: string | null;
  /** Paid amount for this line in cents */
  line_item_payment_amount_cents?: number | null;
  original_units_of_service_count?: number | null;
  /** RARC remark codes. Each entry: {remarkCode, remark, codeListQualifierCode} */
  remark_codes?: {
    [key: string]: any;
  }[];
  remittance_line_id: string;
  /** Line-level adjustments. Each entry: {groupCode, reasonCode, reasonDescription, amountCents} */
  service_adjustments?: {
    [key: string]: any;
  }[];
  service_date?: string | null;
  /** Original submitted code (if payer changed it) */
  submitted_procedure_code?: string | null;
};
export type RemittanceClaimResponse = {
  /** Claim-level adjustments. Each entry: {groupCode, reasonCode, reasonDescription, amountCents}. groupCode: CO=contractual, PR=patient responsibility, OA=other, PI=payor initiated, CR=corrections */
  claim_adjustments?: {
    [key: string]: any;
  }[];
  /** 1=original, 7=replacement, 8=void */
  claim_frequency_code?: string | null;
  /** Matched internal claim ID (null if unmatched) */
  claim_id?: string | null;
  /** Amount paid in cents (CLP04) */
  claim_payment_amount_cents?: number | null;
  claim_received_date?: string | null;
  /** CLP02: 1=processed, 4=denied, 22=reversal, etc. */
  claim_status_code: string;
  /** Encounter ID from the linked claim (null if unmatched) */
  encounter_id?: string | null;
  /** True if payer forwarded to secondary insurance */
  forwarded_to_secondary?: boolean;
  /** Service line adjudication details */
  lines?: RemittanceLineResponse[];
  /** Our PCN used to match this to a claim */
  patient_control_number: string;
  patient_first_name?: string | null;
  patient_last_name?: string | null;
  patient_member_id?: string | null;
  /** Patient owes in cents (CLP05) */
  patient_responsibility_amount_cents?: number | null;
  /** Payer's internal claim reference (CLP07) */
  payer_claim_control_number?: string | null;
  remittance_claim_id: string;
  remittance_id: string;
  rendering_provider_npi?: string | null;
  statement_period_end?: string | null;
  statement_period_start?: string | null;
  /** Total billed amount in cents (CLP03) */
  total_claim_charge_amount_cents?: number | null;
};
export type ClaimRemittanceSummaryResponse = {
  claim_id: string;
  /** Trace number from the most recent 835 */
  latest_check_or_eft_trace_number?: string | null;
  /** Payer name from the most recent 835 */
  latest_payer_name?: string | null;
  /** Payment method from the most recent 835 */
  latest_payment_method_code?: string | null;
  /** Sum of all claim_payment_amount_cents across all 835s */
  net_payment_cents?: number;
  /** Remittance claim records with nested lines. Multiple entries means multiple 835s processed for this claim. */
  remittance_records?: RemittanceClaimResponse[];
  /** Sum of all adjustment amounts across all 835s */
  total_adjustments_cents?: number;
};
export type RemittanceLineResponse2 = {
  /** CPT/HCPCS code the payer adjudicated */
  adjudicated_procedure_code?: string | null;
  /** Modifier codes on the adjudicated procedure */
  adjudicated_procedure_modifier_codes?: string[] | null;
  claim_line_id?: string | null;
  /** Billed amount for this line in cents */
  line_item_charge_amount_cents?: number | null;
  /** Our submitted line control number */
  line_item_control_number?: string | null;
  /** Paid amount for this line in cents */
  line_item_payment_amount_cents?: number | null;
  original_units_of_service_count?: number | null;
  /** RARC remark codes. Each entry: {remarkCode, remark, codeListQualifierCode} */
  remark_codes?: {
    [key: string]: any;
  }[];
  remittance_line_id: string;
  /** Line-level adjustments. Each entry: {groupCode, reasonCode, reasonDescription, amountCents} */
  service_adjustments?: {
    [key: string]: any;
  }[];
  service_date?: string | null;
  /** Original submitted code (if payer changed it) */
  submitted_procedure_code?: string | null;
};
export type RemittanceClaimResponse2 = {
  /** Claim-level adjustments. Each entry: {groupCode, reasonCode, reasonDescription, amountCents}. groupCode: CO=contractual, PR=patient responsibility, OA=other, PI=payor initiated, CR=corrections */
  claim_adjustments?: {
    [key: string]: any;
  }[];
  /** 1=original, 7=replacement, 8=void */
  claim_frequency_code?: string | null;
  /** Matched internal claim ID (null if unmatched) */
  claim_id?: string | null;
  /** Amount paid in cents (CLP04) */
  claim_payment_amount_cents?: number | null;
  claim_received_date?: string | null;
  /** CLP02: 1=processed, 4=denied, 22=reversal, etc. */
  claim_status_code: string;
  /** Encounter ID from the linked claim (null if unmatched) */
  encounter_id?: string | null;
  /** True if payer forwarded to secondary insurance */
  forwarded_to_secondary?: boolean;
  /** Service line adjudication details */
  lines?: RemittanceLineResponse2[];
  /** Our PCN used to match this to a claim */
  patient_control_number: string;
  patient_first_name?: string | null;
  patient_last_name?: string | null;
  patient_member_id?: string | null;
  /** Patient owes in cents (CLP05) */
  patient_responsibility_amount_cents?: number | null;
  /** Payer's internal claim reference (CLP07) */
  payer_claim_control_number?: string | null;
  remittance_claim_id: string;
  remittance_id: string;
  rendering_provider_npi?: string | null;
  statement_period_end?: string | null;
  statement_period_start?: string | null;
  /** Total billed amount in cents (CLP03) */
  total_claim_charge_amount_cents?: number | null;
};
export type RemittanceHeaderResponse2 = {
  /** 'test' or 'production' */
  application_mode?: string | null;
  /** Check number or EFT trace number */
  check_or_eft_trace_number: string;
  /** Number of claims in this remittance */
  claim_count?: number;
  created_at?: string | null;
  organization_id: string;
  /** Name of the entity that received payment */
  payee_name?: string | null;
  /** NPI of the entity that received payment */
  payee_npi?: string | null;
  /** Payer's identifier code */
  payer_identifier?: string | null;
  /** Name of the paying entity */
  payer_name?: string | null;
  /** Date the payer issued payment (from 835 DTM*405). Use this instead of created_at for display. */
  payment_date?: string | null;
  /** CHK (check) or ACH (electronic) */
  payment_method_code?: string | null;
  remittance_id: string;
  /** Origin of this ERA: 'stedi' (live) or source system slug for imports */
  source_system?: string | null;
  stedi_transaction_id?: string | null;
  /** Total payment in cents across all claims in this 835 */
  total_payment_amount_cents?: number | null;
  transaction_task_id?: string | null;
};
export type RemittanceDetailResponse = {
  /** All claims adjudicated in this payment */
  claims?: RemittanceClaimResponse2[];
  remittance: RemittanceHeaderResponse2;
};
export type ConnectStediResponse = {
  /** Whether connection was successful */
  connected: boolean;
  /** When the connection was established */
  connected_at?: string | null;
  /** Status message */
  message?: string;
};
export type ConnectStediRequest = {
  /** Optional label for debugging/display (e.g., clinic name) */
  account_label?: string | null;
  /** Plaintext API key from Stedi app installation */
  api_key: string;
};
export type DisconnectStediResponse = {
  /** Whether disconnection was successful */
  disconnected: boolean;
  /** Status message */
  message?: string;
};
export type StediConnectionStatusResponse = {
  /** Account label for display */
  account_label?: string | null;
  /** Whether the org is connected to Stedi */
  connected: boolean;
  /** When the org first connected */
  connected_at?: string | null;
  /** Whether Stedi integration is enabled */
  enabled: boolean;
  /** When connection was last verified */
  last_verified_at?: string | null;
  /** Account mode: DEDICATED or SHARED */
  mode?: string | null;
  /** Last verification error, if any */
  verification_error?: string | null;
};
export type StediTransactionListResponse = {
  /** List of transaction objects from the Stedi Core API */
  items: {
    [key: string]: any;
  }[];
  /** Cursor token for the next page of results */
  next_page_token?: string | null;
};
export type StediTransactionDetailResponse = {
  /** Parsed JSON content of the transaction output artifact. For 837 claims: full claim payload (payer, subscriber, service lines, etc.). For 277/835: parsed report content. Null if the output artifact could not be fetched. */
  output?: {
    [key: string]: any;
  } | null;
  /** Full transaction metadata from the Stedi Core API */
  transaction: {
    [key: string]: any;
  };
};
export type VerifyStediResponse = {
  /** Error message if validation failed */
  error?: string | null;
  /** Whether the connection is valid */
  valid: boolean;
  /** When the verification was performed */
  verified_at?: string | null;
};
export type RegeneratePatientIntelligenceResponse = {
  /** The encounter that was used for signal selection. */
  encounter_id: string;
  /** The persisted container layout ID. */
  layout_id: string;
  /** Patient ID that was regenerated. */
  patient_id: string;
};
export type RegeneratePatientIntelligenceRequest = {
  /** Encounter to build signals from. If omitted, the most recent completed encounter with an analysis is used. */
  encounter_id?: string | null;
  /** Organization ID. */
  organization_id: string;
  /** Patient ID whose intelligence to rebuild. */
  patient_id: string;
  /** Provider user ID whose layout/preferences to regenerate. */
  user_id: string;
};
export type PayerSyncResponse = {
  message: string;
  success: boolean;
  task_id?: string | null;
};
export type PayerSyncStatusResponse = {
  last_synced_at?: string | null;
  message: string;
  payer_count: number;
};
export type ProspectResponse = {
  /** Clinical focus */
  clinical_focus?: string[] | null;
  /** Colleague count */
  colleague_count?: number | null;
  /** Record creation time */
  created_at?: string | null;
  /** Contact email address */
  email?: string | null;
  /** Practice URLs */
  group_practice_website?: string[] | null;
  /** In group practice */
  in_group_practice?: boolean | null;
  /** Insurance carriers */
  insurance_carriers?: string[] | null;
  /** Insurance types */
  insurance_types?: string[] | null;
  /** Job title */
  job_title?: string | null;
  /** Practice locations */
  location?: string[] | null;
  /** Number of MSO platforms */
  mso_count?: number | null;
  /** MSO platform names */
  mso_platforms?: string[] | null;
  /** Contact full name */
  name: string;
  /** Organization/practice name */
  organization?: string | null;
  /** Owns group practice */
  owns_group_practice?: boolean | null;
  /** Runs solo practice */
  owns_solo_practice?: boolean | null;
  /** Phone number */
  phone_number?: string | null;
  /** Population focus */
  population_focus?: string[] | null;
  /** Unique identifier */
  prospect_segment_id: number;
  /** Admin who uploaded */
  requesting_user_id?: string | null;
  /** Treatment methods */
  services_modalities?: string[] | null;
  /** Data source */
  source?: string | null;
  /** Professional specialty */
  specialty_enriched?: string | null;
  /** Last update time */
  updated_at?: string | null;
  /** ZIP code */
  zipcode?: string | null;
};
export type ProspectListResponse = {
  /** Current page */
  page: number;
  /** Items per page */
  page_size: number;
  /** List of prospects */
  prospects: ProspectResponse[];
  /** Total matching records */
  total_count: number;
  /** Total pages */
  total_pages: number;
};
export type ProspectResponse2 = {
  /** Clinical focus */
  clinical_focus?: string[] | null;
  /** Colleague count */
  colleague_count?: number | null;
  /** Record creation time */
  created_at?: string | null;
  /** Contact email address */
  email?: string | null;
  /** Practice URLs */
  group_practice_website?: string[] | null;
  /** In group practice */
  in_group_practice?: boolean | null;
  /** Insurance carriers */
  insurance_carriers?: string[] | null;
  /** Insurance types */
  insurance_types?: string[] | null;
  /** Job title */
  job_title?: string | null;
  /** Practice locations */
  location?: string[] | null;
  /** Number of MSO platforms */
  mso_count?: number | null;
  /** MSO platform names */
  mso_platforms?: string[] | null;
  /** Contact full name */
  name: string;
  /** Organization/practice name */
  organization?: string | null;
  /** Owns group practice */
  owns_group_practice?: boolean | null;
  /** Runs solo practice */
  owns_solo_practice?: boolean | null;
  /** Phone number */
  phone_number?: string | null;
  /** Population focus */
  population_focus?: string[] | null;
  /** Unique identifier */
  prospect_segment_id: number;
  /** Admin who uploaded */
  requesting_user_id?: string | null;
  /** Treatment methods */
  services_modalities?: string[] | null;
  /** Data source */
  source?: string | null;
  /** Professional specialty */
  specialty_enriched?: string | null;
  /** Last update time */
  updated_at?: string | null;
  /** ZIP code */
  zipcode?: string | null;
};
export type AdminProviderTemplate = {
  display_name: string;
  template_id: string;
  type: string;
};
export type AdminProviderLookupUserInfo = {
  email: string;
  /** Mobile phone number (E.164 format) */
  mobile_phone_num?: string | null;
  name: string;
};
export type AdminProviderLookupUser = {
  email: string;
  feature_flags?: {
    [key: string]: any;
  } | null;
  last_login_time?: string | null;
  membership_status?: string | null;
  name: string;
  note_count: number;
  organization_id?: string | null;
  organization_name?: string | null;
  provider_id: string;
  role?: string | null;
  templates?: AdminProviderTemplate[];
  user_info: AdminProviderLookupUserInfo;
};
export type AdminProviderLookupResponse = {
  user: AdminProviderLookupUser;
};
export type AdminAppointmentResponse = {
  appointment_id: string;
  created_at?: string | null;
  duration?: number | null;
  encounter_type?: string | null;
  encounter_type_id?: string | null;
  organization_id?: string | null;
  patient_id?: string | null;
  provider_id?: string | null;
  series_id?: string | null;
  start_time: string;
  status: string;
  telehealth?: boolean | null;
  template_id?: string | null;
  title: string;
  updated_at?: string | null;
};
export type ListResponseAdminAppointmentResponse = {
  items: AdminAppointmentResponse[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type FormRuleSchema = {
  /** ID of the form definition */
  form_definition_id: string;
  /** Unique identifier for the rule */
  id?: string | null;
  /** ISO 8601 duration format (e.g., '-P1D' for 1 day before) */
  offset: string;
  /** Title of the rule */
  title?: string | null;
};
export type ReminderRuleSchema = {
  /** Unique identifier for the rule */
  id?: string | null;
  /** ISO 8601 duration format (e.g., '-P1D' for 1 day before) */
  offset: string;
  /** ID of the reminder template */
  reminder_template_id: string;
  /** Title of the rule */
  title?: string | null;
};
export type EncounterTypeResponse = {
  /** Color identifier for appointment display (color1, color2, etc.) */
  color: string;
  /** Creation timestamp */
  created_at?: string | null;
  /** Default CPT codes to pre-populate encounters of this type */
  default_cpt_codes?: string[] | null;
  /** Default appointment duration in minutes */
  default_duration?: number | null;
  /** Default form rules */
  default_form_rules?: FormRuleSchema[] | null;
  /** Default ICD-10 codes for encounters of this type */
  default_icd10_codes?: string[] | null;
  /** Default modality for encounters of this type */
  default_modality?: ("in_person" | "video" | "audio") | null;
  /** Default CMS place of service code (e.g., '11', '10', '02') */
  default_place_of_service?: string | null;
  /** Default reminder rules */
  default_reminder_rules?: ReminderRuleSchema[] | null;
  /** Name/description of the encounter type */
  encounter_type: string;
  /** UUID of the encounter type */
  encounter_type_id: string;
  /** UUID of the organization */
  organization_id?: string | null;
  /** UUID of the provider */
  provider_id: string;
  /** Default telehealth setting for appointments of this type */
  telehealth?: boolean | null;
  /** Associated template ID */
  template_id?: string | null;
  /** Last update timestamp */
  updated_at?: string | null;
};
export type ListResponseEncounterTypeResponse = {
  items: EncounterTypeResponse[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type FormRuleSchema2 = {
  /** ID of the form definition */
  form_definition_id: string;
  /** Unique identifier for the rule */
  id?: string | null;
  /** ISO 8601 duration format (e.g., '-P1D' for 1 day before) */
  offset: string;
  /** Title of the rule */
  title?: string | null;
};
export type ReminderRuleSchema2 = {
  /** Unique identifier for the rule */
  id?: string | null;
  /** ISO 8601 duration format (e.g., '-P1D' for 1 day before) */
  offset: string;
  /** ID of the reminder template */
  reminder_template_id: string;
  /** Title of the rule */
  title?: string | null;
};
export type EncounterTypeResponse2 = {
  /** Color identifier for appointment display (color1, color2, etc.) */
  color: string;
  /** Creation timestamp */
  created_at?: string | null;
  /** Default CPT codes to pre-populate encounters of this type */
  default_cpt_codes?: string[] | null;
  /** Default appointment duration in minutes */
  default_duration?: number | null;
  /** Default form rules */
  default_form_rules?: FormRuleSchema2[] | null;
  /** Default ICD-10 codes for encounters of this type */
  default_icd10_codes?: string[] | null;
  /** Default modality for encounters of this type */
  default_modality?: ("in_person" | "video" | "audio") | null;
  /** Default CMS place of service code (e.g., '11', '10', '02') */
  default_place_of_service?: string | null;
  /** Default reminder rules */
  default_reminder_rules?: ReminderRuleSchema2[] | null;
  /** Name/description of the encounter type */
  encounter_type: string;
  /** UUID of the encounter type */
  encounter_type_id: string;
  /** UUID of the organization */
  organization_id?: string | null;
  /** UUID of the provider */
  provider_id: string;
  /** Default telehealth setting for appointments of this type */
  telehealth?: boolean | null;
  /** Associated template ID */
  template_id?: string | null;
  /** Last update timestamp */
  updated_at?: string | null;
};
export type FormRuleSchema3 = {
  /** ID of the form definition */
  form_definition_id: string;
  /** Unique identifier for the rule */
  id?: string | null;
  /** ISO 8601 duration format (e.g., '-P1D' for 1 day before) */
  offset: string;
  /** Title of the rule */
  title?: string | null;
};
export type ReminderRuleSchema3 = {
  /** Unique identifier for the rule */
  id?: string | null;
  /** ISO 8601 duration format (e.g., '-P1D' for 1 day before) */
  offset: string;
  /** ID of the reminder template */
  reminder_template_id: string;
  /** Title of the rule */
  title?: string | null;
};
export type EncounterTypeCreate = {
  /** Color identifier for appointment display (color1, color2, etc.). If not provided, will be auto-assigned based on encounter type name. */
  color?: string | null;
  /** Default CPT codes to pre-populate encounters of this type */
  default_cpt_codes?: string[] | null;
  /** Default appointment duration in minutes */
  default_duration?: number | null;
  /** Default form rules for this encounter type */
  default_form_rules?: FormRuleSchema3[] | null;
  /** Default ICD-10 codes for encounters of this type */
  default_icd10_codes?: string[] | null;
  /** Default modality for encounters of this type */
  default_modality?: ("in_person" | "video" | "audio") | null;
  /** Default CMS place of service code (e.g., '11', '10', '02') */
  default_place_of_service?: string | null;
  /** Default reminder rules for this encounter type */
  default_reminder_rules?: ReminderRuleSchema3[] | null;
  /** Name/description of the encounter type */
  encounter_type: string;
  /** Default telehealth setting for appointments of this type */
  telehealth?: boolean | null;
  /** Associated template ID */
  template_id?: string | null;
};
export type FormRuleSchema4 = {
  /** ID of the form definition */
  form_definition_id: string;
  /** Unique identifier for the rule */
  id?: string | null;
  /** ISO 8601 duration format (e.g., '-P1D' for 1 day before) */
  offset: string;
  /** Title of the rule */
  title?: string | null;
};
export type ReminderRuleSchema4 = {
  /** Unique identifier for the rule */
  id?: string | null;
  /** ISO 8601 duration format (e.g., '-P1D' for 1 day before) */
  offset: string;
  /** ID of the reminder template */
  reminder_template_id: string;
  /** Title of the rule */
  title?: string | null;
};
export type EncounterTypeUpdate = {
  /** Color identifier for appointment display (color1, color2, etc.) */
  color?: string | null;
  /** Default CPT codes to pre-populate encounters of this type */
  default_cpt_codes?: string[] | null;
  /** Default appointment duration in minutes */
  default_duration?: number | null;
  /** Default form rules for this encounter type */
  default_form_rules?: FormRuleSchema4[] | null;
  /** Default ICD-10 codes for encounters of this type */
  default_icd10_codes?: string[] | null;
  /** Default modality for encounters of this type */
  default_modality?: ("in_person" | "video" | "audio") | null;
  /** Default CMS place of service code (e.g., '11', '10', '02') */
  default_place_of_service?: string | null;
  /** Default reminder rules for this encounter type */
  default_reminder_rules?: ReminderRuleSchema4[] | null;
  /** Name/description of the encounter type */
  encounter_type?: string | null;
  /** Default telehealth setting for appointments of this type */
  telehealth?: boolean | null;
  /** Associated template ID */
  template_id?: string | null;
};
export type WorkingBillingClaimLineItemResponse2 = {
  /** Charge amount in cents for the line item */
  charge_cents?: number | null;
  /** Billing code identifier */
  code_id?: string | null;
  /** Subset of claim-level diagnosis codes this line links to. Empty = all apply. */
  diagnosis_codes?: string[];
  /** Provenance for each modifier, keyed by modifier code */
  modifier_sources?: {
    [key: string]: "provider_selected" | "ai_recommended";
  };
  modifiers?: string[];
  /** Whether this line item came from provider edits or AI */
  source?: ("provider_selected" | "ai_recommended") | null;
  /** Units billed */
  units?: number | null;
};
export type WorkingBillingClaimResponse2 = {
  created_at?: string | null;
  /** Provenance for each diagnosis code, keyed by normalized ICD-10 code */
  diagnosis_code_sources?: {
    [key: string]: "provider_selected" | "ai_recommended";
  };
  diagnosis_codes?: string[];
  encounter_id?: string | null;
  line_items?: WorkingBillingClaimLineItemResponse2[];
  organization_id?: string | null;
  place_of_service?: string | null;
  updated_at?: string | null;
};
export type AdminEncounterResponse = {
  appointment_id?: string | null;
  created_at?: string | null;
  encounter_analysis?: {
    [key: string]: any;
  } | null;
  encounter_id: string;
  encounter_type?: string | null;
  end_time?: string | null;
  input_documents?: number;
  modified_at?: string | null;
  note_id?: string | null;
  note_title?: string | null;
  organization_id?: string | null;
  patient_id?: string | null;
  provider_id: string;
  scheduled_for?: string | null;
  start_time?: string | null;
  status: string;
  template_id?: string | null;
  working_billing_claim?: WorkingBillingClaimResponse2 | null;
};
export type ListResponseAdminEncounterResponse = {
  items: AdminEncounterResponse[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type DeleteGoogleCalendarConfigResponse = {
  /** Status message */
  message: string;
};
export type TaskInfo = {
  /** Celery task ID */
  task_id: string;
  /** Type of sync task: initial_sync */
  type: string;
};
export type InitiateSyncResponse = {
  /** Google Calendar ID (None if retry after failed creation) */
  calendar_id?: string | null;
  /** Status message */
  message: string;
  /** Provider ID */
  provider_id: string;
  /** Whether sync initiation was successful */
  success: boolean;
  /** List of tasks that were initiated */
  tasks_initiated?: TaskInfo[];
};
export type GoogleSyncStatusResponse = {
  /** Google Calendar ID if configured */
  calendar_id?: string | null;
  /** Error message if any */
  error?: string | null;
  /** Whether refresh token exists */
  has_refresh_token: boolean;
  /** Whether sync token exists for incremental sync */
  has_sync_token: boolean;
  /** Whether Google Calendar is properly configured */
  is_configured: boolean;
  /** Whether integration flag is set */
  is_integrated: boolean;
  /** Last webhook message number processed */
  last_message_number?: number | null;
  /** Notification channel expiration timestamp */
  notification_channel_expiration?: number | null;
  /** Webhook notification channel ID */
  notification_channel_id?: string | null;
};
export type AdminNoteProcessingSessionListItem = {
  created_at: string;
  encounter_id?: string | null;
  note_id?: string | null;
  note_processing_session_id: string;
  provider_id: string;
  status: string;
  transcript_count: number;
  transcription_session_id?: string | null;
  transcription_session_ids?: string[] | null;
  updated_at?: string | null;
};
export type ListResponseAdminNoteProcessingSessionListItem = {
  items: AdminNoteProcessingSessionListItem[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type AdminNoteListItem = {
  created_at: string;
  encounter_id?: string | null;
  encounter_type?: string | null;
  has_feedback: boolean;
  note_id: string;
  patient_name?: string | null;
  status: string;
  template: string;
  transcript_id?: string | null;
};
export type ListResponseAdminNoteListItem = {
  items: AdminNoteListItem[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type AdminProfileUpdateUserInfo = {
  email: string;
  mobile_phone_num?: string | null;
  name: string;
};
export type AdminProviderProfileUpdateResponse = {
  success: boolean;
  user_info: AdminProfileUpdateUserInfo;
};
export type UpdateProviderProfileRequest = {
  /** Mobile phone number in E.164 format (e.g., +15551234567), or null to clear */
  mobile_phone_num?: string | null;
};
export type AdminTranscriptionSessionResponse = {
  chunk_count?: number;
  end_time?: string | null;
  error_message?: string | null;
  is_closed: boolean;
  job_status: string;
  notes_created?: number;
  provider_id: string;
  recording_session_id: string;
  start_time?: string | null;
  transcription_session_id: string;
};
export type ListResponseAdminTranscriptionSessionResponse = {
  items: AdminTranscriptionSessionResponse[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type RoleDefinition = {
  /** Whether this role has admin-level permissions */
  is_admin_equivalent: boolean;
  /** Whether this role counts for billing */
  is_billable: boolean;
  /** Whether this is a legacy role (for backward compatibility) */
  is_legacy: boolean;
  /** Whether this role has member-level permissions */
  is_member_equivalent: boolean;
  /** Role identifier */
  role: string;
};
export type AvailableRolesResponse = {
  /** List of roles that count for billing */
  billable_roles: string[];
  /** List of current (non-legacy) role identifiers */
  current_roles: string[];
  /** List of legacy role identifiers */
  legacy_roles: string[];
  /** List of all available roles */
  roles: RoleDefinition[];
};
export type RuleFacets = {
  /** Applicable CPT codes */
  cpt?: string[];
  /** Applicable payers (e.g., Optum, Medicare) */
  payer?: string[];
  /** Applicable provider types (e.g., PMHNP) */
  provider_type?: string[];
};
export type RuleOwnerScope = "public" | "org" | "user";
export type RuleSource = {
  /** Date of source document (YYYY-MM-DD or string) */
  document_date?: string | null;
  /** Title of source document */
  document_title?: string | null;
  /** URI/URL to source document */
  source_uri?: string | null;
};
export type RuleState = "active" | "draft" | "deprecated";
export type ComplianceRule = {
  /** When true, rule bypasses LLM selection and is always included */
  always_select?: boolean;
  /** Canonical Markdown content: Rule, Applies when, What good looks like, Why it matters */
  body_md: string;
  /** Sparse applicability filters: cpt, provider_type, payer */
  facets?: RuleFacets;
  /** True if the rule has been soft-deleted (for historical data) */
  is_deleted?: boolean;
  /** True if the rule is disabled for the organization (not active) */
  is_disabled?: boolean;
  /** Owning organization UUID when not public */
  organization_id?: string | null;
  /** Scope of the rule: public, org, or user */
  owner_scope?: RuleOwnerScope;
  /** Reference to parent rule when forked, for lineage tracking */
  parent_rule_id?: string | null;
  /** Unique stable identifier for the rule */
  rule_id: string;
  /** Compact one-liner for LLM rule selection (~100-150 chars) */
  selector_text: string;
  /** Source documentation: document_title, document_date, source_uri */
  source?: RuleSource;
  /** Rule lifecycle state: active or deprecated */
  state?: RuleState;
  /** Short human-readable label */
  title?: string | null;
  /** Last update timestamp (UTC) */
  updated_at?: string | null;
};
export type LearningRuleDocument4 = {
  /** Succinct explanation of why this matters clinically */
  clinical_rationale: string;
  /** Organization ID that owns this rule (can be 'global') */
  organization_id: string;
  /** Specific clinician-facing actions, reflections, or options to consider when this guidance applies */
  recommended_actions: string;
  /** Concise paragraph describing populations, diagnoses, modalities, symptoms, settings, and key phrases that signal when this learning rule matters */
  relevant_context: string;
  /** Unique stable identifier for the rule */
  rule_id: string;
  /** Formatted citation string if available */
  source_citation?: string | null;
  /** Publication year or full date as YYYY or YYYY-MM-DD if known */
  source_date?: string | null;
  /** Primary source title or identifier */
  source_document?: string | null;
  /** Clickable URL to the source (e.g., DOI link) or null */
  source_link?: string | null;
  /** 2-4 sentence, high-yield summary of the key takeaway for clinicians */
  teaching_summary: string;
  /** Human-readable title of the learning rule */
  title: string;
  /** Type of rule (always 'learning') */
  type?: string;
  /** ISO timestamp of last update */
  updated_at?: string | null;
  /** User ID who last updated this rule */
  updated_by?: string | null;
  /** Clinician-facing guidance for when this learning should be applied */
  when_to_follow: string;
};
export type ProviderRuleResponse = {
  /** Whether this rule is disabled for the requesting org/user */
  is_disabled?: boolean;
  /** Whether this is a global rule */
  is_global: boolean;
  /** Organization ID if not global */
  organization_id?: string | null;
  /** Rule document (compliance or learning) */
  rule: ComplianceRule | LearningRuleDocument4;
  /** Rule ID */
  rule_id: string;
  /** Type of rule: 'compliance' or 'learning' */
  rule_type: "compliance" | "learning";
};
export type ProviderRuleListResponse = {
  items: ProviderRuleResponse[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type RuleScope = "global" | "org" | "both";
export type RuleFacets2 = {
  /** Applicable CPT codes */
  cpt?: string[];
  /** Applicable payers (e.g., Optum, Medicare) */
  payer?: string[];
  /** Applicable provider types (e.g., PMHNP) */
  provider_type?: string[];
};
export type RuleOwnerScope2 = "public" | "org" | "user";
export type RuleSource2 = {
  /** Date of source document (YYYY-MM-DD or string) */
  document_date?: string | null;
  /** Title of source document */
  document_title?: string | null;
  /** URI/URL to source document */
  source_uri?: string | null;
};
export type RuleState2 = "active" | "draft" | "deprecated";
export type ComplianceRule2 = {
  /** When true, rule bypasses LLM selection and is always included */
  always_select?: boolean;
  /** Canonical Markdown content: Rule, Applies when, What good looks like, Why it matters */
  body_md: string;
  /** Sparse applicability filters: cpt, provider_type, payer */
  facets?: RuleFacets2;
  /** True if the rule has been soft-deleted (for historical data) */
  is_deleted?: boolean;
  /** True if the rule is disabled for the organization (not active) */
  is_disabled?: boolean;
  /** Owning organization UUID when not public */
  organization_id?: string | null;
  /** Scope of the rule: public, org, or user */
  owner_scope?: RuleOwnerScope2;
  /** Reference to parent rule when forked, for lineage tracking */
  parent_rule_id?: string | null;
  /** Unique stable identifier for the rule */
  rule_id: string;
  /** Compact one-liner for LLM rule selection (~100-150 chars) */
  selector_text: string;
  /** Source documentation: document_title, document_date, source_uri */
  source?: RuleSource2;
  /** Rule lifecycle state: active or deprecated */
  state?: RuleState2;
  /** Short human-readable label */
  title?: string | null;
  /** Last update timestamp (UTC) */
  updated_at?: string | null;
};
export type RuleResponse = {
  /** Rule document */
  rule: ComplianceRule2;
  /** Rule ID */
  rule_id: string;
  /** Last update timestamp */
  updated_at?: string | null;
};
export type RuleFacets3 = {
  /** Applicable CPT codes */
  cpt?: string[];
  /** Applicable payers (e.g., Optum, Medicare) */
  payer?: string[];
  /** Applicable provider types (e.g., PMHNP) */
  provider_type?: string[];
};
export type RuleOwnerScope3 = "public" | "org" | "user";
export type RuleSource3 = {
  /** Date of source document (YYYY-MM-DD or string) */
  document_date?: string | null;
  /** Title of source document */
  document_title?: string | null;
  /** URI/URL to source document */
  source_uri?: string | null;
};
export type RuleState3 = "active" | "draft" | "deprecated";
export type ComplianceRule3 = {
  /** When true, rule bypasses LLM selection and is always included */
  always_select?: boolean;
  /** Canonical Markdown content: Rule, Applies when, What good looks like, Why it matters */
  body_md: string;
  /** Sparse applicability filters: cpt, provider_type, payer */
  facets?: RuleFacets3;
  /** True if the rule has been soft-deleted (for historical data) */
  is_deleted?: boolean;
  /** True if the rule is disabled for the organization (not active) */
  is_disabled?: boolean;
  /** Owning organization UUID when not public */
  organization_id?: string | null;
  /** Scope of the rule: public, org, or user */
  owner_scope?: RuleOwnerScope3;
  /** Reference to parent rule when forked, for lineage tracking */
  parent_rule_id?: string | null;
  /** Unique stable identifier for the rule */
  rule_id: string;
  /** Compact one-liner for LLM rule selection (~100-150 chars) */
  selector_text: string;
  /** Source documentation: document_title, document_date, source_uri */
  source?: RuleSource3;
  /** Rule lifecycle state: active or deprecated */
  state?: RuleState3;
  /** Short human-readable label */
  title?: string | null;
  /** Last update timestamp (UTC) */
  updated_at?: string | null;
};
export type CreateRuleRequest = {
  /** Rule document to create */
  rule: ComplianceRule3;
  /** User ID making this update */
  updated_by?: string | null;
};
export type ProviderRuleSearchResponse = {
  /** The original search query */
  query: string;
  /** Search results (mixed compliance and learning rules) */
  results?: {
    [key: string]: any;
  }[];
  /** Total number of results returned */
  total_results: number;
};
export type RuleFacets4 = {
  /** Applicable CPT codes */
  cpt?: string[];
  /** Applicable payers (e.g., Optum, Medicare) */
  payer?: string[];
  /** Applicable provider types (e.g., PMHNP) */
  provider_type?: string[];
};
export type RuleOwnerScope4 = "public" | "org" | "user";
export type RuleSource4 = {
  /** Date of source document (YYYY-MM-DD or string) */
  document_date?: string | null;
  /** Title of source document */
  document_title?: string | null;
  /** URI/URL to source document */
  source_uri?: string | null;
};
export type RuleState4 = "active" | "draft" | "deprecated";
export type ComplianceRuleRecord = {
  /** When true, rule bypasses LLM selection and is always included */
  always_select?: boolean;
  /** Canonical Markdown content: Rule, Applies when, What good looks like, Why it matters */
  body_md: string;
  /** Creation timestamp (UTC) */
  created_at: string;
  /** Current published version number */
  current_version?: number;
  /** Soft delete timestamp, null when active */
  deleted_at?: string | null;
  /** Vector embedding (may be null until generated) */
  embedding?: number[] | null;
  /** Sparse applicability filters: cpt, provider_type, payer */
  facets?: RuleFacets4;
  /** Owning organization UUID when not public */
  organization_id?: string | null;
  /** Scope of the rule: public, org, or user */
  owner_scope?: RuleOwnerScope4;
  /** Reference to parent rule when forked, for lineage tracking */
  parent_rule_id?: string | null;
  /** UUID of the rule record */
  rule_id: string;
  /** Compact one-liner for LLM rule selection (~100-150 chars) */
  selector_text: string;
  /** Source documentation: document_title, document_date, source_uri */
  source_info?: RuleSource4;
  /** Rule lifecycle state: active or deprecated */
  state?: RuleState4;
  /** Short human-readable label */
  title?: string | null;
  /** Last update timestamp (UTC) */
  updated_at: string;
  /** User ID for user-scoped rules */
  user_id?: string | null;
};
export type RuleSearchResult = {
  /** Preview snippet from the matching rule */
  content_preview?: string | null;
  /** Additional metadata about the match */
  metadata?: {
    [key: string]: any;
  };
  /** Matched rule record */
  record?: ComplianceRuleRecord | null;
  /** Optional relevance score from vector or text search */
  score?: number | null;
};
export type RuleSearchResponse = {
  /** The original search query */
  query: string;
  /** Search results */
  results?: RuleSearchResult[];
  /** Total number of results returned */
  total_results: number;
};
export type RuleOwnerScope5 = "public" | "org" | "user";
export type RuleSearchFilters = {
  /** Filter by CPT codes in facets (any match) */
  cpt?: string[] | null;
  /** Filter by organization ID */
  organization_id?: string | null;
  /** Filter by owner scope (public, org, user) */
  owner_scope?: RuleOwnerScope5 | null;
  /** Filter by payer in facets (any match) */
  payer?: string[] | null;
  /** DEPRECATED: Filter by legacy payer_type */
  payer_type?: string | null;
  /** Filter by provider type in facets (any match) */
  provider_type?: string[] | null;
  /** DEPRECATED: Filter by legacy rule_type */
  rule_type?: string | null;
  /** DEPRECATED: Filter by legacy tags */
  tags?: string[] | null;
  /** Plain-text search query for body_md or selector_text */
  text?: string | null;
  /** Filter by user ID (for user-scoped rules) */
  user_id?: string | null;
};
export type RuleSearchRequest = {
  /** Optional filters for organization, rule type, payer type, CPT codes */
  filters?: RuleSearchFilters | null;
  /** Search query text */
  query: string;
  /** Number of top results to return */
  top_k?: number;
};
export type RuleFacets5 = {
  /** Applicable CPT codes */
  cpt?: string[];
  /** Applicable payers (e.g., Optum, Medicare) */
  payer?: string[];
  /** Applicable provider types (e.g., PMHNP) */
  provider_type?: string[];
};
export type RuleOwnerScope6 = "public" | "org" | "user";
export type RuleSource5 = {
  /** Date of source document (YYYY-MM-DD or string) */
  document_date?: string | null;
  /** Title of source document */
  document_title?: string | null;
  /** URI/URL to source document */
  source_uri?: string | null;
};
export type RuleState5 = "active" | "draft" | "deprecated";
export type ComplianceRule4 = {
  /** When true, rule bypasses LLM selection and is always included */
  always_select?: boolean;
  /** Canonical Markdown content: Rule, Applies when, What good looks like, Why it matters */
  body_md: string;
  /** Sparse applicability filters: cpt, provider_type, payer */
  facets?: RuleFacets5;
  /** True if the rule has been soft-deleted (for historical data) */
  is_deleted?: boolean;
  /** True if the rule is disabled for the organization (not active) */
  is_disabled?: boolean;
  /** Owning organization UUID when not public */
  organization_id?: string | null;
  /** Scope of the rule: public, org, or user */
  owner_scope?: RuleOwnerScope6;
  /** Reference to parent rule when forked, for lineage tracking */
  parent_rule_id?: string | null;
  /** Unique stable identifier for the rule */
  rule_id: string;
  /** Compact one-liner for LLM rule selection (~100-150 chars) */
  selector_text: string;
  /** Source documentation: document_title, document_date, source_uri */
  source?: RuleSource5;
  /** Rule lifecycle state: active or deprecated */
  state?: RuleState5;
  /** Short human-readable label */
  title?: string | null;
  /** Last update timestamp (UTC) */
  updated_at?: string | null;
};
export type LearningRuleDocument5 = {
  /** Succinct explanation of why this matters clinically */
  clinical_rationale: string;
  /** Organization ID that owns this rule (can be 'global') */
  organization_id: string;
  /** Specific clinician-facing actions, reflections, or options to consider when this guidance applies */
  recommended_actions: string;
  /** Concise paragraph describing populations, diagnoses, modalities, symptoms, settings, and key phrases that signal when this learning rule matters */
  relevant_context: string;
  /** Unique stable identifier for the rule */
  rule_id: string;
  /** Formatted citation string if available */
  source_citation?: string | null;
  /** Publication year or full date as YYYY or YYYY-MM-DD if known */
  source_date?: string | null;
  /** Primary source title or identifier */
  source_document?: string | null;
  /** Clickable URL to the source (e.g., DOI link) or null */
  source_link?: string | null;
  /** 2-4 sentence, high-yield summary of the key takeaway for clinicians */
  teaching_summary: string;
  /** Human-readable title of the learning rule */
  title: string;
  /** Type of rule (always 'learning') */
  type?: string;
  /** ISO timestamp of last update */
  updated_at?: string | null;
  /** User ID who last updated this rule */
  updated_by?: string | null;
  /** Clinician-facing guidance for when this learning should be applied */
  when_to_follow: string;
};
export type ProviderRuleResponse2 = {
  /** Whether this rule is disabled for the requesting org/user */
  is_disabled?: boolean;
  /** Whether this is a global rule */
  is_global: boolean;
  /** Organization ID if not global */
  organization_id?: string | null;
  /** Rule document (compliance or learning) */
  rule: ComplianceRule4 | LearningRuleDocument5;
  /** Rule ID */
  rule_id: string;
  /** Type of rule: 'compliance' or 'learning' */
  rule_type: "compliance" | "learning";
};
export type RuleNotFoundResponse = {
  /** Error message */
  error: string;
  /** Organization ID */
  org_id: string;
  /** Rule ID */
  rule_id: string;
};
export type RuleFacets6 = {
  /** Applicable CPT codes */
  cpt?: string[];
  /** Applicable payers (e.g., Optum, Medicare) */
  payer?: string[];
  /** Applicable provider types (e.g., PMHNP) */
  provider_type?: string[];
};
export type RuleOwnerScope7 = "public" | "org" | "user";
export type RuleSource6 = {
  /** Date of source document (YYYY-MM-DD or string) */
  document_date?: string | null;
  /** Title of source document */
  document_title?: string | null;
  /** URI/URL to source document */
  source_uri?: string | null;
};
export type RuleState6 = "active" | "draft" | "deprecated";
export type ComplianceRule5 = {
  /** When true, rule bypasses LLM selection and is always included */
  always_select?: boolean;
  /** Canonical Markdown content: Rule, Applies when, What good looks like, Why it matters */
  body_md: string;
  /** Sparse applicability filters: cpt, provider_type, payer */
  facets?: RuleFacets6;
  /** True if the rule has been soft-deleted (for historical data) */
  is_deleted?: boolean;
  /** True if the rule is disabled for the organization (not active) */
  is_disabled?: boolean;
  /** Owning organization UUID when not public */
  organization_id?: string | null;
  /** Scope of the rule: public, org, or user */
  owner_scope?: RuleOwnerScope7;
  /** Reference to parent rule when forked, for lineage tracking */
  parent_rule_id?: string | null;
  /** Unique stable identifier for the rule */
  rule_id: string;
  /** Compact one-liner for LLM rule selection (~100-150 chars) */
  selector_text: string;
  /** Source documentation: document_title, document_date, source_uri */
  source?: RuleSource6;
  /** Rule lifecycle state: active or deprecated */
  state?: RuleState6;
  /** Short human-readable label */
  title?: string | null;
  /** Last update timestamp (UTC) */
  updated_at?: string | null;
};
export type UpdateRuleRequest = {
  /** Updated rule document */
  rule: ComplianceRule5;
  /** User ID making this update */
  updated_by?: string | null;
};
export type ProviderRuleDisableResponse = {
  /** Whether the rule is now disabled */
  disabled: boolean;
  /** ID of the rule */
  rule_id: string;
  /** Scope at which the rule was disabled/enabled */
  scope: string;
};
export type AdminRuleDisableRequest = {
  /** Organization ID to disable/enable for */
  organization_id: string;
  /** User ID to disable/enable for (optional) */
  user_id?: string | null;
};
export type ProviderRuleForkResponse = {
  /** ID of the newly created forked rule */
  new_rule_id: string;
  /** Organization ID of the forked rule */
  organization_id: string;
  /** Whether the source rule was disabled */
  source_disabled: boolean;
  /** ID of the source rule that was forked */
  source_rule_id: string;
  /** Scope of the forked rule (org or user) */
  target_scope: string;
};
export type AdminRuleForkRequest = {
  /** Whether to automatically disable the source rule for this org/user */
  auto_disable_source?: boolean;
  /** Target organization ID */
  organization_id: string;
  /** Target scope for the forked rule: 'org' or 'user' */
  target_scope?: "org" | "user";
  /** Target user ID for user scope */
  user_id?: string | null;
};
export type RuleType = "compliance" | "learning";
export type ProviderRuleUpdateResponse = {
  /** ID of the updated rule */
  rule_id: string;
  /** Type of rule updated */
  rule_type: RuleType;
  /** Timestamp of update */
  updated_at?: string | null;
};
export type AdminRuleRevertRequest = {
  /** Version number to revert to */
  version: number;
};
export type ProviderRuleRevisionResponse = {
  /** Markdown content at this version */
  body_md: string;
  /** When this revision was created */
  created_at: string;
  /** User who created this revision */
  created_by: string;
  /** Facets at this version */
  facets?: {
    [key: string]: any;
  } | null;
  /** Rule ID */
  rule_id: string;
  /** Selector text at this version */
  selector_text?: string | null;
  /** Source info at this version */
  source_info?: {
    [key: string]: any;
  } | null;
  /** Version number */
  version: number;
};
export type ProviderRuleRevisionsResponse = {
  /** List of revisions ordered by version descending */
  revisions?: ProviderRuleRevisionResponse[];
  /** Rule ID */
  rule_id: string;
  /** Total number of revisions */
  total: number;
};
export type AsyncTaskStatusResponse = {
  /** Task result data when completed */
  data?: {
    [key: string]: any;
  } | null;
  /** Task status (pending, completed, error) */
  status: string;
};
export type ExtractionPrompts6 = {
  keyword_prompt: string;
  semantic_prompt: string;
};
export type NoteTemplateSection6 = {
  content: string;
  example_output?: string | null;
  extraction_prompts?: ExtractionPrompts6 | null;
  id: string;
  legacy_module_id?: string | null;
  order?: number;
  title: string;
};
export type NoteTemplateRevision5 = {
  content: string;
  created_at: string;
  created_by: string;
  description?: string | null;
  draft?: boolean;
  metadata?: {
    [key: string]: any;
  };
  models?: string[] | null;
  prompt?: string | null;
  published_at?: string | null;
  sections?: NoteTemplateSection6[];
  template_id: string;
  title: string;
  updated_at: string;
  version: number;
};
export type NoteTemplateOwnerScope6 = "public" | "org" | "user";
export type NoteTemplate6 = {
  allow_user_forks?: boolean;
  created_at: string;
  current_version: number;
  deleted_at?: string | null;
  id: string;
  note_processing_version?: number;
  organization_id?: string | null;
  owner_scope: NoteTemplateOwnerScope6;
  parent_template_id?: string | null;
  sharable?: boolean;
  updated_at: string;
  user_id: string;
};
export type ConvertLegacyTemplateResponse = {
  revision: NoteTemplateRevision5;
  template: NoteTemplate6;
};
export type ConvertLegacyTemplateRequest = {
  /** Organization ID (required for user-scoped templates) */
  organization_id?: string | null;
  /** The legacy template ID (e.g., p:uuid for public, u:uuid for user) */
  template_id: string;
  /** User ID for the converted template */
  user_id: string;
};
export type TemplateErrorInfo = {
  /** The error message */
  error: string;
  /** The template name */
  name: string;
  /** The template ID that failed to copy */
  template_id: string;
};
export type CopiedTemplateInfo = {
  /** The template name */
  name: string;
  /** The newly created template ID */
  new_id: string;
  /** The original template ID */
  original_id: string;
};
export type CopyTemplatesResponse = {
  /** List of any errors encountered during copying */
  errors?: TemplateErrorInfo[];
  /** Number of public templates skipped */
  skipped_public?: number;
  /** List of successfully copied templates with their old and new IDs */
  templates?: CopiedTemplateInfo[];
  /** Number of user templates successfully copied */
  total_copied?: number;
};
export type CopyTemplatesRequest = {
  /** The ID of the user to copy templates from */
  source_user_id: string;
  /** The ID of the user to copy templates to */
  target_user_id: string;
};
export type SingleModuleGenerationResponse = {
  /** Task ID for the async generation */
  task_id: string;
};
export type SingleModuleGenerationRequest = {
  /** Async task ID for tracking */
  async_task_id: string;
  /** Note processing session ID */
  note_processing_session_id?: string | null;
  /** Processing module configuration */
  processing_module: {
    [key: string]: any;
  };
  /** Selected note ID */
  selected_note_id?: string | null;
};
export type UserTemplateInfo = {
  /** User ID of template creator */
  created_by: string;
  /** Creation timestamp */
  created_on?: number | null;
  /** Name of template creator */
  creator_name?: string | null;
  /** Display name if different from template name */
  display_name?: string | null;
  /** Last modification timestamp */
  modified_on?: number | null;
  /** Number of sections in template */
  sections_count?: number;
  /** Unique template ID */
  template_id: string;
  /** Template name */
  template_name: string;
};
export type UserTemplateListResponse = {
  /** List of user templates */
  templates?: UserTemplateInfo[];
  /** Total number of templates matching criteria */
  total_count?: number;
};
export type AdminAppointmentSummary4 = {
  appointment_id: string;
  duration?: number | null;
  encounter_type?: string | null;
  encounter_type_id?: string | null;
  start_time?: string | null;
  status?: string | null;
  telehealth?: boolean | null;
  title?: string | null;
};
export type AdminEncounterSummary4 = {
  appointment_id?: string | null;
  created_at?: string | null;
  encounter_id: string;
  encounter_type?: string | null;
  input_documents?: number | null;
  patient_id?: string | null;
  status?: string | null;
  updated_at?: string | null;
};
export type AdminNoteProcessingSessionSummary3 = {
  created_at?: string | null;
  note_id?: string | null;
  note_processing_session_id: string;
  status?: string | null;
  transcription_session_ids?: string[] | null;
};
export type AdminNoteSummary4 = {
  created_at?: string | null;
  encounter_type?: string | null;
  has_feedback?: boolean | null;
  note_id: string;
  patient_id?: string | null;
  patient_name?: string | null;
  status?: string | null;
  template?: string | null;
};
export type AdminProviderSummary5 = {
  email?: string | null;
  last_login_time?: string | null;
  name?: string | null;
  organization_id?: string | null;
  organization_name?: string | null;
  provider_id: string;
  role?: string | null;
};
export type AdminTranscriptionDetail = {
  appointment_id?: string | null;
  chunk_count?: number | null;
  created_at?: string | null;
  encounter_id?: string | null;
  end_time?: string | null;
  is_closed?: boolean | null;
  job_status?: string | null;
  notes_created?: number | null;
  provider_id?: string | null;
  start_time?: string | null;
  transcription_session_id: string;
  updated_at?: string | null;
};
export type AdminTranscriptionDetailResponse = {
  appointment?: AdminAppointmentSummary4 | null;
  encounter?: AdminEncounterSummary4 | null;
  note_processing_sessions: AdminNoteProcessingSessionSummary3[];
  notes: AdminNoteSummary4[];
  provider: AdminProviderSummary5;
  transcription: AdminTranscriptionDetail;
};
export type VoiceEnrollmentResetResponse = {
  /** Number of enrolled embeddings deleted from Supabase */
  enrolled_deleted: number;
  /** Whether the MongoDB asr_enrollment_status field was successfully removed */
  mongo_updated: boolean;
  /** Number of session embeddings deleted from Supabase */
  session_deleted: number;
};
export type VoiceEnrollmentStatusResponse = {
  /** Number of enrollment session data points associated with the user */
  data_point_count: number;
  /** ISO format datetime when the user was enrolled, or None if not enrolled */
  enrolled_at?: string | null;
  /** Whether the user has been enrolled for voice recognition */
  is_enrolled: boolean;
};
